import { Chart } from '@cxc/ui-kit/chart.js/models';

export const mockedChartsData = [
  {
    title: 'RELATED PARTIES CONCENTRATION',
    subtitle: '',
    type: 'bar',
    size: Chart.Size.medium,
    icon: undefined,
    data: {
      labels: ['No relacionado a PCH', 'Relacionado a PCH'],
      datasets: [
        {
          label: 'No relacionado a PCH',
          data: [90386458.78, 0],
          tooltip: {
            muted: ['90.5%'],
          },
          grouped: false,
          backgroundColor: '#330022',
          borderRadius: 8,
        },
        {
          label: 'Relacionado a PCH',
          data: [0, 9531530.27],
          tooltip: {
            muted: ['9.5%'],
          },
          grouped: false,
          backgroundColor: '#F609A7',
          borderRadius: 8,
        },
      ],
    },
    options: {
      scales: {
        y: {
          axis: 'y',
          title: {
            text: 'Net loan Value',
            display: true,
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          display: true,
          stacked: false,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            color: ['#3f3f46'],
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
          },
          type: 'linear',
          beginAtZero: true,
          offset: false,
          reverse: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'y',
          position: 'left',
        },
        x: {
          axis: 'x',
          display: true,
          stacked: false,
          grid: {
            display: true,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            maxRotation: 0,
            minRotation: 0,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          type: 'category',
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'x',
          position: 'bottom',
        },
        percentage: {
          axis: 'x',
          display: false,
          type: 'linear',
          position: 'top',
          max: 100,
          ticks: {
            maxTicksLimit: 3,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          grid: {
            display: false,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          id: 'percentage',
        },
      },
      indexAxis: 'x',
      responsive: true,
      elements: {
        point: {
          backgroundColor: 'white',
        },
      },
      plugins: {
        legendCustom: {
          containerID: 'legendCustom-3',
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          padding: 0,
          hideZeros: false,
        },
      },
      maintainAspectRatio: false,
    },
  },
  {
    title: 'CONCENTRATION PER CLIENT',
    subtitle: 'The concentration of the top 10 clients is presented below.',
    type: 'bar',
    size: 'large',
    icon: null,
    data: {
      labels: [
        'FD SERVICIOS INTEGRALES DE IMPRESIÓN SA DE CV',
        'GRUPO LOGÃSTICO INTEGRAL SAPI DE CV',
        'COSMOCOLOR SA DE CV',
        'PRODUCTOS DESHIDRATADOS ARRAN SA DE CV .',
        'METALURGICA LAZCANO SA DE CV .',
        'SISTEMAS DE ECOLOGIA SOLAR S DE RL DE CV',
        'CAPA CONCRETOS Y CONSTRUCCIONES SA DE CV',
        'ETIMASTER SA DE CV',
        'OPTIMAL BRIGHTNESS SOLUTIONS S DE RL DE CV',
        'SMART CENTER S.A. DE C.V.',
      ],
      datasets: [
        {
          label: 'FD SERVICIOS INTEGRALES DE IMPRESIÓN SA DE CV',
          data: [10402923.82, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['10.41%'],
          },
          grouped: false,
          backgroundColor: '#330022',
          borderRadius: 8,
        },
        {
          label: 'GRUPO LOGÃSTICO INTEGRAL SAPI DE CV',
          data: [0, 10000000, 0, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['10.01%'],
          },
          grouped: false,
          backgroundColor: '#5B003D',
          borderRadius: 8,
        },
        {
          label: 'COSMOCOLOR SA DE CV',
          data: [0, 0, 9700436.04, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['9.71%'],
          },
          grouped: false,
          backgroundColor: '#830258',
          borderRadius: 8,
        },
        {
          label: 'PRODUCTOS DESHIDRATADOS ARRAN SA DE CV .',
          data: [0, 0, 0, 6922845.39, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['6.93%'],
          },
          grouped: false,
          backgroundColor: '#AA0372',
          borderRadius: 8,
        },
        {
          label: 'METALURGICA LAZCANO SA DE CV .',
          data: [0, 0, 0, 0, 6887338.34, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['6.89%'],
          },
          grouped: false,
          backgroundColor: '#D1058D',
          borderRadius: 8,
        },
        {
          label: 'SISTEMAS DE ECOLOGIA SOLAR S DE RL DE CV',
          data: [0, 0, 0, 0, 0, 6471973.7, 0, 0, 0, 0],
          tooltip: {
            muted: ['6.48%'],
          },
          grouped: false,
          backgroundColor: '#F609A7',
          borderRadius: 8,
        },
        {
          label: 'CAPA CONCRETOS Y CONSTRUCCIONES SA DE CV',
          data: [0, 0, 0, 0, 0, 0, 6289766.41, 0, 0, 0],
          tooltip: {
            muted: ['6.29%'],
          },
          grouped: false,
          backgroundColor: '#F736B7',
          borderRadius: 8,
        },
        {
          label: 'ETIMASTER SA DE CV',
          data: [0, 0, 0, 0, 0, 0, 0, 6255836.92, 0, 0],
          tooltip: {
            muted: ['6.26%'],
          },
          grouped: false,
          backgroundColor: '#F75EC4',
          borderRadius: 8,
        },
        {
          label: 'OPTIMAL BRIGHTNESS SOLUTIONS S DE RL DE CV',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 5231041.55, 0],
          tooltip: {
            muted: ['5.24%'],
          },
          grouped: false,
          backgroundColor: '#F986D2',
          borderRadius: 8,
        },
        {
          label: 'SMART CENTER S.A. DE C.V.',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 4757857.6],
          tooltip: {
            muted: ['4.76%'],
          },
          grouped: false,
          backgroundColor: '#FAAEE0',
          borderRadius: 8,
        },
      ],
    },
    options: {
      scales: {
        y: {
          axis: 'y',
          title: {
            text: 'Net loan Value',
            display: true,
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          display: true,
          stacked: false,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            color: ['#3f3f46'],
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
          },
          type: 'linear',
          beginAtZero: true,
          offset: false,
          reverse: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'y',
          position: 'left',
        },
        x: {
          axis: 'x',
          display: true,
          stacked: false,
          grid: {
            display: true,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            maxRotation: 0,
            minRotation: 0,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          type: 'category',
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'x',
          position: 'bottom',
        },
        percentage: {
          axis: 'x',
          display: false,
          type: 'linear',
          position: 'top',
          max: 100,
          ticks: {
            maxTicksLimit: 3,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          grid: {
            display: false,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          id: 'percentage',
        },
      },
      indexAxis: 'x',
      responsive: true,
      elements: {
        point: {
          backgroundColor: 'white',
        },
      },
      plugins: {
        legendCustom: {
          containerID: 'legendCustom-4',
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          padding: 0,
          hideZeros: false,
        },
      },
      maintainAspectRatio: false,
    },
  },
  {
    title: 'CONCENTRATION PER STATE',
    subtitle: '',
    type: 'choropleth',
    size: 'large',
    icon: null,
    data: {
      labels: [
        'USA',
        'South of Mexico nations',
        'Sonora',
        'Baja California',
        'Chihuahua',
        'Coahuila',
        'Tamaulipas',
        'Nuevo León',
        'Quintana Roo',
        'Campeche',
        'Tabasco',
        'Chiapas',
        'Colima',
        'Nayarit',
        'Baja California Sur',
        'Sinaloa',
        'Yucatán',
        'Veracruz',
        'Jalisco',
        'Michoacán',
        'Guerrero',
        'Oaxaca',
        'Estado de México',
        'Puebla',
        'Morelos',
        'Querétaro',
        'Hidalgo',
        'Guanajuato',
        'San Luis Potosí',
        'Zacatecas',
        'Aguascalientes',
        'Durango',
        'Tlaxcala',
        'Ciudad de México',
      ],
      datasets: [
        {
          label: 'Mexico',
          outline: {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: '',
                  iso_a2: '',
                  name: 'USA',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-122.7518945641238, 48.992172651963884],
                      [-121.33382397780805, 48.992172651963884],
                      [-119.35542154887514, 48.992172651963884],
                      [-117.15719662783857, 48.992172651963884],
                      [-115.61843918311298, 48.992172651963884],
                      [-113.64003675418007, 48.992172651963884],
                      [-112.32110180155813, 48.992172651963884],
                      [-110.56252186472888, 48.992172651963884],
                      [-109.24358691210693, 48.992172651963884],
                      [-107.26518448317402, 48.992172651963884],
                      [-105.05833907225104, 48.992172651963884],
                      [-103.52820211741187, 48.992172651963884],
                      [-101.98944467268626, 48.992172651963884],
                      [-99.79121975164969, 48.992172651963884],
                      [-98.03263981482044, 48.992172651963884],
                      [-96.27405987799119, 48.992172651963884],
                      [-95.1792576624161, 48.992172651963884],
                      [-95.16201668264327, 49.3694941210001],
                      [-94.82581757707297, 49.29402982719286],
                      [-94.70944096360634, 48.91327816298359],
                      [-94.59306435013968, 48.728047623638545],
                      [-94.23100377491014, 48.6525833298313],
                      [-93.8732534446238, 48.63543235396601],
                      [-93.75687683115716, 48.51537552290904],
                      [-93.4896416446782, 48.54281708429349],
                      [-93.25688841774492, 48.63200215879296],
                      [-92.98103274137954, 48.61828137810073],
                      [-92.64914388075245, 48.535956693947384],
                      [-92.30432428529573, 48.30956381252565],
                      [-92.04139934375999, 48.33357517873705],
                      [-91.95519444489581, 48.227239128372304],
                      [-91.69226950336005, 48.09689171179616],
                      [-91.42934456182431, 48.03514819868114],
                      [-90.92504590346887, 48.227239128372304],
                      [-90.78711806528618, 48.100321906969214],
                      [-90.17937352829372, 48.11747288283449],
                      [-89.98110226090611, 48.011136832469745],
                      [-89.58024948118768, 47.99741605177752],
                      [-90.08454813954313, 47.812185512432464],
                      [-90.53281361363685, 47.71270985241384],
                      [-91.01125080233305, 47.493177361338226],
                      [-91.51123921574529, 47.12271628264813],
                      [-92.0974325280217, 46.803708131553876],
                      [-91.96381493478222, 46.69051169084301],
                      [-91.4164138269947, 46.7934175460347],
                      [-90.96814835290095, 46.951206523995296],
                      [-90.73108488102446, 46.683651300496905],
                      [-90.43367797994304, 46.577315250132145],
                      [-90.05868666988387, 46.68022110532384],
                      [-89.79576172834811, 46.831149692938325],
                      [-89.39921919357289, 46.865451644668894],
                      [-89.13198400709393, 47.00608964676421],
                      [-88.968194699252, 47.019810427456434],
                      [-88.68371853300022, 47.22905233301287],
                      [-88.5371702049311, 47.12614647782118],
                      [-88.3863116319188, 46.85516105914972],
                      [-88.23545305890647, 46.94434613364919],
                      [-87.79580807469917, 46.89975359639945],
                      [-87.59753680731156, 46.765975984650254],
                      [-87.34754260060544, 46.515571737017126],
                      [-86.96824104560304, 46.53958310322852],
                      [-86.62342145014634, 46.44353763838295],
                      [-86.48980385690686, 46.55330388392075],
                      [-85.86050809519834, 46.70766266670829],
                      [-85.51999874468484, 46.683651300496905],
                      [-85.20104061888738, 46.776266570169426],
                      [-85.01138984138618, 46.72481364257358],
                      [-85.05449229081827, 46.53272271288242],
                      [-84.83466979871461, 46.46068861424823],
                      [-84.4898502032579, 46.457258419075174],
                      [-84.1105486482555, 46.5258623225363],
                      [-84.10623840331229, 46.34749217353736],
                      [-84.2010637920629, 46.25144670869179],
                      [-84.02865399433455, 46.148540853500094],
                      [-84.02434374939133, 45.96331031415504],
                      [-84.65794975604305, 46.05592558382757],
                      [-84.8260493088282, 45.88098563000169],
                      [-85.0200103312726, 46.02505382727006],
                      [-85.33896845707005, 46.11080870659647],
                      [-85.54586021434409, 46.09708792590425],
                      [-85.66223682781073, 45.98389148519338],
                      [-86.25274038503036, 45.95301972863588],
                      [-86.3734272434402, 45.805521336194445],
                      [-86.52428581645253, 45.76092879894472],
                      [-86.73979806361297, 45.867264849309464],
                      [-86.85617467707962, 45.7300570423872],
                      [-87.17513280287707, 45.6683135292722],
                      [-87.55874460282267, 45.19151640021734],
                      [-87.63632901180043, 45.006285860872296],
                      [-87.82166954435843, 44.94797254293033],
                      [-88.03287154657565, 44.56722087872107],
                      [-87.76563636009669, 44.65640595322054],
                      [-87.66219048145969, 44.814194931181135],
                      [-87.45098847924245, 44.886229029815325],
                      [-87.32599137588939, 44.80390434566196],
                      [-87.48547043878813, 44.5260585366444],
                      [-87.55012411293626, 44.31338643591489],
                      [-87.49409092867454, 44.22077116624237],
                      [-87.72253391066462, 43.92577438135952],
                      [-87.70098268594856, 43.70967208545696],
                      [-87.9078744432226, 43.26717690813268],
                      [-87.89494370839297, 43.04078402671095],
                      [-87.78287733986954, 42.81096095011617],
                      [-87.82166954435843, 42.279280698292425],
                      [-87.68805195111895, 42.0837595734282],
                      [-87.57598558259551, 41.78876278854535],
                      [-87.38633480509432, 41.64126439610392],
                      [-87.20099427253632, 41.63440400575781],
                      [-86.8001414928179, 41.77847220302618],
                      [-86.65790340969201, 41.87451766787176],
                      [-86.37773748838342, 42.25526933208103],
                      [-86.21825842548469, 42.708055094924475],
                      [-86.2225686704279, 42.96531973290371],
                      [-86.54152679622536, 43.62734740130361],
                      [-86.44239116253155, 43.7851363792642],
                      [-86.51997557150932, 44.08356335932011],
                      [-86.26567111985999, 44.37512994902991],
                      [-86.26998136480319, 44.687277709778044],
                      [-86.10188181201804, 44.74559102772001],
                      [-86.05877936258597, 44.92396117671895],
                      [-85.84757736036872, 44.94797254293033],
                      [-85.76137246150454, 45.061168983641195],
                      [-85.58034217388976, 45.061168983641195],
                      [-85.33465821212685, 45.315003426447376],
                      [-85.0200103312726, 45.438490452677414],
                      [-85.08035376047752, 45.630581382368575],
                      [-84.77432636950968, 45.79866094584834],
                      [-84.45967848865544, 45.67174372444525],
                      [-84.22261501677895, 45.64087196788773],
                      [-84.09761791342588, 45.503664160965485],
                      [-83.51142460114946, 45.3595959636971],
                      [-83.30453284387544, 45.095470935371765],
                      [-83.45970166183096, 44.99942547052618],
                      [-83.3433250483643, 44.89308942016143],
                      [-83.2872918641026, 44.70442868564332],
                      [-83.35194553825073, 44.33053741178017],
                      [-83.5329758258655, 44.2653637034921],
                      [-83.59331925507044, 44.06298218828178],
                      [-83.82176223706051, 44.00466887033981],
                      [-83.92520811569753, 43.881181844109776],
                      [-83.90365689098148, 43.68223052407251],
                      [-83.67952415393461, 43.606766230265265],
                      [-83.26574063938655, 43.977227308955364],
                      [-82.92523128887305, 44.069842578627885],
                      [-82.68816781699655, 43.922344186186464],
                      [-82.63644487767804, 43.81257794064865],
                      [-82.52437850915462, 43.27746749365184],
                      [-82.41662238557439, 43.016772660499555],
                      [-82.51144777432498, 42.64631158180946],
                      [-82.64506536756446, 42.55712650730999],
                      [-82.86488785966812, 42.55712650730999],
                      [-82.89074932932738, 42.40276772452245],
                      [-83.1450537809767, 42.23125796586963],
                      [-83.22263818995447, 41.994574498928735],
                      [-83.42090945734208, 41.809343959583686],
                      [-83.09764108660141, 41.620683225065584],
                      [-82.92523128887305, 41.43202249054748],
                      [-82.614893652962, 41.45603385675887],
                      [-82.50282728443857, 41.39429034364386],
                      [-82.0416310755152, 41.51091697952778],
                      [-81.67095001039924, 41.52120756504695],
                      [-81.34768163965856, 41.73044947060339],
                      [-80.86924445096237, 41.8950988389101],
                      [-80.37787652743654, 42.02201606031319],
                      [-79.47272508936267, 42.40619791969551],
                      [-79.14945671862199, 42.581137873521385],
                      [-78.86929079731343, 42.84526290184674],
                      [-78.91670349168871, 43.07508597844152],
                      [-79.06325181975782, 43.10595773499902],
                      [-79.05894157481461, 43.27746749365184],
                      [-78.68826050969864, 43.359792177805204],
                      [-78.10637744236543, 43.39409412953576],
                      [-77.74862711207908, 43.34607139711298],
                      [-77.53742510986186, 43.25688632261351],
                      [-77.3650153121335, 43.298048664690185],
                      [-76.9814035121879, 43.28432788399796],
                      [-76.71416832570894, 43.33921100676686],
                      [-76.42107166957072, 43.534732131631074],
                      [-76.24435162689916, 43.53816232680414],
                      [-76.1667672179214, 43.668509743380284],
                      [-76.27883358644483, 43.88461203928284],
                      [-76.13228525837573, 44.04583121241649],
                      [-76.35641799542259, 44.1315860917429],
                      [-76.05470084939796, 44.2653637034921],
                      [-75.79177590786222, 44.49518678008688],
                      [-75.27023626973394, 44.86221766360393],
                      [-74.86938349001551, 45.00971605604535],
                      [-74.71421467205998, 44.99942547052618],
                      [-73.39958996438125, 45.002855665699244],
                      [-71.50308218936931, 45.013146251218416],
                      [-71.39532606578908, 45.242969327813185],
                      [-71.14102161413976, 45.25325991333236],
                      [-70.83499422317192, 45.39389791542767],
                      [-70.68844589510282, 45.57226806442661],
                      [-70.40827997379424, 45.7300570423872],
                      [-70.26173164572512, 45.92214797207836],
                      [-70.31345458504364, 46.07307655969285],
                      [-70.18845748169058, 46.35778275905653],
                      [-70.07639111316715, 46.41952627217155],
                      [-70.0074271940758, 46.704232471535235],
                      [-69.26606506384385, 47.43829423856931],
                      [-69.06779379645624, 47.43143384822321],
                      [-69.041932326797, 47.24963350405122],
                      [-68.90831473355752, 47.19132018610925],
                      [-68.53763366844154, 47.301086431647065],
                      [-68.19712431792803, 47.34224877372374],
                      [-67.96437109099475, 47.19818057645537],
                      [-67.80489202809602, 47.03696140332171],
                      [-67.77472031349356, 45.82953270240584],
                      [-67.80058178315281, 45.6991852858297],
                      [-67.4514519427529, 45.61000021133023],
                      [-67.47300316746893, 45.28070147471681],
                      [-67.35662655400229, 45.167505034005956],
                      [-67.17559626638752, 45.177795619525114],
                      [-66.9773249989999, 44.814194931181135],
                      [-67.22300896076283, 44.64268517252832],
                      [-67.57644904610595, 44.55350009802885],
                      [-67.80489202809602, 44.57408126906718],
                      [-67.89971741684661, 44.423152681452706],
                      [-68.09798868423422, 44.385420534549084],
                      [-68.27039848196259, 44.48489619456771],
                      [-68.7574561605452, 44.33396760695324],
                      [-68.82642007963655, 44.478035804221605],
                      [-68.98589914253529, 44.41972248627964],
                      [-69.11951673577477, 44.042401017243435],
                      [-69.26175481890066, 43.92920457653257],
                      [-69.64967686378947, 43.89833281997507],
                      [-69.78760470197214, 43.73711364684141],
                      [-69.98587596935975, 43.8640308682445],
                      [-70.24018042100909, 43.699381499937786],
                      [-70.20569846146341, 43.56217369301554],
                      [-70.35655703447573, 43.52787174128497],
                      [-70.38241850413499, 43.39409412953576],
                      [-70.52034634231767, 43.33921100676686],
                      [-70.81344299845588, 42.869274268058135],
                      [-70.86085569283117, 42.54683592179082],
                      [-71.03757573550274, 42.306722259676874],
                      [-70.78327128385342, 42.25869952725408],
                      [-70.6324127108411, 42.09405015894737],
                      [-70.53327707714729, 41.816204349929805],
                      [-70.27466238055476, 41.716728689911164],
                      [-70.07208086822394, 41.77504200785312],
                      [-69.93846327498446, 41.67556634783449],
                      [-70.42983119851027, 41.63097381058475],
                      [-70.65827418050036, 41.52120756504695],
                      [-70.65827418050036, 41.72358908025728],
                      [-71.18412406357184, 41.4697546374511],
                      [-71.20567528828789, 41.64469459127697],
                      [-71.3565338613002, 41.74760044646867],
                      [-71.4987719444261, 41.36684878225941],
                      [-71.89962472414453, 41.346267611221066],
                      [-72.28754676903334, 41.28452409810605],
                      [-72.77891469255917, 41.27080331741382],
                      [-73.17114698239118, 41.16789746222213],
                      [-73.63665343625775, 41.00667828908848],
                      [-73.82199396881572, 40.83859872560871],
                      [-74.28319017773909, 40.49900940347612],
                      [-74.03319597103297, 40.42011491449583],
                      [-73.97285254182805, 40.327499644823305],
                      [-74.16681356427245, 39.699773928153974],
                      [-74.36077458671684, 39.548845340539486],
                      [-74.74438638666246, 39.054897235619364],
                      [-75.02455230797102, 39.209256018406904],
                      [-75.1581699012105, 39.19896543288773],
                      [-75.36075141354132, 39.33617323980999],
                      [-75.395233373087, 39.054897235619364],
                      [-75.16679039109692, 38.79420240246707],
                      [-75.0590342675167, 38.55408874035312],
                      [-75.15385965626729, 38.24194097960498],
                      [-75.43402557757588, 37.96066497541435],
                      [-75.4943690067808, 37.8303175588382],
                      [-75.88660129661281, 37.35695062495642],
                      [-75.92108325615848, 37.61078506776259],
                      [-75.70988125394125, 37.83374775401126],
                      [-75.81332713257827, 38.13560492924023],
                      [-76.22280040218311, 38.34484683479668],
                      [-76.3176257909337, 38.47519425137282],
                      [-76.14521599320535, 38.66385498589092],
                      [-76.33917701564977, 38.72902869417899],
                      [-76.15383648309177, 38.893678062485705],
                      [-76.13228525837573, 39.116640748734376],
                      [-76.27452334150163, 39.15094270046494],
                      [-76.17538770780783, 39.31559206877165],
                      [-76.42538191451393, 39.32245245911776],
                      [-76.39952044485469, 39.01373489354268],
                      [-76.55037901786699, 38.77705142660179],
                      [-76.51158681337812, 38.526647178968666],
                      [-76.32193603587692, 38.13903512441329],
                      [-76.61503269201513, 38.149325709932455],
                      [-76.52882779315095, 38.025838683702425],
                      [-76.24866187184237, 37.902351657472394],
                      [-76.35641799542259, 37.52159999326312],
                      [-76.24435162689916, 37.44956589462895],
                      [-76.37796922013864, 37.27119574563001],
                      [-76.27021309655842, 36.96247818005493],
                      [-75.99004717524983, 36.91102525245908],
                      [-75.92970374604491, 36.7052135420757],
                      [-75.91677301121528, 36.40335636684672],
                      [-75.86073982695356, 36.163242704732774],
                      [-76.02021888985229, 36.19068426611723],
                      [-76.19693893252386, 36.104929386790815],
                      [-76.41245117968431, 36.08434821575248],
                      [-76.38658971002505, 35.93684982331105],
                      [-76.19693893252386, 35.99516314125301],
                      [-75.85211933706714, 35.981442360560784],
                      [-75.72281198877087, 35.830513772946304],
                      [-75.75298370337333, 35.610981281870686],
                      [-75.89522178649923, 35.580109525313176],
                      [-76.14952623814857, 35.34685625354534],
                      [-76.44262289428677, 35.4051695714873],
                      [-76.55899950775341, 35.123893567296676],
                      [-76.55037901786699, 35.00040654106664],
                      [-76.33486677070655, 34.900930881048],
                      [-76.5029663234917, 34.7671532692988],
                      [-76.65813514144722, 34.72256073204907],
                      [-76.89519861332371, 34.73971170791435],
                      [-77.20122600429156, 34.650526633414884],
                      [-77.53742510986186, 34.468726289242895],
                      [-77.83052176600006, 34.208031456090595],
                      [-77.91241641992103, 33.95762720845748],
                      [-78.03310327833088, 33.89245350016941],
                      [-78.25292577043453, 33.92675545189997],
                      [-78.55895316140237, 33.86844213395801],
                      [-78.93825471640476, 33.64204925253628],
                      [-79.13221573884917, 33.41908656628762],
                      [-79.20117965794051, 33.19269368486589],
                      [-79.38652019049849, 33.01775373104002],
                      [-79.5847914578861, 33.01432353586696],
                      [-79.60634268260215, 32.914847875848324],
                      [-80.00719546232058, 32.61299070061935],
                      [-80.40804824203902, 32.482643284043206],
                      [-80.44253020158469, 32.36601664815929],
                      [-80.8864854307352, 32.07101986327643],
                      [-80.83476249141671, 32.00241595981531],
                      [-81.05889522846357, 31.789743859085803],
                      [-81.19682306664626, 31.71770976045162],
                      [-81.36492261943141, 31.415852585222652],
                      [-81.2700972306808, 31.275214583127337],
                      [-81.49854021267089, 30.966497017552257],
                      [-81.49854021267089, 30.705802184399968],
                      [-81.25716649585118, 29.789940073193897],
                      [-81.17958208687341, 29.58412836281051],
                      [-80.92096739028088, 29.06959908685204],
                      [-80.61062975436982, 28.609952933662477],
                      [-80.76579857232537, 28.613383128835533],
                      [-80.7399371026661, 28.373269466721585],
                      [-80.38218677237975, 27.666649261071957],
                      [-80.34339456789088, 27.515720673457473],
                      [-80.07615938141193, 26.973749836114553],
                      [-80.03736717692304, 26.8125306629809],
                      [-80.12788232073044, 25.886377966255658],
                      [-80.30891260834521, 25.618822742757256],
                      [-80.31322285328841, 25.371848690297192],
                      [-80.42528922181185, 25.220920102682708],
                      [-80.58045803976736, 25.24150127372105],
                      [-80.70976538806364, 25.145455808875468],
                      [-80.85631371613275, 25.186618150952143],
                      [-81.08475669812282, 25.12144444266407],
                      [-81.17527184193021, 25.22778049302882],
                      [-81.14941037227095, 25.39586005650859],
                      [-81.32182016999931, 25.783472111063965],
                      [-81.66232952051283, 25.98242343110124],
                      [-81.8002573586955, 26.099050066985157],
                      [-81.85629054295723, 26.44892997463692],
                      [-82.037320830572, 26.527824463617215],
                      [-82.08042328000408, 26.6787530512317],
                      [-82.31317650693737, 26.85026280988452],
                      [-82.5631707136435, 27.27560701134352],
                      [-82.6623063473373, 27.51915086863053],
                      [-82.39938140580155, 27.7969966776481],
                      [-82.59765267318917, 27.98222721699315],
                      [-82.63644487767804, 27.70095121280252],
                      [-82.84333663495207, 27.82786843420561],
                      [-82.76575222597431, 28.10571424322318],
                      [-82.78730345069036, 28.194899317722648],
                      [-82.6623063473373, 28.448733760528825],
                      [-82.64506536756446, 28.901519523372276],
                      [-82.84764687989528, 29.182795527562906],
                      [-83.02436692256686, 29.175935137216793],
                      [-83.21401770006804, 29.40918840898463],
                      [-83.40366847756924, 29.532675435214664],
                      [-83.40797872251244, 29.666453046963863],
                      [-83.52866558092231, 29.714475779386653],
                      [-83.67952415393461, 29.92028748977004],
                      [-84.02434374939133, 30.10551802911509],
                      [-84.27002771115424, 30.091797248422864],
                      [-84.50709118303072, 29.923717684943096],
                      [-84.88639273803312, 29.731626755251938],
                      [-85.30879674246759, 29.693894608348316],
                      [-85.3562094368429, 29.889415733212534],
                      [-85.67085731769714, 30.12266900498037],
                      [-85.70964952218603, 30.246156031210404],
                      [-85.86481834014155, 30.215284274652895],
                      [-86.3648067535538, 30.379933642959603],
                      [-86.48549361196365, 30.47940930297824],
                      [-86.67945463440805, 30.42109598503628],
                      [-87.15789182310425, 30.475979107805184],
                      [-87.3303016208326, 30.318190129844588],
                      [-87.78718758481276, 30.235865445691235],
                      [-87.91649493310902, 30.424526180209337],
                      [-87.94235640276827, 30.661209647150233],
                      [-88.05442277129171, 30.65434925680412],
                      [-88.11907644543984, 30.33877130088293],
                      [-88.35613991731633, 30.403945009171],
                      [-88.47251653078297, 30.3250505201907],
                      [-88.74406196220514, 30.352492081575154],
                      [-88.92940249476312, 30.441677156074622],
                      [-89.0112971486841, 30.376503447786547],
                      [-89.33025527448154, 30.304469349152363],
                      [-89.44232164300499, 30.1912729084415],
                      [-89.70955682948394, 30.174121932576217],
                      [-89.96817152607647, 30.263307007075685],
                      [-90.05868666988387, 30.359352471921266],
                      [-90.22247597772581, 30.38679403330572],
                      [-90.40350626534058, 30.21871446982595],
                      [-90.33885259119245, 30.06435568703841],
                      [-90.03713544516782, 30.040344320827018],
                      [-89.88196662721231, 30.15354076153788],
                      [-89.83886417778021, 29.995751783577283],
                      [-89.6880056047679, 29.88255534286642],
                      [-89.42939090817535, 30.0574952966923],
                      [-89.45525237783461, 29.827672220097515],
                      [-89.66645438005185, 29.52238484969549],
                      [-89.34318600931118, 29.347444895869614],
                      [-89.20094792618528, 29.354305286215727],
                      [-89.02422788351372, 29.14849357583234],
                      [-89.18801719135566, 29.031866939948422],
                      [-89.38197821380007, 29.086750062717325],
                      [-89.48111384749387, 29.24453904067792],
                      [-89.75696952385924, 29.344014700696558],
                      [-89.90782809687155, 29.47779231244576],
                      [-90.03713544516782, 29.364595871734895],
                      [-90.08023789459992, 29.175935137216793],
                      [-90.25264769232828, 29.247969235850977],
                      [-90.56298532823931, 29.299422163446824],
                      [-90.70522341136521, 29.121052014447887],
                      [-91.22676304949348, 29.23767865033181],
                      [-91.21814255960707, 29.405758213811573],
                      [-91.32158843824409, 29.494943288311042],
                      [-91.53279044046133, 29.532675435214664],
                      [-91.68364901347366, 29.752207926290275],
                      [-91.87761003591805, 29.759068316636387],
                      [-91.98536615949827, 29.831102415270575],
                      [-92.13622473251058, 29.75563812146333],
                      [-92.10605301790812, 29.62186050971413],
                      [-92.27846281563649, 29.532675435214664],
                      [-92.68362584029812, 29.604709533848848],
                      [-93.2008552334832, 29.772789097328612],
                      [-93.73963585138432, 29.73848714559805],
                      [-93.85601246485096, 29.985461198058115],
                      [-93.93359687382872, 29.77621929250167],
                      [-94.05859397718177, 29.68017382765609],
                      [-94.65340777934462, 29.450350751061308],
                      [-94.87754051639148, 29.666453046963863],
                      [-95.02408884446058, 29.542966020733832],
                      [-94.8904712512211, 29.374886457254064],
                      [-95.15770643770006, 29.151923771005396],
                      [-95.15770643770006, 29.045587720640647],
                      [-95.60166166685059, 28.764311716450017],
                      [-95.81717391401104, 28.73343995989251],
                      [-96.20509595889985, 28.585941567451084],
                      [-96.55853604424297, 28.65454547091221],
                      [-96.58008726895902, 28.57908117710497],
                      [-96.40336722628746, 28.4350129798366],
                      [-96.65336143299356, 28.318386343952678],
                      [-97.02404249810954, 28.040540534935108],
                      [-97.18352156100828, 27.838159019724777],
                      [-97.42058503288476, 27.327059938939367],
                      [-97.51972066657856, 27.231014474093787],
                      [-97.44644650254402, 27.13153881407515],
                      [-97.54989238118104, 27.008051787845115],
                      [-97.35162111379343, 26.352884509791338],
                      [-97.30851866436133, 26.123061433196554],
                      [-97.14041911157618, 25.965272455235958],
                      [-97.42489527782797, 25.85550620969815],
                      [-97.6791997294773, 26.033876358697086],
                      [-98.22229059232163, 26.075038700773764],
                      [-98.36883892039074, 26.195095531830738],
                      [-98.6403843518129, 26.243118264253532],
                      [-98.79555316976843, 26.366605290483562],
                      [-99.08433958096342, 26.407767632560237],
                      [-99.1662342348844, 26.54154524430944],
                      [-99.24812888880537, 26.826251443673126],
                      [-99.46364113596582, 27.056074520267906],
                      [-99.43346942136336, 27.20700310788239],
                      [-99.49812309551149, 27.337350524458536],
                      [-99.5067435853979, 27.574033991399432],
                      [-99.70070460784231, 27.65978887072584],
                      [-99.86449391568425, 27.803857067994212],
                      [-99.87742465051387, 27.90333272801285],
                      [-100.07569591790148, 28.15373697564597],
                      [-100.2825876751755, 28.29780517291434],
                      [-100.39896428864216, 28.592801957797196],
                      [-100.62309702568902, 28.925530889583673],
                      [-100.67050972006432, 29.11762181927483],
                      [-100.81705804813342, 29.27198060206237],
                      [-101.16187764359015, 29.501803678657154],
                      [-101.40756160535305, 29.7659287069825],
                      [-101.97220369291342, 29.817381634578346],
                      [-102.11013153109612, 29.80366085388612],
                      [-102.30409255354051, 29.889415733212534],
                      [-102.40753843217753, 29.77621929250167],
                      [-102.6833941085429, 29.745347535944163],
                      [-102.88166537593051, 29.344014700696558],
                      [-103.14890056240947, 28.98384420752563],
                      [-103.29975913542178, 29.000995183390913],
                      [-103.67475044548097, 29.172504942043734],
                      [-103.79543730389082, 29.278840992408487],
                      [-104.05836224542657, 29.340584505523502],
                      [-104.26525400270059, 29.525815044868548],
                      [-104.53248918917954, 29.666453046963863],
                      [-104.67903751724864, 29.94086866080838],
                      [-104.68334776219186, 30.1912729084415],
                      [-105.00661613293252, 30.678360623015514],
                      [-105.36436646321887, 30.84987038166834],
                      [-105.59280944520894, 31.072833067917006],
                      [-105.76952948788052, 31.179169118281756],
                      [-106.006592959757, 31.395271414184315],
                      [-106.16607202265574, 31.44672434178016],
                      [-106.36003304510014, 31.71770976045162],
                      [-106.51520186305567, 31.772592883220522],
                      [-108.21343837068, 31.779453273566634],
                      [-108.21343837068, 31.326667510723183],
                      [-109.96770806256603, 31.326667510723183],
                      [-111.06682052308432, 31.333527901069296],
                      [-112.32541204650134, 31.728000345970788],
                      [-113.96330512492074, 32.235669231583145],
                      [-114.82104386861933, 32.49979425990849],
                      [-114.72621847986872, 32.71246636063799],
                      [-115.79515922578454, 32.63357187165769],
                      [-117.12702491323611, 32.530666016466],
                      [-117.25633226153238, 32.70217577511882],
                      [-117.25202201658918, 32.88397611929081],
                      [-117.32098593568053, 33.106938805539485],
                      [-117.51063671318171, 33.33676188213426],
                      [-118.09251978051492, 33.73123432703575],
                      [-118.38992668159634, 33.8375703774005],
                      [-118.54509549955186, 34.03995189261083],
                      [-118.93732778938387, 34.04338208778389],
                      [-119.21749371069247, 34.14628794297558],
                      [-119.26921665001096, 34.25605418851339],
                      [-119.61834649041089, 34.4207035568201],
                      [-119.87696118700343, 34.406982776127876],
                      [-120.13126563865276, 34.47215648441595],
                      [-120.47177498916626, 34.4515753133776],
                      [-120.64849503183784, 34.58535292512681],
                      [-120.60108233746253, 34.70540975618378],
                      [-120.67435650149709, 34.90779127139412],
                      [-120.64418478689463, 35.141044543161954],
                      [-120.89848923854396, 35.25081078869976],
                      [-120.8726277688847, 35.4051695714873],
                      [-121.00624536212418, 35.460052694256206],
                      [-121.26917030365992, 35.66586440463959],
                      [-121.48899279576358, 35.981442360560784],
                      [-121.89415582042523, 36.314171292347254],
                      [-121.94587875974374, 36.49254144134619],
                      [-121.79070994178821, 36.80468920209433],
                      [-121.93725826985731, 36.97962915592021],
                      [-122.15277051701776, 36.976198960747155],
                      [-122.40276472372388, 37.195731451822766],
                      [-122.39845447878066, 37.36038082012948],
                      [-122.51914133719052, 37.531890578782296],
                      [-122.3596622742918, 37.593634091897314],
                      [-122.14846027207454, 37.57991331120509],
                      [-122.48896962258806, 38.10473317268273],
                      [-122.52776182707694, 37.81659677814598],
                      [-122.91999411690895, 38.03612926922159],
                      [-122.97602730117067, 38.26595234581637],
                      [-123.64842551231126, 38.84908552523598],
                      [-123.82514555498284, 39.34646382532915],
                      [-123.76911237072112, 39.545415145366434],
                      [-123.8553172695853, 39.83355153990317],
                      [-124.11393196617783, 40.107967153747694],
                      [-124.36392617288395, 40.262325936535234],
                      [-124.41133886725925, 40.44412628070722],
                      [-124.21306759987164, 40.70139091868646],
                      [-124.10962172123463, 41.01353867943459],
                      [-124.12255245606426, 41.181618242914354],
                      [-124.06220902685932, 41.435452685720534],
                      [-124.21737784481485, 41.85050630166036],
                      [-124.21737784481485, 42.0048650844479],
                      [-124.35961592794075, 42.11463132998571],
                      [-124.4328900919753, 42.33073362588827],
                      [-124.41564911220246, 42.66346255767474],
                      [-124.54926670544194, 42.84526290184674],
                      [-124.44582082680492, 43.03049344119178],
                      [-124.37685690771357, 43.33921100676686],
                      [-124.27772127401977, 43.42153569092022],
                      [-124.15272417066672, 43.881181844109776],
                      [-124.06220902685932, 44.60838322079775],
                      [-124.06651927180253, 44.82448551670031],
                      [-123.97169388305194, 45.15378425331372],
                      [-123.97169388305194, 45.45221123336964],
                      [-123.91997094373343, 45.66145313892608],
                      [-123.98031437293835, 45.76092879894472],
                      [-123.93721192350627, 46.08336714521202],
                      [-123.86824800441492, 46.158831439019266],
                      [-123.61394355276559, 46.186273000403716],
                      [-123.69152796174336, 46.30632983146069],
                      [-123.92428118867664, 46.25144670869179],
                      [-124.06220902685932, 46.35778275905653],
                      [-123.89841971901738, 46.4401074432099],
                      [-123.911350453847, 46.72824383774663],
                      [-124.0923807414618, 46.74196461843886],
                      [-124.01479633248402, 46.98207828055281],
                      [-124.16996515043955, 47.040391598494764],
                      [-124.31651347850865, 47.355969554415964],
                      [-124.42426960208888, 47.74358160897134],
                      [-124.63978184924933, 47.90823097727805],
                      [-124.73460723799992, 48.16892581043034],
                      [-124.5751281751012, 48.37130732564067],
                      [-124.0492782920297, 48.17578620077646],
                      [-123.70014845162977, 48.165495615257285],
                      [-122.79068676861269, 48.08317093110392],
                      [-122.46741839787201, 47.757302389663565],
                      [-122.62689746077075, 47.69212868137549],
                      [-122.5062106023609, 47.520618922722676],
                      [-122.58379501133865, 47.33538838337762],
                      [-122.7993072584991, 47.20504096680148],
                      [-122.72172284952134, 47.08841433091756],
                      [-122.32518031474612, 47.37312053028124],
                      [-122.4113852136103, 47.64067575377965],
                      [-122.32087006980291, 47.94253292900862],
                      [-122.38983398889425, 48.30956381252565],
                      [-122.53207207202014, 48.374737520813724],
                      [-122.44155692821276, 48.58054923119711],
                      [-122.53207207202014, 48.76920996571522],
                      [-122.77344578883985, 48.88583660159914],
                      [-122.7518945641238, 48.992172651963884],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: '',
                  iso_a2: '',
                  name: 'South of Mexico nations',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-83.13212304614707, 14.995508291801439],
                      [-83.41228896745565, 14.827428728321673],
                      [-83.30022259893222, 14.77254560555277],
                      [-83.192466475352, 14.388363746170448],
                      [-83.21832794501125, 14.25115593924819],
                      [-83.4295299472285, 13.956159154365334],
                      [-83.49418362137664, 13.736626663289723],
                      [-83.57176803035439, 13.287271095619328],
                      [-83.50711435620624, 12.903089236237006],
                      [-83.58900901012723, 12.632103817565547],
                      [-83.76572905279879, 12.546348938239136],
                      [-83.66228317416179, 12.254782348529337],
                      [-83.71400611348028, 12.048970638145951],
                      [-83.83469297189014, 11.870600489147016],
                      [-83.70107537865066, 11.850019318108677],
                      [-83.65366268427536, 11.609905655994725],
                      [-83.76141880785559, 11.558452728398878],
                      [-83.86917493143581, 11.37322218905383],
                      [-83.83900321683333, 11.143399112459049],
                      [-83.69676513370746, 10.937587402075662],
                      [-83.66228317416179, 10.807239985499518],
                      [-83.93382860558394, 10.71805491100005],
                      [-84.02434374939133, 10.786658814461179],
                      [-84.67519073581587, 11.071365013824863],
                      [-84.9294951874652, 10.941017597248718],
                      [-85.63206511320827, 11.194852040054895],
                      [-85.70102903229962, 11.081655599344032],
                      [-85.7872339311638, 11.112527355901541],
                      [-85.92947201428969, 11.311478675938815],
                      [-86.33463503895132, 11.609905655994725],
                      [-86.49842434679327, 11.760834243609208],
                      [-86.79583124787469, 12.217050201625717],
                      [-87.07168692424005, 12.388559960278538],
                      [-87.45529872418567, 12.745300258276409],
                      [-87.64494950168685, 12.872217479679499],
                      [-87.58460607248193, 13.057448019024546],
                      [-87.4337474994696, 12.923670407275345],
                      [-87.31306064105976, 12.981983725217304],
                      [-87.62339827697082, 13.424478902541587],
                      [-87.81735929941522, 13.407327926676304],
                      [-87.80011831964237, 13.266689924580989],
                      [-87.92942566793865, 13.156923679043183],
                      [-88.20959158924722, 13.16035387421624],
                      [-88.46820628583976, 13.222097387331257],
                      [-88.78716441163724, 13.24610875354265],
                      [-89.2526708655038, 13.472501634964377],
                      [-89.80869246317775, 13.52738475773328],
                      [-89.83886417778021, 13.595988661194408],
                      [-90.09747887437274, 13.72976627294361],
                      [-90.39919602039737, 13.860113689519755],
                      [-90.70522341136521, 13.928717592980885],
                      [-90.91211516863925, 13.911566617115602],
                      [-91.3172781933009, 13.956159154365334],
                      [-91.7612334224514, 14.179121840614005],
                      [-92.24829110103403, 14.546152724131044],
                      [-92.16208620216983, 14.70394170209164],
                      [-92.15346571228342, 14.995508291801439],
                      [-92.07588130330566, 15.074402780781737],
                      [-92.20518865160193, 15.290505076684294],
                      [-91.75261293256499, 16.045148014756712],
                      [-91.72244121796253, 16.069159380968106],
                      [-90.48540091926156, 16.069159380968106],
                      [-90.39919602039737, 16.34700518998568],
                      [-90.6491902271035, 16.52880553415767],
                      [-90.73539512596767, 16.744907830060228],
                      [-91.06728398659476, 16.919847783886105],
                      [-91.29141672364163, 17.18740300738451],
                      [-90.9940098225602, 17.252576715672582],
                      [-90.989699577617, 17.801407943361614],
                      [-90.26126818221468, 17.81512872405384],
                      [-89.16215572169641, 17.81512872405384],
                      [-89.05008935317298, 18.000359263398884],
                      [-88.88198980038783, 17.887162822688023],
                      [-88.73544147231871, 18.051812190994735],
                      [-88.4897575105558, 18.484016782799845],
                      [-88.30441697799782, 18.48058658762679],
                      [-88.09321497578058, 18.116985899282806],
                      [-88.20959158924722, 17.88030243234191],
                      [-88.28286575328178, 17.581875452286],
                      [-88.23114281396327, 17.49612057295959],
                      [-88.3001067330546, 17.17711242186534],
                      [-88.21390183419044, 16.967870516308896],
                      [-88.28286575328178, 16.892406222501656],
                      [-88.30441697799782, 16.652292560387703],
                      [-88.5371702049311, 16.274971091351492],
                      [-88.73975171726192, 16.230378554101762],
                      [-88.74406196220514, 16.154914260294518],
                      [-88.92940249476312, 15.983404501641695],
                      [-88.91216151499029, 15.894219427142229],
                      [-88.6276853487385, 15.753581425046914],
                      [-88.44665506112372, 15.859917475411663],
                      [-88.22252232407686, 15.726139863662462],
                      [-88.11907644543984, 15.695268107104955],
                      [-87.9078744432226, 15.866777865757776],
                      [-87.72253391066462, 15.921660988526678],
                      [-87.51133190844737, 15.798173962296648],
                      [-87.34323235566222, 15.849626889892495],
                      [-86.87772590179566, 15.763872010566082],
                      [-86.47256287713401, 15.80503435264276],
                      [-86.33894528389453, 15.781022986431365],
                      [-86.20532769065505, 15.87363825610389],
                      [-85.99412568843782, 15.901079817488341],
                      [-85.90361054463042, 15.983404501641695],
                      [-85.70533927724281, 15.976544111295583],
                      [-85.48982703008238, 15.870208060930832],
                      [-85.25276355820588, 15.883928841623058],
                      [-84.99845910655655, 15.986834696814752],
                      [-84.67519073581587, 15.877068451276946],
                      [-84.65794975604305, 15.774162596085253],
                      [-84.29588918081349, 15.811894742988873],
                      [-84.02434374939133, 15.534048933971302],
                      [-84.08037693365304, 15.359108980145422],
                      [-83.90365689098148, 15.383120346356819],
                      [-83.7743495426852, 15.287074881511238],
                      [-83.40797872251244, 15.266493710472897],
                      [-83.25280990455693, 15.04353102422423],
                      [-83.13212304614707, 14.995508291801439],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SON',
                  iso_a2: 'MX',
                  name: 'Sonora',
                },
                geometry: {
                  type: 'MultiPolygon',
                  coordinates: [
                    [
                      [
                        [-114.82104386861933, 32.49979425990849],
                        [-113.96330512492074, 32.235669231583145],
                        [-112.32110180155813, 31.728000345970788],
                        [-111.06682052308432, 31.333527901069296],
                        [-109.96770806256603, 31.326667510723183],
                        [-109.04531564471932, 31.326667510723183],
                        [-108.96773123574155, 31.326667510723183],
                        [-109.04100539977611, 30.829289210629998],
                        [-108.58411943579597, 30.506850864362693],
                        [-108.53670674142066, 30.03691412565396],
                        [-108.60998090545522, 29.40918840898463],
                        [-108.70911653914902, 29.39889782346546],
                        [-108.62722188522805, 28.77117210679613],
                        [-108.6487731099441, 28.60652273848942],
                        [-108.54101698636387, 28.318386343952678],
                        [-108.65739359983051, 28.242922050145438],
                        [-109.07117711437857, 28.277224001876004],
                        [-109.14445127841313, 28.177748341857367],
                        [-109.01945417506006, 27.906762923185905],
                        [-108.90738780653663, 27.83472882455172],
                        [-108.77808045824037, 27.622056723822222],
                        [-108.67032433466014, 27.53630184449581],
                        [-108.64015262005768, 27.313339158247143],
                        [-108.67894482454656, 27.182991741670996],
                        [-108.46774282232931, 26.980610226460666],
                        [-108.5065350268182, 26.80224007746173],
                        [-109.14014103346992, 26.332303338752997],
                        [-109.25220740199336, 26.496952707059705],
                        [-109.54961430307478, 26.72677578365449],
                        [-109.69185238620067, 26.675322856058642],
                        [-109.8556416940426, 26.798809882288673],
                        [-109.91598512324754, 27.059504715440966],
                        [-110.2866661883635, 27.14868978994043],
                        [-110.55390137484245, 27.38194306170827],
                        [-110.62717553887701, 27.608335943129994],
                        [-110.58407308944491, 27.838159019724777],
                        [-110.80820582649179, 27.927344094224246],
                        [-111.06251027814112, 27.937634679743415],
                        [-111.2478508106991, 28.054261315627333],
                        [-111.47629379268918, 28.380129857067697],
                        [-111.70904701962246, 28.459024346047993],
                        [-111.89438755218045, 28.7814626923153],
                        [-112.15300224877298, 28.96326303648729],
                        [-112.26506861729641, 29.330293920004333],
                        [-112.50644233411612, 29.618430314541072],
                        [-112.68747262173089, 29.90999690425087],
                        [-112.75212629587902, 30.187842713268445],
                        [-112.87281315428888, 30.427956375382394],
                        [-113.0797049115629, 30.668070037496346],
                        [-113.12711760593821, 30.812138234764717],
                        [-113.04953319696044, 31.155157752070362],
                        [-113.11849711605178, 31.220331460358434],
                        [-113.54952161037268, 31.295795754165677],
                        [-113.65727773395291, 31.498177269376008],
                        [-113.87278998111336, 31.597652929394645],
                        [-114.02795879906887, 31.491316879029895],
                        [-114.16157639230835, 31.49474707420295],
                        [-114.93311023714276, 31.906370494969725],
                        [-114.9546614618588, 32.14305396191062],
                        [-115.04086636072299, 32.27683157365982],
                        [-114.90724876748351, 32.49293386956238],
                        [-114.82104386861933, 32.49979425990849],
                      ],
                    ],
                    [
                      [
                        [-112.27368910718283, 28.767741911623073],
                        [-112.58402674309387, 28.877508157160882],
                        [-112.48489110940007, 28.970123426833403],
                        [-112.43747841502477, 29.203376698601243],
                        [-112.28230959706924, 29.22395786963958],
                        [-112.19610469820506, 29.02157635442925],
                        [-112.27368910718283, 28.767741911623073],
                      ],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-BCN',
                  iso_a2: 'MX',
                  name: 'Baja California',
                },
                geometry: {
                  type: 'MultiPolygon',
                  coordinates: [
                    [
                      [
                        [-114.82104386861933, 32.49979425990849],
                        [-114.90724876748351, 32.49293386956238],
                        [-115.04086636072299, 32.27683157365982],
                        [-114.9546614618588, 32.14305396191062],
                        [-114.93311023714276, 31.906370494969725],
                        [-114.78225166413044, 31.655966247336604],
                        [-114.85121558322179, 31.529049025933514],
                        [-114.89000778771067, 31.162018142416475],
                        [-114.83397460344895, 31.007659359628935],
                        [-114.71759798998231, 30.942485651340863],
                        [-114.69604676526626, 30.63719828093884],
                        [-114.63139309111813, 30.424526180209337],
                        [-114.66156480572059, 30.18441251809539],
                        [-114.39432961924163, 29.783079682847784],
                        [-114.26933251588858, 29.772789097328612],
                        [-113.76934410247634, 29.40918840898463],
                        [-113.48055769128133, 28.94611206062201],
                        [-113.26073519917767, 28.83977601025726],
                        [-113.10125613627895, 28.503616883297727],
                        [-112.90298486889134, 28.476175321913278],
                        [-112.76074678576545, 27.99937819285843],
                        [-114.06244075861454, 28.002808388031486],
                        [-114.12709443276268, 28.256642830837663],
                        [-114.04088953389851, 28.459024346047993],
                        [-114.16588663725156, 28.6476850805661],
                        [-114.26933251588858, 28.657975666085267],
                        [-114.40295010912806, 28.860357181295598],
                        [-114.52794721248111, 28.925530889583673],
                        [-114.97190244163164, 29.378316652427124],
                        [-115.18310444384888, 29.42976958002297],
                        [-115.2865503224859, 29.532675435214664],
                        [-115.49775232470313, 29.61156992419496],
                        [-115.70033383703395, 29.75563812146333],
                        [-115.83395143027343, 30.34563169122904],
                        [-116.04946367743388, 30.47940930297824],
                        [-116.06670465720671, 30.812138234764717],
                        [-116.24773494482149, 30.95620643203309],
                        [-116.31238861896962, 31.14829736172425],
                        [-116.53221111107328, 31.439863951434045],
                        [-116.67444919419917, 31.55306039214491],
                        [-116.61841600993746, 31.854917567373878],
                        [-116.84254874698432, 31.98526498395002],
                        [-116.94599462562134, 32.24939001227537],
                        [-117.02788927954231, 32.27683157365982],
                        [-117.1227146682929, 32.530666016466],
                        [-115.79515922578454, 32.630141676484634],
                        [-114.72190823492552, 32.71246636063799],
                        [-114.82104386861933, 32.49979425990849],
                      ],
                    ],
                    [
                      [
                        [-113.13573809582462, 29.066168891678984],
                        [-113.23056348457521, 29.059308501332872],
                        [-113.58831381486156, 29.40918840898463],
                        [-113.47624744633814, 29.532675435214664],
                        [-113.35125034298507, 29.385177042773236],
                        [-113.18315079019992, 29.29256177310071],
                        [-113.13573809582462, 29.066168891678984],
                      ],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CHH',
                  iso_a2: 'MX',
                  name: 'Chihuahua',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-108.96773123574155, 31.326667510723183],
                      [-108.21774861562321, 31.326667510723183],
                      [-108.21774861562321, 31.776023078393578],
                      [-106.50658137316924, 31.769162688047466],
                      [-106.35572280015694, 31.71770976045162],
                      [-106.16176177771253, 31.44672434178016],
                      [-106.006592959757, 31.395271414184315],
                      [-105.76952948788052, 31.179169118281756],
                      [-105.59280944520894, 31.072833067917006],
                      [-105.36436646321887, 30.84987038166834],
                      [-105.00661613293252, 30.678360623015514],
                      [-104.68334776219186, 30.1912729084415],
                      [-104.68334776219186, 29.944298855981437],
                      [-104.53248918917954, 29.66988324213692],
                      [-104.2695642476438, 29.525815044868548],
                      [-104.05836224542657, 29.340584505523502],
                      [-103.79543730389082, 29.27541079723543],
                      [-103.3083796253082, 29.02500654960231],
                      [-103.96353685667596, 27.917053508705077],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.94198563195991, 26.761077735385054],
                      [-104.23508228809813, 26.723345588481433],
                      [-104.51955845434992, 26.37003548565662],
                      [-104.59714286332768, 26.349454314618278],
                      [-104.83420633520417, 26.486662121540537],
                      [-105.11868250145596, 26.55183582982861],
                      [-105.3298845036732, 26.459220560156083],
                      [-105.55832748566328, 26.57241700086695],
                      [-105.67901434407312, 26.69933422227004],
                      [-105.80832169236939, 26.692473831923923],
                      [-106.02814418447305, 26.83997222436535],
                      [-106.22641545186066, 26.558696220174724],
                      [-106.23072569680387, 26.428348803598578],
                      [-106.39882524958902, 26.383756266348843],
                      [-106.37727402487297, 26.129921823542666],
                      [-106.52382235294209, 25.99271401662041],
                      [-106.54537357765813, 25.78004191589091],
                      [-106.7220936203297, 25.63254352344948],
                      [-106.93760586749013, 25.64283410896865],
                      [-107.25656399328761, 25.869226990390377],
                      [-107.41604305618634, 26.129921823542666],
                      [-107.78672412130231, 26.215676702869075],
                      [-107.83413681567761, 26.5998585622514],
                      [-108.04533881789484, 26.932587494037875],
                      [-108.37291743357872, 27.076655691306247],
                      [-108.46774282232931, 26.980610226460666],
                      [-108.67894482454656, 27.182991741670996],
                      [-108.64015262005768, 27.313339158247143],
                      [-108.67032433466014, 27.53630184449581],
                      [-108.77808045824037, 27.622056723822222],
                      [-108.90738780653663, 27.83472882455172],
                      [-109.01945417506006, 27.906762923185905],
                      [-109.14445127841313, 28.177748341857367],
                      [-109.07117711437857, 28.277224001876004],
                      [-108.65739359983051, 28.242922050145438],
                      [-108.54101698636387, 28.318386343952678],
                      [-108.6487731099441, 28.60652273848942],
                      [-108.62722188522805, 28.77117210679613],
                      [-108.70911653914902, 29.39889782346546],
                      [-108.60998090545522, 29.40918840898463],
                      [-108.53670674142066, 30.03691412565396],
                      [-108.58411943579597, 30.506850864362693],
                      [-109.04100539977611, 30.829289210629998],
                      [-108.96773123574155, 31.326667510723183],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-COA',
                  iso_a2: 'MX',
                  name: 'Coahuila',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-103.3083796253082, 29.02500654960231],
                      [-103.14890056240947, 28.98384420752563],
                      [-102.88166537593051, 29.344014700696558],
                      [-102.6833941085429, 29.741917340771106],
                      [-102.40322818723432, 29.77621929250167],
                      [-102.30409255354051, 29.889415733212534],
                      [-102.11013153109612, 29.80366085388612],
                      [-101.97220369291342, 29.817381634578346],
                      [-101.41187185029627, 29.7659287069825],
                      [-101.16618788853336, 29.501803678657154],
                      [-100.81705804813342, 29.27198060206237],
                      [-100.66619947512112, 29.11762181927483],
                      [-100.62309702568902, 28.925530889583673],
                      [-100.39896428864216, 28.592801957797196],
                      [-100.28689792011872, 28.294374977741285],
                      [-100.07569591790148, 28.157167170819026],
                      [-99.80415048647932, 27.772985311436706],
                      [-99.96793979432127, 27.639207699687503],
                      [-100.1834520414817, 27.793566482475043],
                      [-100.33431061449403, 27.70095121280252],
                      [-100.43344624818783, 27.38194306170827],
                      [-100.62740727063223, 27.330490134112424],
                      [-100.8041273133038, 27.210433303055446],
                      [-100.55413310659767, 27.032063154056512],
                      [-100.58861506614335, 26.76450793055811],
                      [-100.75240437398529, 26.730205978827545],
                      [-101.21791082785185, 26.373465680829675],
                      [-100.84722976273588, 25.95498186971679],
                      [-100.84722976273588, 25.783472111063965],
                      [-100.57137408637051, 25.41301103237387],
                      [-100.30413889989156, 25.344407128912742],
                      [-100.25672620551626, 25.21062951716354],
                      [-100.53258188188164, 25.231210688201877],
                      [-100.76964535375812, 25.145455808875468],
                      [-100.83429902790625, 25.042549953683775],
                      [-100.77395559870133, 24.750983363973972],
                      [-100.82998878296306, 24.565752824628927],
                      [-101.09722396944201, 24.641217118436167],
                      [-101.19635960313582, 24.799006096396766],
                      [-101.46359478961477, 24.750983363973972],
                      [-101.58859189296783, 24.884760975723175],
                      [-101.7653119356394, 24.93964409849208],
                      [-101.86013732439, 25.076851905414337],
                      [-102.17478520524425, 25.16260678474075],
                      [-102.5842584748491, 25.124874637837127],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.81701170178238, 24.905342146761512],
                      [-102.84287317144164, 24.730402192935635],
                      [-103.25234644104648, 24.922493122626797],
                      [-103.27389766576253, 25.07342171024128],
                      [-103.50665089269582, 25.299814591663008],
                      [-103.42475623877485, 25.426731813066095],
                      [-103.48940991292298, 25.539928253776957],
                      [-103.31700011519462, 25.697717231737556],
                      [-103.34286158485386, 26.12649162836961],
                      [-103.28251815564894, 26.26369943529187],
                      [-103.32562060508104, 26.407767632560237],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.96353685667596, 27.917053508705077],
                      [-103.3083796253082, 29.02500654960231],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TAM',
                  iso_a2: 'MX',
                  name: 'Tamaulipas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.70932509772872, 27.670079456245013],
                      [-99.5067435853979, 27.574033991399432],
                      [-99.49812309551149, 27.337350524458536],
                      [-99.43346942136336, 27.210433303055446],
                      [-99.46364113596582, 27.056074520267906],
                      [-99.24812888880537, 26.826251443673126],
                      [-99.08433958096342, 26.407767632560237],
                      [-98.79555316976843, 26.366605290483562],
                      [-98.6403843518129, 26.243118264253532],
                      [-98.36883892039074, 26.195095531830738],
                      [-98.22229059232163, 26.075038700773764],
                      [-97.6791997294773, 26.033876358697086],
                      [-97.42489527782797, 25.85550620969815],
                      [-97.14041911157618, 25.965272455235958],
                      [-97.16197033629223, 25.725158793122006],
                      [-97.32144939919095, 25.388999666162476],
                      [-97.45937723737364, 25.17975776060603],
                      [-97.65333825981804, 24.51429989703308],
                      [-97.71799193396618, 24.010061206593782],
                      [-97.7697148732847, 23.25884846369442],
                      [-97.74385340362544, 22.974142264330737],
                      [-97.89040173169454, 22.624262356678976],
                      [-97.78264560811432, 22.270952253854162],
                      [-98.09298324402536, 22.373858109045855],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.93779125289431, 22.373858109045855],
                      [-99.24812888880537, 22.459612988372267],
                      [-99.37743623710163, 22.686005869793995],
                      [-99.5541562797732, 22.620832161505923],
                      [-99.98518077409409, 22.775190944293463],
                      [-99.91621685500274, 22.956991288465453],
                      [-100.05414469318544, 23.241697487829136],
                      [-100.04121395835581, 23.416637441655016],
                      [-99.83863244602499, 23.739075787922324],
                      [-99.5972587292053, 23.766517349306774],
                      [-99.46364113596582, 23.958608278997936],
                      [-99.61449970897813, 24.136978427996873],
                      [-99.57570750448924, 24.346220333553312],
                      [-99.653291913467, 24.637786923263114],
                      [-99.19640594948686, 24.877900585377063],
                      [-99.03261664164492, 25.118014247491015],
                      [-98.86882733380298, 25.097433076452674],
                      [-98.4464233293685, 25.42330161789304],
                      [-98.56279994283514, 25.502196106873335],
                      [-98.55848969789193, 25.97213284558207],
                      [-98.81279414954126, 26.057887724908483],
                      [-99.14899325511155, 26.085329286292932],
                      [-99.1705444798276, 26.28085041115715],
                      [-99.42053868653372, 26.400907242214124],
                      [-99.4162284415905, 26.623869928462796],
                      [-99.6058792190917, 26.730205978827545],
                      [-99.70070460784231, 26.89828554230731],
                      [-99.67915338312626, 27.134969009248206],
                      [-99.77828901682007, 27.481418721726907],
                      [-99.91190661005955, 27.570603796226376],
                      [-99.70932509772872, 27.670079456245013],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-NLE',
                  iso_a2: 'MX',
                  name: 'Nuevo León',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.80415048647932, 27.772985311436706],
                      [-99.70932509772872, 27.670079456245013],
                      [-99.91190661005955, 27.570603796226376],
                      [-99.77828901682007, 27.481418721726907],
                      [-99.67915338312626, 27.134969009248206],
                      [-99.70070460784231, 26.89828554230731],
                      [-99.6058792190917, 26.730205978827545],
                      [-99.4162284415905, 26.623869928462796],
                      [-99.42053868653372, 26.400907242214124],
                      [-99.1705444798276, 26.28085041115715],
                      [-99.14899325511155, 26.085329286292932],
                      [-98.81279414954126, 26.057887724908483],
                      [-98.55848969789193, 25.97213284558207],
                      [-98.56279994283514, 25.502196106873335],
                      [-98.4464233293685, 25.42330161789304],
                      [-98.86882733380298, 25.097433076452674],
                      [-99.03261664164492, 25.118014247491015],
                      [-99.19640594948686, 24.877900585377063],
                      [-99.653291913467, 24.637786923263114],
                      [-99.57570750448924, 24.346220333553312],
                      [-99.61449970897813, 24.136978427996873],
                      [-99.46364113596582, 23.958608278997936],
                      [-99.5972587292053, 23.766517349306774],
                      [-99.83863244602499, 23.739075787922324],
                      [-100.04121395835581, 23.416637441655016],
                      [-100.05414469318544, 23.241697487829136],
                      [-100.43775649313103, 23.22797670713691],
                      [-100.48516918750633, 23.821400472075677],
                      [-100.57999457625692, 23.931166717613486],
                      [-100.6101662908594, 24.2844768204383],
                      [-100.82998878296306, 24.565752824628927],
                      [-100.77395559870133, 24.750983363973972],
                      [-100.83429902790625, 25.042549953683775],
                      [-100.76964535375812, 25.145455808875468],
                      [-100.53258188188164, 25.231210688201877],
                      [-100.25672620551626, 25.21062951716354],
                      [-100.30413889989156, 25.344407128912742],
                      [-100.57137408637051, 25.41301103237387],
                      [-100.84722976273588, 25.783472111063965],
                      [-100.84722976273588, 25.95498186971679],
                      [-101.21791082785185, 26.373465680829675],
                      [-100.75240437398529, 26.730205978827545],
                      [-100.58861506614335, 26.76450793055811],
                      [-100.55413310659767, 27.032063154056512],
                      [-100.8041273133038, 27.210433303055446],
                      [-100.62740727063223, 27.330490134112424],
                      [-100.43344624818783, 27.38194306170827],
                      [-100.33431061449403, 27.70095121280252],
                      [-100.1834520414817, 27.793566482475043],
                      [-99.96793979432127, 27.639207699687503],
                      [-99.80415048647932, 27.772985311436706],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-ROO',
                  iso_a2: 'MX',
                  name: 'Quintana Roo',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-89.14922498686678, 17.952336530976098],
                      [-89.03284837340013, 18.20274077860922],
                      [-89.04146886328655, 18.490877173145957],
                      [-89.1104327823779, 18.693258688356288],
                      [-89.08026106777544, 18.960813911854693],
                      [-89.0112971486841, 19.218078549833926],
                      [-89.13629425203715, 19.403309089178975],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.36904747897043, 19.82179290029186],
                      [-89.20094792618528, 19.842374071330198],
                      [-88.91216151499029, 19.94871012169495],
                      [-88.70958000265946, 20.08248773344415],
                      [-88.44665506112372, 20.185393588635844],
                      [-88.22252232407686, 20.432367641095908],
                      [-88.01563056680283, 20.432367641095908],
                      [-87.67512121628931, 20.648469936998463],
                      [-87.53288313316341, 20.957187502573547],
                      [-87.58460607248193, 21.111546285361086],
                      [-87.524262643277, 21.30020701987919],
                      [-87.53719337810662, 21.499158339916463],
                      [-87.2397864770252, 21.44427521714756],
                      [-86.99841276020551, 21.567762243377594],
                      [-86.82600296247715, 21.43398463162839],
                      [-86.81307222764752, 21.204161555033608],
                      [-86.74410830855618, 21.162999212956933],
                      [-86.87341565685244, 20.854281647381853],
                      [-87.06737667929684, 20.62102837561401],
                      [-87.235476232082, 20.494111154210923],
                      [-87.44236798935603, 20.1888237838089],
                      [-87.47253970395849, 19.883536413406876],
                      [-87.62770852191402, 19.708596459580995],
                      [-87.66650072640289, 19.554237676793456],
                      [-87.42512700958319, 19.557667871966515],
                      [-87.72253391066462, 18.679537907664063],
                      [-87.7699466050399, 18.40512229381955],
                      [-88.08028424095096, 18.497737563492073],
                      [-88.00269983197319, 18.68982849318323],
                      [-88.101835465667, 18.803024933894093],
                      [-88.30441697799782, 18.48058658762679],
                      [-88.4897575105558, 18.4874469779729],
                      [-88.61475461390887, 18.247333315858953],
                      [-88.88198980038783, 17.887162822688023],
                      [-89.05008935317298, 18.000359263398884],
                      [-89.14922498686678, 17.952336530976098],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CAM',
                  iso_a2: 'MX',
                  name: 'Campeche',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-89.14922498686678, 17.952336530976098],
                      [-89.16215572169641, 17.81512872405384],
                      [-90.26126818221468, 17.81512872405384],
                      [-90.989699577617, 17.801407943361614],
                      [-90.989699577617, 17.96948750684138],
                      [-91.57158264495021, 18.10326511859058],
                      [-91.63192607415513, 17.952336530976098],
                      [-91.89054077074768, 17.966057311668322],
                      [-92.15346571228342, 18.168438826878653],
                      [-92.14915546734022, 18.463435611761508],
                      [-92.35604722461424, 18.456575221415395],
                      [-92.48535457291051, 18.648666151106553],
                      [-92.05864032353281, 18.7001190787024],
                      [-91.99398664938468, 18.538899905568748],
                      [-91.83019734154274, 18.477156392453733],
                      [-91.54572117529096, 18.44971483106928],
                      [-91.33451917307372, 18.573201857299313],
                      [-91.26555525398237, 18.734421030432966],
                      [-91.42934456182431, 18.881919422874393],
                      [-90.9379766382985, 19.16319542706502],
                      [-90.73108488102446, 19.375867527794522],
                      [-90.70953365630842, 19.68801528854266],
                      [-90.47678042937514, 19.921268560310498],
                      [-90.48971116420476, 20.5352734962876],
                      [-90.37764479568133, 20.826840085997397],
                      [-90.39057553051096, 20.548994276979826],
                      [-90.23971695749864, 20.511262130076204],
                      [-89.86903589238267, 20.267718272789196],
                      [-89.81300270812096, 20.137370856213053],
                      [-89.63197242050617, 20.017314025156075],
                      [-89.45525237783461, 19.777200363042127],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.13629425203715, 19.403309089178975],
                      [-89.0112971486841, 19.218078549833926],
                      [-89.08026106777544, 18.960813911854693],
                      [-89.1104327823779, 18.693258688356288],
                      [-89.04146886328655, 18.490877173145957],
                      [-89.03284837340013, 18.20274077860922],
                      [-89.14922498686678, 17.952336530976098],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TAB',
                  iso_a2: 'MX',
                  name: 'Tabasco',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-90.989699577617, 17.801407943361614],
                      [-90.989699577617, 17.252576715672582],
                      [-91.43365480676752, 17.252576715672582],
                      [-91.42934456182431, 17.389784522594837],
                      [-91.62761582921192, 17.51327154882487],
                      [-91.78709489211066, 17.846000480611345],
                      [-91.9982968943279, 17.904313798553307],
                      [-92.36466771450065, 17.695071892996864],
                      [-92.69655657512774, 17.386354327421785],
                      [-92.84310490319686, 17.41722608397929],
                      [-92.98965323126596, 17.561294281247662],
                      [-92.99396347620916, 17.907743993726363],
                      [-93.31292160200663, 17.962627116495266],
                      [-93.41205723570044, 17.636758575054905],
                      [-93.588777278372, 17.376063741902612],
                      [-93.61463874803125, 17.547573500555437],
                      [-93.73532560644111, 17.671060526785467],
                      [-93.93790711877193, 17.760245601284936],
                      [-94.07583495695462, 17.883732627514966],
                      [-94.04997348729536, 17.993498873052772],
                      [-94.13617838615954, 18.20960116895533],
                      [-93.4422289503029, 18.442854440723167],
                      [-92.93793029194745, 18.446284635896227],
                      [-92.68362584029812, 18.62465478489516],
                      [-92.48535457291051, 18.648666151106553],
                      [-92.35604722461424, 18.456575221415395],
                      [-92.14915546734022, 18.463435611761508],
                      [-92.15346571228342, 18.168438826878653],
                      [-91.89054077074768, 17.966057311668322],
                      [-91.63192607415513, 17.952336530976098],
                      [-91.57158264495021, 18.10326511859058],
                      [-90.989699577617, 17.96948750684138],
                      [-90.989699577617, 17.801407943361614],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CHP',
                  iso_a2: 'MX',
                  name: 'Chiapas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-91.43365480676752, 17.252576715672582],
                      [-91.29141672364163, 17.190833202557563],
                      [-91.06297374165155, 16.919847783886105],
                      [-90.73539512596767, 16.748338025233284],
                      [-90.6491902271035, 16.52880553415767],
                      [-90.39488577545416, 16.34700518998568],
                      [-90.45091895971589, 16.079449966487275],
                      [-90.9940098225602, 16.069159380968106],
                      [-91.72244121796253, 16.069159380968106],
                      [-92.10605301790812, 15.455154444991003],
                      [-92.20518865160193, 15.235621953915391],
                      [-92.07157105836245, 15.074402780781737],
                      [-92.15346571228342, 14.995508291801439],
                      [-92.15777595722663, 14.700511506918584],
                      [-92.24829110103403, 14.546152724131044],
                      [-92.70086682007096, 14.998938486974495],
                      [-92.82586392342401, 15.173878440800374],
                      [-92.98103274137954, 15.266493710472897],
                      [-93.22671670314244, 15.503177177413793],
                      [-93.65343095252014, 15.839336304373326],
                      [-93.94652760865834, 16.010846063026147],
                      [-94.08445544684103, 16.148053869948406],
                      [-94.03704275246574, 16.271540896178436],
                      [-94.12324765132992, 16.508224363119332],
                      [-94.03704275246574, 16.662583145906872],
                      [-94.02842226257931, 16.813511733521356],
                      [-93.90773540416947, 16.882115636982483],
                      [-93.8732534446238, 17.14967086048089],
                      [-93.588777278372, 17.376063741902612],
                      [-93.41205723570044, 17.636758575054905],
                      [-93.31292160200663, 17.962627116495266],
                      [-92.99396347620916, 17.907743993726363],
                      [-92.98965323126596, 17.561294281247662],
                      [-92.84310490319686, 17.41722608397929],
                      [-92.69655657512774, 17.386354327421785],
                      [-92.36466771450065, 17.695071892996864],
                      [-91.9982968943279, 17.904313798553307],
                      [-91.78709489211066, 17.846000480611345],
                      [-91.62761582921192, 17.51327154882487],
                      [-91.42934456182431, 17.389784522594837],
                      [-91.43365480676752, 17.252576715672582],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-COL',
                  iso_a2: 'MX',
                  name: 'Colima',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-103.7394041196291, 18.693258688356288],
                      [-103.97646759150558, 18.87505903252828],
                      [-104.32990767684872, 19.02255742496971],
                      [-104.35576914650798, 19.111742499469173],
                      [-104.59283261838448, 19.149474646372795],
                      [-104.53679943412276, 19.248950306391436],
                      [-104.21353106338208, 19.32098440502562],
                      [-104.1230159195747, 19.471912992640103],
                      [-103.83422950837969, 19.399878894005916],
                      [-103.63595824099208, 19.485633773332328],
                      [-103.49372015786619, 19.314124014679507],
                      [-103.52389187246865, 19.091161328430836],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.7394041196291, 18.693258688356288],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-NAY',
                  iso_a2: 'MX',
                  name: 'Nayarit',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.29109229918433, 20.686202083902085],
                      [-105.51091479128797, 20.771956963228497],
                      [-105.30833327895715, 21.032651796380787],
                      [-105.2350591149226, 21.06009335776524],
                      [-105.24367960480902, 21.341369361955866],
                      [-105.18764642054731, 21.44427521714756],
                      [-105.41608940253738, 21.602064195108156],
                      [-105.63160164969783, 21.95537429793297],
                      [-105.65315287441388, 22.25380127798888],
                      [-105.72211679350522, 22.511065915968114],
                      [-105.46350209691268, 22.49734513527589],
                      [-105.48505332162873, 22.686005869793995],
                      [-105.57125822049291, 22.788911724985688],
                      [-105.39022793287813, 23.032455582272696],
                      [-105.13161323628559, 23.015304606407412],
                      [-104.9462727037276, 22.915828946388775],
                      [-104.88592927452268, 22.788911724985688],
                      [-104.9936853981029, 22.675715284274823],
                      [-104.97213417338686, 22.541937672525624],
                      [-104.77386290599924, 22.675715284274823],
                      [-104.66610678241902, 22.624262356678976],
                      [-104.58852237344126, 22.459612988372267],
                      [-104.33421792179193, 22.47676396423755],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.32990767684872, 22.26409186350805],
                      [-104.39887159594007, 22.085721714509113],
                      [-104.09715444991544, 21.783864539280145],
                      [-104.20922081843887, 21.5197395109548],
                      [-103.94198563195991, 21.375671313686432],
                      [-103.9807778364488, 21.27276545849474],
                      [-104.2221515532685, 21.169859603303046],
                      [-104.20922081843887, 20.97090828326577],
                      [-104.28680522741664, 20.706783254940426],
                      [-104.73076045656715, 21.008640430169393],
                      [-105.09282103179672, 20.916025160496865],
                      [-105.29109229918433, 20.686202083902085],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-BCS',
                  iso_a2: 'MX',
                  name: 'Baja California Sur',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-114.06244075861454, 28.002808388031486],
                      [-112.76074678576545, 27.99937819285843],
                      [-112.76936727565186, 27.86560058110923],
                      [-112.60126772286671, 27.656358675552784],
                      [-112.37282474087664, 27.563743405880263],
                      [-112.15731249371619, 27.16241057063266],
                      [-112.01076416564709, 27.117818033382925],
                      [-112.01507441059029, 26.97718003128761],
                      [-111.81680314320268, 26.89828554230731],
                      [-111.56249869155336, 26.69590402709698],
                      [-111.57111918143977, 26.575847196040005],
                      [-111.32112497473365, 26.075038700773764],
                      [-111.35991717922253, 25.965272455235958],
                      [-111.30819423990403, 25.78004191589091],
                      [-111.02371807365223, 25.4576035696236],
                      [-110.90303121524238, 25.145455808875468],
                      [-110.75648288717328, 25.011678197126265],
                      [-110.65734725347947, 24.80586648674288],
                      [-110.73924190740044, 24.555462239109758],
                      [-110.68320872313873, 24.35994111424554],
                      [-110.56252186472888, 24.212442721804113],
                      [-110.40304280183014, 24.17471057490049],
                      [-110.17459981984007, 24.25017486870773],
                      [-110.01943100188454, 24.16785018455438],
                      [-109.98925928728208, 24.044363158324344],
                      [-109.69616263114388, 23.80081930103734],
                      [-109.67892165137104, 23.649890713422856],
                      [-109.47634013904022, 23.560705638923388],
                      [-109.42461719972171, 23.296580610598042],
                      [-109.53237332330194, 23.107919876079936],
                      [-109.7090933659735, 23.029025387099637],
                      [-109.89443389853149, 22.874666604312097],
                      [-110.09701541086231, 23.015304606407412],
                      [-110.17028957489686, 23.32059197680944],
                      [-110.30821741307955, 23.543554663058103],
                      [-110.5754525995585, 23.684192665153418],
                      [-111.04095905342507, 24.102676476266307],
                      [-111.4418118331435, 24.32220896734192],
                      [-111.67887530502, 24.586333995667268],
                      [-111.84697485780515, 24.654937899128395],
                      [-111.96766171621499, 24.778424925358426],
                      [-112.08834857462485, 24.771564535012313],
                      [-112.14438175888657, 25.08714249093351],
                      [-112.07541783979522, 25.258652249586326],
                      [-112.07541783979522, 25.714868207602837],
                      [-112.20041494314827, 25.996144211793464],
                      [-112.34265302627418, 26.177944555965457],
                      [-112.72626482621978, 26.37003548565662],
                      [-113.06246393179006, 26.5998585622514],
                      [-113.14435858571105, 26.757647540211998],
                      [-113.5064191609406, 26.795379687115616],
                      [-113.63572650923686, 26.72677578365449],
                      [-113.81675679685164, 26.949738469903156],
                      [-114.00640757435283, 26.97718003128761],
                      [-114.11416369793305, 27.107527447863752],
                      [-114.48484476304903, 27.2378748644399],
                      [-114.50639598776507, 27.405954427919664],
                      [-114.73052872481193, 27.51915086863053],
                      [-114.88569754276746, 27.694090822456406],
                      [-114.92448974725633, 27.83472882455172],
                      [-114.49777549787865, 27.776415506609762],
                      [-114.3253657001503, 27.8758911666284],
                      [-114.2822632507182, 27.735253164533084],
                      [-114.10554320804664, 27.70781160314863],
                      [-114.20898908668366, 28.002808388031486],
                      [-114.14864565747872, 28.002808388031486],
                      [-114.09692271816022, 28.002808388031486],
                      [-114.07106124850097, 28.002808388031486],
                      [-114.06244075861454, 28.002808388031486],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SIN',
                  iso_a2: 'MX',
                  name: 'Sinaloa',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.72211679350522, 22.511065915968114],
                      [-105.79970120248298, 22.6379831373712],
                      [-106.03245442941626, 22.830074067062363],
                      [-106.22210520691746, 23.053036753311034],
                      [-106.4333072091347, 23.23140690230997],
                      [-106.52382235294209, 23.406346856135848],
                      [-106.79105753942103, 23.63273973755757],
                      [-106.90312390794446, 23.84541183828707],
                      [-107.03674150118394, 23.979189450036273],
                      [-107.37725085169745, 24.205582331458],
                      [-107.62293481346036, 24.45598657909112],
                      [-107.82120608084799, 24.59319438601338],
                      [-107.99792612351955, 24.64807750878228],
                      [-108.03671832800842, 24.78528531570454],
                      [-108.18757690102075, 24.98766683091487],
                      [-108.10568224709976, 25.118014247491015],
                      [-108.33412522908984, 25.16260678474075],
                      [-108.45050184255649, 25.2689428351055],
                      [-108.8901468267638, 25.48847532618111],
                      [-109.11858980875388, 25.536498058603904],
                      [-109.17031274807238, 25.64626430414171],
                      [-109.43754793455133, 25.793762696583137],
                      [-109.43323768960813, 26.023585773177917],
                      [-109.29530985142544, 26.236257873907416],
                      [-109.28668936153902, 26.239688069080472],
                      [-109.23065617727731, 26.26369943529187],
                      [-109.15738201324275, 26.308291972541603],
                      [-109.14014103346992, 26.332303338752997],
                      [-108.5065350268182, 26.80224007746173],
                      [-108.46774282232931, 26.980610226460666],
                      [-108.37291743357872, 27.076655691306247],
                      [-108.04533881789484, 26.932587494037875],
                      [-107.83413681567761, 26.5998585622514],
                      [-107.78672412130231, 26.215676702869075],
                      [-107.41604305618634, 26.129921823542666],
                      [-107.25656399328761, 25.869226990390377],
                      [-106.93760586749013, 25.64283410896865],
                      [-107.09708493038887, 25.419871422719982],
                      [-107.12725664499133, 25.190048346125202],
                      [-107.03674150118394, 24.922493122626797],
                      [-106.75657557987537, 24.702960631551186],
                      [-106.59278627203342, 24.37023169976471],
                      [-106.40313549453224, 24.287907015611353],
                      [-106.19193349231499, 24.387382675629993],
                      [-106.05400565413231, 24.2844768204383],
                      [-105.94624953055208, 24.075234914881854],
                      [-105.89883683617678, 23.715064421710927],
                      [-105.7134963036188, 23.464660174077807],
                      [-105.68763483395955, 23.296580610598042],
                      [-105.39022793287813, 23.032455582272696],
                      [-105.57125822049291, 22.788911724985688],
                      [-105.48505332162873, 22.686005869793995],
                      [-105.46350209691268, 22.49734513527589],
                      [-105.72211679350522, 22.511065915968114],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-YUC',
                  iso_a2: 'MX',
                  name: 'Yucatán',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-90.37764479568133, 20.826840085997397],
                      [-90.33023210130602, 21.032651796380787],
                      [-90.09747887437274, 21.162999212956933],
                      [-89.7871412384617, 21.286486239186964],
                      [-89.12336351720752, 21.361950532994207],
                      [-88.70526975771625, 21.457995997839788],
                      [-88.45096530606693, 21.574622633723706],
                      [-88.28286575328178, 21.55747165785842],
                      [-88.12769693532626, 21.61578497580038],
                      [-87.53719337810662, 21.499158339916463],
                      [-87.524262643277, 21.30020701987919],
                      [-87.58460607248193, 21.111546285361086],
                      [-87.53288313316341, 20.957187502573547],
                      [-87.67512121628931, 20.648469936998463],
                      [-88.01563056680283, 20.432367641095908],
                      [-88.22252232407686, 20.432367641095908],
                      [-88.44665506112372, 20.185393588635844],
                      [-88.70958000265946, 20.08248773344415],
                      [-88.91216151499029, 19.94871012169495],
                      [-89.20094792618528, 19.842374071330198],
                      [-89.36904747897043, 19.82179290029186],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.45525237783461, 19.777200363042127],
                      [-89.63197242050617, 20.017314025156075],
                      [-89.81300270812096, 20.137370856213053],
                      [-89.86903589238267, 20.267718272789196],
                      [-90.23971695749864, 20.511262130076204],
                      [-90.39057553051096, 20.548994276979826],
                      [-90.37764479568133, 20.826840085997397],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-VER',
                  iso_a2: 'MX',
                  name: 'Veracruz',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-97.78264560811432, 22.270952253854162],
                      [-97.76109438339827, 22.096012300028285],
                      [-97.61023581038596, 21.835317466875996],
                      [-97.65764850476126, 21.63636614683872],
                      [-97.49816944186253, 21.399682679897825],
                      [-97.1964522958379, 20.80968911013212],
                      [-97.1490396014626, 20.648469936998463],
                      [-96.67491265770961, 20.15795202725139],
                      [-96.45509016560595, 19.869815632714648],
                      [-96.27837012293439, 19.314124014679507],
                      [-95.97665297690976, 19.056859376700274],
                      [-95.85165587355671, 18.717270054567685],
                      [-95.73096901514685, 18.75843239664436],
                      [-95.49821578821357, 18.706979469048516],
                      [-95.20511913207537, 18.710409664221572],
                      [-95.00253761974454, 18.556050881434032],
                      [-94.80857659730015, 18.521748929703467],
                      [-94.58444386025327, 18.18901999791699],
                      [-94.46806724678663, 18.14442746066726],
                      [-94.13617838615954, 18.20960116895533],
                      [-94.04997348729536, 17.993498873052772],
                      [-94.07583495695462, 17.883732627514966],
                      [-93.93790711877193, 17.760245601284936],
                      [-93.73532560644111, 17.671060526785467],
                      [-93.61463874803125, 17.547573500555437],
                      [-93.588777278372, 17.376063741902612],
                      [-93.8732534446238, 17.14967086048089],
                      [-94.93788394559641, 17.21484456876896],
                      [-95.30856501071239, 17.674490721958524],
                      [-95.610282156737, 17.516701743997928],
                      [-95.79562268929499, 17.537282915036265],
                      [-95.91199930276163, 17.780826772323273],
                      [-95.77407146457895, 17.996929068225832],
                      [-95.83872513872709, 18.120416094455862],
                      [-96.10596032520604, 18.14442746066726],
                      [-96.22664718361588, 18.19931058343616],
                      [-96.41198771617387, 18.538899905568748],
                      [-96.59732824873186, 18.610934004202935],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.79990976106268, 18.552620686260973],
                      [-96.98525029362067, 18.514888539357354],
                      [-97.12748837674656, 18.638375565587385],
                      [-97.30851866436133, 18.68296810283712],
                      [-97.33006988907738, 18.809885324240206],
                      [-97.22662401044036, 18.9127911794319],
                      [-97.26541621492925, 19.159765231891967],
                      [-97.11024739697372, 19.176916207757248],
                      [-96.98094004867745, 19.286682453295054],
                      [-97.22662401044036, 19.3381353808909],
                      [-97.3904133182823, 19.574818847831796],
                      [-97.30851866436133, 19.89039680375299],
                      [-97.1533498464058, 20.144231246559166],
                      [-97.40334405311194, 20.25742768727003],
                      [-97.54127189129461, 20.137370856213053],
                      [-97.7740251182279, 20.274578663135312],
                      [-97.7697148732847, 20.43922803144202],
                      [-97.55851287106745, 20.504401739730092],
                      [-97.77833536317111, 20.81311930530517],
                      [-97.89902222158096, 20.80625891495906],
                      [-97.99815785527477, 20.483820568691755],
                      [-98.0197090799908, 20.658760522517632],
                      [-98.11453446874141, 20.68963227907514],
                      [-98.33866720578827, 20.432367641095908],
                      [-98.49814626868701, 20.363763737634777],
                      [-98.57142043272155, 20.473529983172583],
                      [-98.43780283948207, 20.675911498382916],
                      [-98.39470039004999, 20.878293013593247],
                      [-98.23091108220805, 20.936606331535206],
                      [-98.13177544851425, 21.070383943284405],
                      [-98.21367010243522, 21.15270862743776],
                      [-98.41194136982283, 21.176719993649158],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.6403843518129, 21.608924585454268],
                      [-98.48952577880058, 21.75299278272264],
                      [-98.37314916533394, 22.26409186350805],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.09298324402536, 22.373858109045855],
                      [-97.78264560811432, 22.270952253854162],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-JAL',
                  iso_a2: 'MX',
                  name: 'Jalisco',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-104.59283261838448, 19.149474646372795],
                      [-104.80834486554491, 19.228369135353095],
                      [-105.01523662281895, 19.36900713744841],
                      [-105.08420054191029, 19.561098067139568],
                      [-105.24798984975223, 19.66743411750432],
                      [-105.52384552611761, 20.03446500102136],
                      [-105.55401724072007, 20.202544564501125],
                      [-105.69625532384596, 20.40835627488451],
                      [-105.5755684654361, 20.48725076386481],
                      [-105.3298845036732, 20.514692325249264],
                      [-105.29109229918433, 20.686202083902085],
                      [-105.09282103179672, 20.916025160496865],
                      [-104.73076045656715, 21.008640430169393],
                      [-104.28680522741664, 20.706783254940426],
                      [-104.20922081843887, 20.97090828326577],
                      [-104.2221515532685, 21.169859603303046],
                      [-103.9807778364488, 21.27276545849474],
                      [-103.94198563195991, 21.375671313686432],
                      [-104.20922081843887, 21.5197395109548],
                      [-104.09715444991544, 21.783864539280145],
                      [-104.39887159594007, 22.085721714509113],
                      [-104.32990767684872, 22.26409186350805],
                      [-103.94629587690312, 22.377288304218915],
                      [-103.9807778364488, 22.771760749120403],
                      [-103.77819632411797, 22.73745879738984],
                      [-103.85147048815253, 22.565949038737017],
                      [-103.61009677133282, 22.524786696660342],
                      [-103.68337093536738, 22.32240518145001],
                      [-103.67906069042417, 22.137174642104963],
                      [-103.48940991292298, 22.133744446931907],
                      [-103.36010256462671, 22.349846742834462],
                      [-103.37303329945634, 22.51449611114117],
                      [-103.04545468377245, 22.25380127798888],
                      [-103.15752105229589, 21.996536640009648],
                      [-103.28682840059216, 21.98624605449048],
                      [-103.52389187246865, 21.818166491010714],
                      [-103.51958162752544, 21.602064195108156],
                      [-103.66612995559454, 21.488867754397294],
                      [-103.7437143645723, 21.296776824706132],
                      [-103.59285579156, 21.19387096951444],
                      [-103.23079521633043, 21.080674528803577],
                      [-103.04545468377245, 21.073814138457465],
                      [-103.05407517365887, 21.265905068148626],
                      [-102.91183709053297, 21.283056044013907],
                      [-102.6833941085429, 21.399682679897825],
                      [-102.64029165911082, 21.567762243377594],
                      [-102.77821949729349, 21.608924585454268],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.23081838950597, 21.6775284889154],
                      [-101.84720658956036, 22.01711781104799],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.53686895364932, 21.63636614683872],
                      [-101.64031483228634, 21.516309315781747],
                      [-101.57135091319499, 21.34822975230198],
                      [-101.85582707944678, 21.149278432264705],
                      [-102.04547785694797, 20.87143262324713],
                      [-102.08427006143685, 20.727364425978763],
                      [-101.98082418279984, 20.55585466732594],
                      [-102.10151104120969, 20.387775103846174],
                      [-102.49805357598491, 20.31231081003893],
                      [-102.67477361865649, 20.21969554036641],
                      [-103.04976492871566, 20.12021988034777],
                      [-103.03683419388604, 19.96929129273329],
                      [-102.7739092523503, 19.955570512041064],
                      [-102.80839121189597, 19.82179290029186],
                      [-102.73942729280462, 19.58167923817791],
                      [-102.54977651530342, 19.38615811331369],
                      [-102.65753263888365, 19.23179933052615],
                      [-102.88166537593051, 19.2043577691417],
                      [-102.98942149951074, 19.056859376700274],
                      [-103.118728847807, 19.005406449104427],
                      [-103.29544889047858, 19.0465687911811],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.52389187246865, 19.091161328430836],
                      [-103.49372015786619, 19.314124014679507],
                      [-103.63595824099208, 19.485633773332328],
                      [-103.83422950837969, 19.399878894005916],
                      [-104.1230159195747, 19.471912992640103],
                      [-104.21353106338208, 19.32098440502562],
                      [-104.53679943412276, 19.248950306391436],
                      [-104.59283261838448, 19.149474646372795],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MIC',
                  iso_a2: 'MX',
                  name: 'Michoacán',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-102.17047496030104, 17.921464774418588],
                      [-102.74373753774782, 18.068963166860016],
                      [-103.02390345905641, 18.185589802743934],
                      [-103.36441280956991, 18.264484291724234],
                      [-103.49803040280939, 18.33308819518536],
                      [-103.7394041196291, 18.693258688356288],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.29544889047858, 19.0465687911811],
                      [-103.118728847807, 19.005406449104427],
                      [-102.98942149951074, 19.056859376700274],
                      [-102.88166537593051, 19.2043577691417],
                      [-102.65753263888365, 19.23179933052615],
                      [-102.54977651530342, 19.38615811331369],
                      [-102.73942729280462, 19.58167923817791],
                      [-102.80839121189597, 19.82179290029186],
                      [-102.7739092523503, 19.955570512041064],
                      [-103.03683419388604, 19.96929129273329],
                      [-103.04976492871566, 20.12021988034777],
                      [-102.67477361865649, 20.21969554036641],
                      [-102.49805357598491, 20.31231081003893],
                      [-102.10151104120969, 20.387775103846174],
                      [-101.95065246819738, 20.363763737634777],
                      [-101.90755001876529, 20.202544564501125],
                      [-101.69203777160484, 20.202544564501125],
                      [-101.61014311768388, 20.319171200385043],
                      [-101.386010380637, 20.288299443827537],
                      [-101.42049234018268, 20.051615976886644],
                      [-101.19635960313582, 20.03446500102136],
                      [-101.01963956046424, 19.94871012169495],
                      [-100.73085314926925, 19.934989341002723],
                      [-100.39465404369895, 19.96586109756023],
                      [-100.39896428864216, 20.07219714792498],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.12310861227678, 19.93841953617578],
                      [-100.21362375608417, 19.564528262312628],
                      [-100.15759057182245, 19.420460065044256],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.79119657847417, 18.782443762855756],
                      [-100.73516339421245, 18.508028149011242],
                      [-101.25670303234074, 18.538899905568748],
                      [-101.49376650421723, 18.477156392453733],
                      [-101.64462507722955, 18.580062247645426],
                      [-101.83858609967395, 18.57663205247237],
                      [-101.87737830416283, 18.319367414493136],
                      [-101.94203197831096, 18.206170973782275],
                      [-102.15754422547141, 18.16157843653254],
                      [-102.17047496030104, 17.921464774418588],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-GRO',
                  iso_a2: 'MX',
                  name: 'Guerrero',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.55417945294872, 16.319563628601227],
                      [-98.77831218999559, 16.556247095542123],
                      [-98.85589659897335, 16.525375338984613],
                      [-99.37312599215842, 16.66601334107993],
                      [-99.73949681233118, 16.731187049368003],
                      [-99.9894910190373, 16.909557198366937],
                      [-101.01101907057783, 17.252576715672582],
                      [-101.18342886830618, 17.413795888806234],
                      [-101.45497429972835, 17.52356213434404],
                      [-101.64462507722955, 17.66763033161241],
                      [-101.80841438507149, 17.89059301786108],
                      [-102.03254712211834, 17.99006867787972],
                      [-102.17047496030104, 17.921464774418588],
                      [-102.15754422547141, 18.16157843653254],
                      [-101.94203197831096, 18.206170973782275],
                      [-101.87737830416283, 18.319367414493136],
                      [-101.83858609967395, 18.57663205247237],
                      [-101.64462507722955, 18.580062247645426],
                      [-101.49376650421723, 18.477156392453733],
                      [-101.25670303234074, 18.538899905568748],
                      [-100.73516339421245, 18.508028149011242],
                      [-100.79119657847417, 18.782443762855756],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.45499747290387, 18.844187275970775],
                      [-100.43344624818783, 18.6452359559335],
                      [-100.2739671852891, 18.39140151312732],
                      [-100.07138567295827, 18.60750380902988],
                      [-99.7481173022176, 18.693258688356288],
                      [-99.66191240335343, 18.76186259181742],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.33002354272634, 18.45314502624234],
                      [-99.14037276522514, 18.497737563492073],
                      [-99.04985762141774, 18.350239171050646],
                      [-99.03261664164492, 18.250763511032005],
                      [-98.79124292482521, 18.03466121512945],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.39039014510678, 17.640188770227958],
                      [-98.33435696084507, 17.334901399825938],
                      [-98.14901642828708, 17.21484456876896],
                      [-98.00246810021798, 17.026183834250855],
                      [-98.07143201930933, 16.77920978179079],
                      [-98.23953157209446, 16.700315292810494],
                      [-98.33435696084507, 16.56653768106129],
                      [-98.32573647095865, 16.4396204596582],
                      [-98.55417945294872, 16.319563628601227],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-OAX',
                  iso_a2: 'MX',
                  name: 'Oaxaca',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.55417945294872, 16.319563628601227],
                      [-98.32573647095865, 16.4396204596582],
                      [-98.33435696084507, 16.56653768106129],
                      [-98.23953157209446, 16.700315292810494],
                      [-98.07143201930933, 16.77920978179079],
                      [-98.00246810021798, 17.026183834250855],
                      [-98.14901642828708, 17.21484456876896],
                      [-98.33435696084507, 17.334901399825938],
                      [-98.39039014510678, 17.640188770227958],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.17487789794633, 18.01751023926417],
                      [-97.92488369124021, 18.038091410302506],
                      [-97.7266124238526, 18.302216438627852],
                      [-97.63609728004522, 18.17186902205171],
                      [-97.42489527782797, 17.99006867787972],
                      [-97.31282890930454, 18.14442746066726],
                      [-97.02835274305275, 18.12384628962892],
                      [-96.79128927117625, 18.281635267589515],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.59732824873186, 18.610934004202935],
                      [-96.41198771617387, 18.538899905568748],
                      [-96.22664718361588, 18.19931058343616],
                      [-96.10596032520604, 18.14442746066726],
                      [-95.83872513872709, 18.120416094455862],
                      [-95.77407146457895, 17.996929068225832],
                      [-95.91199930276163, 17.780826772323273],
                      [-95.79562268929499, 17.537282915036265],
                      [-95.610282156737, 17.516701743997928],
                      [-95.30856501071239, 17.674490721958524],
                      [-94.93788394559641, 17.21484456876896],
                      [-93.8732534446238, 17.14967086048089],
                      [-93.90773540416947, 16.882115636982483],
                      [-94.02842226257931, 16.813511733521356],
                      [-94.03704275246574, 16.662583145906872],
                      [-94.12324765132992, 16.508224363119332],
                      [-94.03704275246574, 16.271540896178436],
                      [-94.08445544684103, 16.148053869948406],
                      [-94.09307593672744, 16.09660094235256],
                      [-94.1146271614435, 16.058868795448937],
                      [-94.44220577712738, 16.185786016852028],
                      [-94.65340777934462, 16.36415616585096],
                      [-94.76116390292484, 16.292122067216777],
                      [-94.85167904673223, 16.429329874139036],
                      [-95.23098060173461, 16.158344455467574],
                      [-95.43356211406544, 15.976544111295583],
                      [-95.95941199713693, 15.829045718854156],
                      [-96.2352676735023, 15.681547326412728],
                      [-96.55853604424297, 15.660966155374389],
                      [-96.84732245543798, 15.733000254008575],
                      [-97.26541621492925, 15.935381769218905],
                      [-97.7740251182279, 15.97997430646864],
                      [-98.12315495862782, 16.20979738306342],
                      [-98.55417945294872, 16.319563628601227],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MEX',
                  iso_a2: 'MX',
                  name: 'Estado de México',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.6403843518129, 19.461622407120934],
                      [-98.64469459675611, 19.02255742496971],
                      [-98.81710439448446, 18.974534692546918],
                      [-98.96796296749679, 19.08773113325778],
                      [-98.95503223266715, 19.26267108708366],
                      [-99.1231317854523, 19.57138865265874],
                      [-99.33002354272634, 19.296973038814222],
                      [-99.28692109329424, 19.142614256026683],
                      [-99.30847231801029, 18.93337235047024],
                      [-99.47226162585223, 18.79959473872104],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.66191240335343, 18.76186259181742],
                      [-99.7481173022176, 18.693258688356288],
                      [-100.07138567295827, 18.60750380902988],
                      [-100.2739671852891, 18.39140151312732],
                      [-100.43344624818783, 18.6452359559335],
                      [-100.45499747290387, 18.844187275970775],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.15759057182245, 19.420460065044256],
                      [-100.21362375608417, 19.564528262312628],
                      [-100.12310861227678, 19.93841953617578],
                      [-99.84725293591141, 20.308880614865878],
                      [-99.71794558761513, 20.185393588635844],
                      [-99.54984603482998, 20.154521832078338],
                      [-99.38605672698804, 19.75661919200379],
                      [-99.20502643937327, 19.979581878252457],
                      [-99.01968590681528, 20.041325391367472],
                      [-98.60590239226723, 19.74289841131156],
                      [-98.65762533158573, 19.585109433350965],
                      [-98.6403843518129, 19.461622407120934],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-PUE',
                  iso_a2: 'MX',
                  name: 'Puebla',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.64469459675611, 19.02255742496971],
                      [-98.6403843518129, 19.461622407120934],
                      [-98.46366430914134, 19.437611040909538],
                      [-98.35159794061789, 19.242089916045323],
                      [-98.19211887771917, 19.10488210912306],
                      [-98.04988079459328, 19.207787964314754],
                      [-97.92919393618342, 19.156335036718907],
                      [-97.8257480575464, 19.314124014679507],
                      [-97.94212467101305, 19.578249043004853],
                      [-98.14470618334387, 19.674294507850433],
                      [-98.24384181703768, 19.869815632714648],
                      [-98.10160373391179, 20.085917928617206],
                      [-98.16194716311671, 20.329461785904215],
                      [-97.99815785527477, 20.483820568691755],
                      [-97.89902222158096, 20.80625891495906],
                      [-97.77833536317111, 20.81311930530517],
                      [-97.55851287106745, 20.504401739730092],
                      [-97.7697148732847, 20.43922803144202],
                      [-97.7740251182279, 20.274578663135312],
                      [-97.54127189129461, 20.137370856213053],
                      [-97.40334405311194, 20.25742768727003],
                      [-97.1533498464058, 20.144231246559166],
                      [-97.30851866436133, 19.89039680375299],
                      [-97.3904133182823, 19.574818847831796],
                      [-97.22662401044036, 19.3381353808909],
                      [-96.98094004867745, 19.286682453295054],
                      [-97.11024739697372, 19.176916207757248],
                      [-97.26541621492925, 19.159765231891967],
                      [-97.22662401044036, 18.9127911794319],
                      [-97.33006988907738, 18.809885324240206],
                      [-97.30851866436133, 18.68296810283712],
                      [-97.12748837674656, 18.638375565587385],
                      [-96.98525029362067, 18.514888539357354],
                      [-96.79990976106268, 18.552620686260973],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.79128927117625, 18.281635267589515],
                      [-97.02835274305275, 18.12384628962892],
                      [-97.31282890930454, 18.14442746066726],
                      [-97.42489527782797, 17.99006867787972],
                      [-97.63609728004522, 18.17186902205171],
                      [-97.7266124238526, 18.302216438627852],
                      [-97.92488369124021, 18.038091410302506],
                      [-98.17487789794633, 18.01751023926417],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.79124292482521, 18.03466121512945],
                      [-99.03261664164492, 18.250763511032005],
                      [-99.04985762141774, 18.350239171050646],
                      [-98.80848390459805, 18.494307368319014],
                      [-98.65762533158573, 18.892210008393562],
                      [-98.64469459675611, 19.02255742496971],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MOR',
                  iso_a2: 'MX',
                  name: 'Morelos',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.64469459675611, 19.02255742496971],
                      [-98.65762533158573, 18.892210008393562],
                      [-98.80848390459805, 18.494307368319014],
                      [-99.04985762141774, 18.350239171050646],
                      [-99.14037276522514, 18.497737563492073],
                      [-99.33002354272634, 18.45314502624234],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.47226162585223, 18.79959473872104],
                      [-99.30847231801029, 18.93337235047024],
                      [-99.28692109329424, 19.142614256026683],
                      [-99.04554737647454, 19.056859376700274],
                      [-98.96796296749679, 19.08773113325778],
                      [-98.81710439448446, 18.974534692546918],
                      [-98.64469459675611, 19.02255742496971],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-QUE',
                  iso_a2: 'MX',
                  name: 'Querétaro',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.04554737647454, 21.26933526332168],
                      [-99.04123713153133, 21.176719993649158],
                      [-99.36450550227201, 21.111546285361086],
                      [-99.48950260562506, 20.66219071769069],
                      [-99.81708122130894, 20.514692325249264],
                      [-99.84725293591141, 20.308880614865878],
                      [-100.12310861227678, 19.93841953617578],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.48085894256312, 20.435797836268964],
                      [-100.56706384142731, 20.741085206670988],
                      [-100.4722384526767, 20.95032711222743],
                      [-100.1834520414817, 20.878293013593247],
                      [-100.10586763250394, 20.916025160496865],
                      [-100.04983444824222, 21.15613882261082],
                      [-99.82570171119536, 21.15613882261082],
                      [-99.79121975164969, 21.420263850936166],
                      [-99.72225583255835, 21.516309315781747],
                      [-99.56708701460283, 21.392822289551713],
                      [-99.37743623710163, 21.43055443645533],
                      [-99.20071619443007, 21.622645366146493],
                      [-99.04554737647454, 21.26933526332168],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-HID',
                  iso_a2: 'MX',
                  name: 'Hidalgo',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.84725293591141, 20.308880614865878],
                      [-99.81708122130894, 20.514692325249264],
                      [-99.48950260562506, 20.66219071769069],
                      [-99.36450550227201, 21.111546285361086],
                      [-99.04123713153133, 21.176719993649158],
                      [-99.04554737647454, 21.26933526332168],
                      [-98.93779125289431, 21.28991643436002],
                      [-98.82572488437089, 21.176719993649158],
                      [-98.5929716574376, 21.21102194537972],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.41194136982283, 21.176719993649158],
                      [-98.21367010243522, 21.15270862743776],
                      [-98.13177544851425, 21.070383943284405],
                      [-98.23091108220805, 20.936606331535206],
                      [-98.39470039004999, 20.878293013593247],
                      [-98.43780283948207, 20.675911498382916],
                      [-98.57142043272155, 20.473529983172583],
                      [-98.49814626868701, 20.363763737634777],
                      [-98.33866720578827, 20.432367641095908],
                      [-98.11453446874141, 20.68963227907514],
                      [-98.0197090799908, 20.658760522517632],
                      [-97.99815785527477, 20.483820568691755],
                      [-98.16194716311671, 20.329461785904215],
                      [-98.10160373391179, 20.085917928617206],
                      [-98.24384181703768, 19.869815632714648],
                      [-98.14470618334387, 19.674294507850433],
                      [-98.33435696084507, 19.605690604389302],
                      [-98.57573067766477, 19.633132165773755],
                      [-98.65762533158573, 19.585109433350965],
                      [-98.60590239226723, 19.74289841131156],
                      [-99.01968590681528, 20.041325391367472],
                      [-99.20502643937327, 19.979581878252457],
                      [-99.38605672698804, 19.75661919200379],
                      [-99.54984603482998, 20.154521832078338],
                      [-99.71794558761513, 20.185393588635844],
                      [-99.84725293591141, 20.308880614865878],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-GUA',
                  iso_a2: 'MX',
                  name: 'Guanajuato',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.79121975164969, 21.420263850936166],
                      [-99.82570171119536, 21.15613882261082],
                      [-100.04983444824222, 21.15613882261082],
                      [-100.10586763250394, 20.916025160496865],
                      [-100.1834520414817, 20.878293013593247],
                      [-100.4722384526767, 20.95032711222743],
                      [-100.56706384142731, 20.741085206670988],
                      [-100.48085894256312, 20.435797836268964],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.39896428864216, 20.07219714792498],
                      [-100.39465404369895, 19.96586109756023],
                      [-100.73085314926925, 19.934989341002723],
                      [-101.01963956046424, 19.94871012169495],
                      [-101.19635960313582, 20.03446500102136],
                      [-101.42049234018268, 20.051615976886644],
                      [-101.386010380637, 20.288299443827537],
                      [-101.61014311768388, 20.319171200385043],
                      [-101.69203777160484, 20.202544564501125],
                      [-101.90755001876529, 20.202544564501125],
                      [-101.95065246819738, 20.363763737634777],
                      [-102.10151104120969, 20.387775103846174],
                      [-101.98082418279984, 20.55585466732594],
                      [-102.08427006143685, 20.727364425978763],
                      [-102.04547785694797, 20.87143262324713],
                      [-101.85582707944678, 21.149278432264705],
                      [-101.57135091319499, 21.34822975230198],
                      [-101.64031483228634, 21.516309315781747],
                      [-101.53686895364932, 21.63636614683872],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.32566695143208, 21.873049613779614],
                      [-101.26101327728395, 21.77357395376098],
                      [-100.96360637620253, 21.749562587549583],
                      [-100.62740727063223, 21.49229794957035],
                      [-100.49809992233597, 21.516309315781747],
                      [-100.40327453358536, 21.6775284889154],
                      [-99.79121975164969, 21.420263850936166],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SLP',
                  iso_a2: 'MX',
                  name: 'San Luis Potosí',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-100.82998878296306, 24.565752824628927],
                      [-100.6101662908594, 24.2844768204383],
                      [-100.57999457625692, 23.931166717613486],
                      [-100.48516918750633, 23.821400472075677],
                      [-100.43775649313103, 23.22797670713691],
                      [-100.05414469318544, 23.241697487829136],
                      [-99.91621685500274, 22.956991288465453],
                      [-99.98518077409409, 22.775190944293463],
                      [-99.5541562797732, 22.620832161505923],
                      [-99.37743623710163, 22.686005869793995],
                      [-99.24812888880537, 22.459612988372267],
                      [-98.93779125289431, 22.373858109045855],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.37314916533394, 22.26409186350805],
                      [-98.48952577880058, 21.75299278272264],
                      [-98.6403843518129, 21.608924585454268],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.5929716574376, 21.21102194537972],
                      [-98.82572488437089, 21.176719993649158],
                      [-98.93779125289431, 21.28991643436002],
                      [-99.04554737647454, 21.26933526332168],
                      [-99.20071619443007, 21.622645366146493],
                      [-99.37743623710163, 21.43055443645533],
                      [-99.56708701460283, 21.392822289551713],
                      [-99.72225583255835, 21.516309315781747],
                      [-99.79121975164969, 21.420263850936166],
                      [-100.40327453358536, 21.6775284889154],
                      [-100.49809992233597, 21.516309315781747],
                      [-100.62740727063223, 21.49229794957035],
                      [-100.96360637620253, 21.749562587549583],
                      [-101.26101327728395, 21.77357395376098],
                      [-101.32566695143208, 21.873049613779614],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.32135670648887, 22.09944249520134],
                      [-101.38170013569379, 22.36013732835363],
                      [-101.29980548177282, 22.48019415941061],
                      [-101.35152842109133, 22.589960404948414],
                      [-101.51100748399007, 22.61054157598675],
                      [-101.63169434239992, 22.49734513527589],
                      [-101.83427585473073, 22.48019415941061],
                      [-101.95065246819738, 22.648273722890373],
                      [-102.11875202098253, 22.754609773255122],
                      [-102.24805936927879, 22.984432849849902],
                      [-102.252369614222, 23.186814365060236],
                      [-102.18771594007387, 23.406346856135848],
                      [-102.07564957155044, 23.35489392854],
                      [-101.82996560978754, 23.581286809961725],
                      [-101.24808254245431, 23.992910230728498],
                      [-100.993778090805, 24.37023169976471],
                      [-100.82998878296306, 24.565752824628927],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-ZAC',
                  iso_a2: 'MX',
                  name: 'Zacatecas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-100.82998878296306, 24.565752824628927],
                      [-100.993778090805, 24.37023169976471],
                      [-101.24808254245431, 23.992910230728498],
                      [-101.82996560978754, 23.581286809961725],
                      [-102.07564957155044, 23.35489392854],
                      [-102.18771594007387, 23.406346856135848],
                      [-102.252369614222, 23.186814365060236],
                      [-102.24805936927879, 22.984432849849902],
                      [-102.11875202098253, 22.754609773255122],
                      [-101.95065246819738, 22.648273722890373],
                      [-101.83427585473073, 22.48019415941061],
                      [-101.63169434239992, 22.49734513527589],
                      [-101.51100748399007, 22.61054157598675],
                      [-101.35152842109133, 22.589960404948414],
                      [-101.29980548177282, 22.48019415941061],
                      [-101.38170013569379, 22.36013732835363],
                      [-101.32135670648887, 22.09944249520134],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.84720658956036, 22.01711781104799],
                      [-101.98082418279984, 22.123453861412735],
                      [-101.98513442774305, 22.250371082815825],
                      [-102.3471950029726, 22.394439280084196],
                      [-102.64460190405401, 22.212638935912203],
                      [-102.84287317144164, 21.931362931721573],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.77821949729349, 21.608924585454268],
                      [-102.64029165911082, 21.567762243377594],
                      [-102.6833941085429, 21.399682679897825],
                      [-102.91183709053297, 21.283056044013907],
                      [-103.05407517365887, 21.265905068148626],
                      [-103.04545468377245, 21.073814138457465],
                      [-103.23079521633043, 21.080674528803577],
                      [-103.59285579156, 21.19387096951444],
                      [-103.7437143645723, 21.296776824706132],
                      [-103.66612995559454, 21.488867754397294],
                      [-103.51958162752544, 21.602064195108156],
                      [-103.52389187246865, 21.818166491010714],
                      [-103.28682840059216, 21.98624605449048],
                      [-103.15752105229589, 21.996536640009648],
                      [-103.04545468377245, 22.25380127798888],
                      [-103.37303329945634, 22.51449611114117],
                      [-103.36010256462671, 22.349846742834462],
                      [-103.48940991292298, 22.133744446931907],
                      [-103.67906069042417, 22.137174642104963],
                      [-103.68337093536738, 22.32240518145001],
                      [-103.61009677133282, 22.524786696660342],
                      [-103.85147048815253, 22.565949038737017],
                      [-103.77819632411797, 22.73745879738984],
                      [-103.9807778364488, 22.771760749120403],
                      [-103.94629587690312, 22.377288304218915],
                      [-104.32990767684872, 22.26409186350805],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.20922081843887, 22.644843527717317],
                      [-104.18766959372283, 23.118210461599105],
                      [-104.11008518474506, 23.437218612693357],
                      [-103.94198563195991, 23.5675660292695],
                      [-103.85147048815253, 23.852272228633186],
                      [-103.8385397533229, 24.085525500401026],
                      [-103.67044020053775, 24.164419989381322],
                      [-103.51527138258223, 24.3393599432072],
                      [-103.24803619610327, 24.490288530821687],
                      [-102.79977072200954, 24.40796384666833],
                      [-102.49374333104171, 24.473137554956402],
                      [-102.49374333104171, 24.82301746260816],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.5842584748491, 25.124874637837127],
                      [-102.17478520524425, 25.16260678474075],
                      [-101.86013732439, 25.076851905414337],
                      [-101.7653119356394, 24.93964409849208],
                      [-101.58859189296783, 24.884760975723175],
                      [-101.46359478961477, 24.750983363973972],
                      [-101.19635960313582, 24.799006096396766],
                      [-101.09722396944201, 24.641217118436167],
                      [-100.82998878296306, 24.565752824628927],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-AGU',
                  iso_a2: 'MX',
                  name: 'Aguascalientes',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-101.84720658956036, 22.01711781104799],
                      [-102.23081838950597, 21.6775284889154],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.84287317144164, 21.931362931721573],
                      [-102.64460190405401, 22.212638935912203],
                      [-102.3471950029726, 22.394439280084196],
                      [-101.98513442774305, 22.250371082815825],
                      [-101.98082418279984, 22.123453861412735],
                      [-101.84720658956036, 22.01711781104799],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-DUR',
                  iso_a2: 'MX',
                  name: 'Durango',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.39022793287813, 23.032455582272696],
                      [-105.68763483395955, 23.296580610598042],
                      [-105.7134963036188, 23.464660174077807],
                      [-105.89883683617678, 23.715064421710927],
                      [-105.94624953055208, 24.075234914881854],
                      [-106.05400565413231, 24.2844768204383],
                      [-106.19193349231499, 24.387382675629993],
                      [-106.40313549453224, 24.287907015611353],
                      [-106.59278627203342, 24.37023169976471],
                      [-106.75657557987537, 24.702960631551186],
                      [-107.03674150118394, 24.922493122626797],
                      [-107.12725664499133, 25.190048346125202],
                      [-107.09708493038887, 25.419871422719982],
                      [-106.93760586749013, 25.64283410896865],
                      [-106.7220936203297, 25.63254352344948],
                      [-106.54537357765813, 25.78004191589091],
                      [-106.52382235294209, 25.99271401662041],
                      [-106.37727402487297, 26.129921823542666],
                      [-106.39882524958902, 26.383756266348843],
                      [-106.23072569680387, 26.428348803598578],
                      [-106.22641545186066, 26.558696220174724],
                      [-106.02814418447305, 26.83997222436535],
                      [-105.80832169236939, 26.692473831923923],
                      [-105.67901434407312, 26.69933422227004],
                      [-105.55832748566328, 26.57241700086695],
                      [-105.3298845036732, 26.459220560156083],
                      [-105.11868250145596, 26.55183582982861],
                      [-104.83420633520417, 26.486662121540537],
                      [-104.59714286332768, 26.349454314618278],
                      [-104.51955845434992, 26.37003548565662],
                      [-104.23508228809813, 26.723345588481433],
                      [-103.94198563195991, 26.761077735385054],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.32562060508104, 26.407767632560237],
                      [-103.28251815564894, 26.26369943529187],
                      [-103.34286158485386, 26.12649162836961],
                      [-103.31700011519462, 25.697717231737556],
                      [-103.48940991292298, 25.539928253776957],
                      [-103.42475623877485, 25.426731813066095],
                      [-103.50665089269582, 25.299814591663008],
                      [-103.27389766576253, 25.07342171024128],
                      [-103.25234644104648, 24.922493122626797],
                      [-102.84287317144164, 24.730402192935635],
                      [-102.81701170178238, 24.905342146761512],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.49374333104171, 24.82301746260816],
                      [-102.49374333104171, 24.473137554956402],
                      [-102.79977072200954, 24.40796384666833],
                      [-103.24803619610327, 24.490288530821687],
                      [-103.51527138258223, 24.3393599432072],
                      [-103.67044020053775, 24.164419989381322],
                      [-103.8385397533229, 24.085525500401026],
                      [-103.85147048815253, 23.852272228633186],
                      [-103.94198563195991, 23.5675660292695],
                      [-104.11008518474506, 23.437218612693357],
                      [-104.18766959372283, 23.118210461599105],
                      [-104.20922081843887, 22.644843527717317],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.33421792179193, 22.47676396423755],
                      [-104.58852237344126, 22.459612988372267],
                      [-104.66610678241902, 22.624262356678976],
                      [-104.77386290599924, 22.675715284274823],
                      [-104.97213417338686, 22.541937672525624],
                      [-104.9936853981029, 22.675715284274823],
                      [-104.88592927452268, 22.788911724985688],
                      [-104.9462727037276, 22.915828946388775],
                      [-105.13161323628559, 23.015304606407412],
                      [-105.39022793287813, 23.032455582272696],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TLA',
                  iso_a2: 'MX',
                  name: 'Tlaxcala',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.65762533158573, 19.585109433350965],
                      [-98.57573067766477, 19.633132165773755],
                      [-98.33435696084507, 19.605690604389302],
                      [-98.14470618334387, 19.674294507850433],
                      [-97.94212467101305, 19.578249043004853],
                      [-97.8257480575464, 19.314124014679507],
                      [-97.92919393618342, 19.156335036718907],
                      [-98.04988079459328, 19.207787964314754],
                      [-98.19211887771917, 19.10488210912306],
                      [-98.35159794061789, 19.242089916045323],
                      [-98.46366430914134, 19.437611040909538],
                      [-98.6403843518129, 19.461622407120934],
                      [-98.65762533158573, 19.585109433350965],
                    ],
                  ],
                },
              },
              {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CMX',
                  iso_a2: 'MX',
                  name: 'Ciudad de México',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.28692109329424, 19.142614256026683],
                      [-99.33002354272634, 19.296973038814222],
                      [-99.1231317854523, 19.57138865265874],
                      [-98.95503223266715, 19.26267108708366],
                      [-98.96796296749679, 19.08773113325778],
                      [-99.04554737647454, 19.056859376700274],
                      [-99.28692109329424, 19.142614256026683],
                    ],
                  ],
                },
              },
            ],
          },
          data: [
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: '',
                  iso_a2: '',
                  name: 'USA',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-122.7518945641238, 48.992172651963884],
                      [-121.33382397780805, 48.992172651963884],
                      [-119.35542154887514, 48.992172651963884],
                      [-117.15719662783857, 48.992172651963884],
                      [-115.61843918311298, 48.992172651963884],
                      [-113.64003675418007, 48.992172651963884],
                      [-112.32110180155813, 48.992172651963884],
                      [-110.56252186472888, 48.992172651963884],
                      [-109.24358691210693, 48.992172651963884],
                      [-107.26518448317402, 48.992172651963884],
                      [-105.05833907225104, 48.992172651963884],
                      [-103.52820211741187, 48.992172651963884],
                      [-101.98944467268626, 48.992172651963884],
                      [-99.79121975164969, 48.992172651963884],
                      [-98.03263981482044, 48.992172651963884],
                      [-96.27405987799119, 48.992172651963884],
                      [-95.1792576624161, 48.992172651963884],
                      [-95.16201668264327, 49.3694941210001],
                      [-94.82581757707297, 49.29402982719286],
                      [-94.70944096360634, 48.91327816298359],
                      [-94.59306435013968, 48.728047623638545],
                      [-94.23100377491014, 48.6525833298313],
                      [-93.8732534446238, 48.63543235396601],
                      [-93.75687683115716, 48.51537552290904],
                      [-93.4896416446782, 48.54281708429349],
                      [-93.25688841774492, 48.63200215879296],
                      [-92.98103274137954, 48.61828137810073],
                      [-92.64914388075245, 48.535956693947384],
                      [-92.30432428529573, 48.30956381252565],
                      [-92.04139934375999, 48.33357517873705],
                      [-91.95519444489581, 48.227239128372304],
                      [-91.69226950336005, 48.09689171179616],
                      [-91.42934456182431, 48.03514819868114],
                      [-90.92504590346887, 48.227239128372304],
                      [-90.78711806528618, 48.100321906969214],
                      [-90.17937352829372, 48.11747288283449],
                      [-89.98110226090611, 48.011136832469745],
                      [-89.58024948118768, 47.99741605177752],
                      [-90.08454813954313, 47.812185512432464],
                      [-90.53281361363685, 47.71270985241384],
                      [-91.01125080233305, 47.493177361338226],
                      [-91.51123921574529, 47.12271628264813],
                      [-92.0974325280217, 46.803708131553876],
                      [-91.96381493478222, 46.69051169084301],
                      [-91.4164138269947, 46.7934175460347],
                      [-90.96814835290095, 46.951206523995296],
                      [-90.73108488102446, 46.683651300496905],
                      [-90.43367797994304, 46.577315250132145],
                      [-90.05868666988387, 46.68022110532384],
                      [-89.79576172834811, 46.831149692938325],
                      [-89.39921919357289, 46.865451644668894],
                      [-89.13198400709393, 47.00608964676421],
                      [-88.968194699252, 47.019810427456434],
                      [-88.68371853300022, 47.22905233301287],
                      [-88.5371702049311, 47.12614647782118],
                      [-88.3863116319188, 46.85516105914972],
                      [-88.23545305890647, 46.94434613364919],
                      [-87.79580807469917, 46.89975359639945],
                      [-87.59753680731156, 46.765975984650254],
                      [-87.34754260060544, 46.515571737017126],
                      [-86.96824104560304, 46.53958310322852],
                      [-86.62342145014634, 46.44353763838295],
                      [-86.48980385690686, 46.55330388392075],
                      [-85.86050809519834, 46.70766266670829],
                      [-85.51999874468484, 46.683651300496905],
                      [-85.20104061888738, 46.776266570169426],
                      [-85.01138984138618, 46.72481364257358],
                      [-85.05449229081827, 46.53272271288242],
                      [-84.83466979871461, 46.46068861424823],
                      [-84.4898502032579, 46.457258419075174],
                      [-84.1105486482555, 46.5258623225363],
                      [-84.10623840331229, 46.34749217353736],
                      [-84.2010637920629, 46.25144670869179],
                      [-84.02865399433455, 46.148540853500094],
                      [-84.02434374939133, 45.96331031415504],
                      [-84.65794975604305, 46.05592558382757],
                      [-84.8260493088282, 45.88098563000169],
                      [-85.0200103312726, 46.02505382727006],
                      [-85.33896845707005, 46.11080870659647],
                      [-85.54586021434409, 46.09708792590425],
                      [-85.66223682781073, 45.98389148519338],
                      [-86.25274038503036, 45.95301972863588],
                      [-86.3734272434402, 45.805521336194445],
                      [-86.52428581645253, 45.76092879894472],
                      [-86.73979806361297, 45.867264849309464],
                      [-86.85617467707962, 45.7300570423872],
                      [-87.17513280287707, 45.6683135292722],
                      [-87.55874460282267, 45.19151640021734],
                      [-87.63632901180043, 45.006285860872296],
                      [-87.82166954435843, 44.94797254293033],
                      [-88.03287154657565, 44.56722087872107],
                      [-87.76563636009669, 44.65640595322054],
                      [-87.66219048145969, 44.814194931181135],
                      [-87.45098847924245, 44.886229029815325],
                      [-87.32599137588939, 44.80390434566196],
                      [-87.48547043878813, 44.5260585366444],
                      [-87.55012411293626, 44.31338643591489],
                      [-87.49409092867454, 44.22077116624237],
                      [-87.72253391066462, 43.92577438135952],
                      [-87.70098268594856, 43.70967208545696],
                      [-87.9078744432226, 43.26717690813268],
                      [-87.89494370839297, 43.04078402671095],
                      [-87.78287733986954, 42.81096095011617],
                      [-87.82166954435843, 42.279280698292425],
                      [-87.68805195111895, 42.0837595734282],
                      [-87.57598558259551, 41.78876278854535],
                      [-87.38633480509432, 41.64126439610392],
                      [-87.20099427253632, 41.63440400575781],
                      [-86.8001414928179, 41.77847220302618],
                      [-86.65790340969201, 41.87451766787176],
                      [-86.37773748838342, 42.25526933208103],
                      [-86.21825842548469, 42.708055094924475],
                      [-86.2225686704279, 42.96531973290371],
                      [-86.54152679622536, 43.62734740130361],
                      [-86.44239116253155, 43.7851363792642],
                      [-86.51997557150932, 44.08356335932011],
                      [-86.26567111985999, 44.37512994902991],
                      [-86.26998136480319, 44.687277709778044],
                      [-86.10188181201804, 44.74559102772001],
                      [-86.05877936258597, 44.92396117671895],
                      [-85.84757736036872, 44.94797254293033],
                      [-85.76137246150454, 45.061168983641195],
                      [-85.58034217388976, 45.061168983641195],
                      [-85.33465821212685, 45.315003426447376],
                      [-85.0200103312726, 45.438490452677414],
                      [-85.08035376047752, 45.630581382368575],
                      [-84.77432636950968, 45.79866094584834],
                      [-84.45967848865544, 45.67174372444525],
                      [-84.22261501677895, 45.64087196788773],
                      [-84.09761791342588, 45.503664160965485],
                      [-83.51142460114946, 45.3595959636971],
                      [-83.30453284387544, 45.095470935371765],
                      [-83.45970166183096, 44.99942547052618],
                      [-83.3433250483643, 44.89308942016143],
                      [-83.2872918641026, 44.70442868564332],
                      [-83.35194553825073, 44.33053741178017],
                      [-83.5329758258655, 44.2653637034921],
                      [-83.59331925507044, 44.06298218828178],
                      [-83.82176223706051, 44.00466887033981],
                      [-83.92520811569753, 43.881181844109776],
                      [-83.90365689098148, 43.68223052407251],
                      [-83.67952415393461, 43.606766230265265],
                      [-83.26574063938655, 43.977227308955364],
                      [-82.92523128887305, 44.069842578627885],
                      [-82.68816781699655, 43.922344186186464],
                      [-82.63644487767804, 43.81257794064865],
                      [-82.52437850915462, 43.27746749365184],
                      [-82.41662238557439, 43.016772660499555],
                      [-82.51144777432498, 42.64631158180946],
                      [-82.64506536756446, 42.55712650730999],
                      [-82.86488785966812, 42.55712650730999],
                      [-82.89074932932738, 42.40276772452245],
                      [-83.1450537809767, 42.23125796586963],
                      [-83.22263818995447, 41.994574498928735],
                      [-83.42090945734208, 41.809343959583686],
                      [-83.09764108660141, 41.620683225065584],
                      [-82.92523128887305, 41.43202249054748],
                      [-82.614893652962, 41.45603385675887],
                      [-82.50282728443857, 41.39429034364386],
                      [-82.0416310755152, 41.51091697952778],
                      [-81.67095001039924, 41.52120756504695],
                      [-81.34768163965856, 41.73044947060339],
                      [-80.86924445096237, 41.8950988389101],
                      [-80.37787652743654, 42.02201606031319],
                      [-79.47272508936267, 42.40619791969551],
                      [-79.14945671862199, 42.581137873521385],
                      [-78.86929079731343, 42.84526290184674],
                      [-78.91670349168871, 43.07508597844152],
                      [-79.06325181975782, 43.10595773499902],
                      [-79.05894157481461, 43.27746749365184],
                      [-78.68826050969864, 43.359792177805204],
                      [-78.10637744236543, 43.39409412953576],
                      [-77.74862711207908, 43.34607139711298],
                      [-77.53742510986186, 43.25688632261351],
                      [-77.3650153121335, 43.298048664690185],
                      [-76.9814035121879, 43.28432788399796],
                      [-76.71416832570894, 43.33921100676686],
                      [-76.42107166957072, 43.534732131631074],
                      [-76.24435162689916, 43.53816232680414],
                      [-76.1667672179214, 43.668509743380284],
                      [-76.27883358644483, 43.88461203928284],
                      [-76.13228525837573, 44.04583121241649],
                      [-76.35641799542259, 44.1315860917429],
                      [-76.05470084939796, 44.2653637034921],
                      [-75.79177590786222, 44.49518678008688],
                      [-75.27023626973394, 44.86221766360393],
                      [-74.86938349001551, 45.00971605604535],
                      [-74.71421467205998, 44.99942547052618],
                      [-73.39958996438125, 45.002855665699244],
                      [-71.50308218936931, 45.013146251218416],
                      [-71.39532606578908, 45.242969327813185],
                      [-71.14102161413976, 45.25325991333236],
                      [-70.83499422317192, 45.39389791542767],
                      [-70.68844589510282, 45.57226806442661],
                      [-70.40827997379424, 45.7300570423872],
                      [-70.26173164572512, 45.92214797207836],
                      [-70.31345458504364, 46.07307655969285],
                      [-70.18845748169058, 46.35778275905653],
                      [-70.07639111316715, 46.41952627217155],
                      [-70.0074271940758, 46.704232471535235],
                      [-69.26606506384385, 47.43829423856931],
                      [-69.06779379645624, 47.43143384822321],
                      [-69.041932326797, 47.24963350405122],
                      [-68.90831473355752, 47.19132018610925],
                      [-68.53763366844154, 47.301086431647065],
                      [-68.19712431792803, 47.34224877372374],
                      [-67.96437109099475, 47.19818057645537],
                      [-67.80489202809602, 47.03696140332171],
                      [-67.77472031349356, 45.82953270240584],
                      [-67.80058178315281, 45.6991852858297],
                      [-67.4514519427529, 45.61000021133023],
                      [-67.47300316746893, 45.28070147471681],
                      [-67.35662655400229, 45.167505034005956],
                      [-67.17559626638752, 45.177795619525114],
                      [-66.9773249989999, 44.814194931181135],
                      [-67.22300896076283, 44.64268517252832],
                      [-67.57644904610595, 44.55350009802885],
                      [-67.80489202809602, 44.57408126906718],
                      [-67.89971741684661, 44.423152681452706],
                      [-68.09798868423422, 44.385420534549084],
                      [-68.27039848196259, 44.48489619456771],
                      [-68.7574561605452, 44.33396760695324],
                      [-68.82642007963655, 44.478035804221605],
                      [-68.98589914253529, 44.41972248627964],
                      [-69.11951673577477, 44.042401017243435],
                      [-69.26175481890066, 43.92920457653257],
                      [-69.64967686378947, 43.89833281997507],
                      [-69.78760470197214, 43.73711364684141],
                      [-69.98587596935975, 43.8640308682445],
                      [-70.24018042100909, 43.699381499937786],
                      [-70.20569846146341, 43.56217369301554],
                      [-70.35655703447573, 43.52787174128497],
                      [-70.38241850413499, 43.39409412953576],
                      [-70.52034634231767, 43.33921100676686],
                      [-70.81344299845588, 42.869274268058135],
                      [-70.86085569283117, 42.54683592179082],
                      [-71.03757573550274, 42.306722259676874],
                      [-70.78327128385342, 42.25869952725408],
                      [-70.6324127108411, 42.09405015894737],
                      [-70.53327707714729, 41.816204349929805],
                      [-70.27466238055476, 41.716728689911164],
                      [-70.07208086822394, 41.77504200785312],
                      [-69.93846327498446, 41.67556634783449],
                      [-70.42983119851027, 41.63097381058475],
                      [-70.65827418050036, 41.52120756504695],
                      [-70.65827418050036, 41.72358908025728],
                      [-71.18412406357184, 41.4697546374511],
                      [-71.20567528828789, 41.64469459127697],
                      [-71.3565338613002, 41.74760044646867],
                      [-71.4987719444261, 41.36684878225941],
                      [-71.89962472414453, 41.346267611221066],
                      [-72.28754676903334, 41.28452409810605],
                      [-72.77891469255917, 41.27080331741382],
                      [-73.17114698239118, 41.16789746222213],
                      [-73.63665343625775, 41.00667828908848],
                      [-73.82199396881572, 40.83859872560871],
                      [-74.28319017773909, 40.49900940347612],
                      [-74.03319597103297, 40.42011491449583],
                      [-73.97285254182805, 40.327499644823305],
                      [-74.16681356427245, 39.699773928153974],
                      [-74.36077458671684, 39.548845340539486],
                      [-74.74438638666246, 39.054897235619364],
                      [-75.02455230797102, 39.209256018406904],
                      [-75.1581699012105, 39.19896543288773],
                      [-75.36075141354132, 39.33617323980999],
                      [-75.395233373087, 39.054897235619364],
                      [-75.16679039109692, 38.79420240246707],
                      [-75.0590342675167, 38.55408874035312],
                      [-75.15385965626729, 38.24194097960498],
                      [-75.43402557757588, 37.96066497541435],
                      [-75.4943690067808, 37.8303175588382],
                      [-75.88660129661281, 37.35695062495642],
                      [-75.92108325615848, 37.61078506776259],
                      [-75.70988125394125, 37.83374775401126],
                      [-75.81332713257827, 38.13560492924023],
                      [-76.22280040218311, 38.34484683479668],
                      [-76.3176257909337, 38.47519425137282],
                      [-76.14521599320535, 38.66385498589092],
                      [-76.33917701564977, 38.72902869417899],
                      [-76.15383648309177, 38.893678062485705],
                      [-76.13228525837573, 39.116640748734376],
                      [-76.27452334150163, 39.15094270046494],
                      [-76.17538770780783, 39.31559206877165],
                      [-76.42538191451393, 39.32245245911776],
                      [-76.39952044485469, 39.01373489354268],
                      [-76.55037901786699, 38.77705142660179],
                      [-76.51158681337812, 38.526647178968666],
                      [-76.32193603587692, 38.13903512441329],
                      [-76.61503269201513, 38.149325709932455],
                      [-76.52882779315095, 38.025838683702425],
                      [-76.24866187184237, 37.902351657472394],
                      [-76.35641799542259, 37.52159999326312],
                      [-76.24435162689916, 37.44956589462895],
                      [-76.37796922013864, 37.27119574563001],
                      [-76.27021309655842, 36.96247818005493],
                      [-75.99004717524983, 36.91102525245908],
                      [-75.92970374604491, 36.7052135420757],
                      [-75.91677301121528, 36.40335636684672],
                      [-75.86073982695356, 36.163242704732774],
                      [-76.02021888985229, 36.19068426611723],
                      [-76.19693893252386, 36.104929386790815],
                      [-76.41245117968431, 36.08434821575248],
                      [-76.38658971002505, 35.93684982331105],
                      [-76.19693893252386, 35.99516314125301],
                      [-75.85211933706714, 35.981442360560784],
                      [-75.72281198877087, 35.830513772946304],
                      [-75.75298370337333, 35.610981281870686],
                      [-75.89522178649923, 35.580109525313176],
                      [-76.14952623814857, 35.34685625354534],
                      [-76.44262289428677, 35.4051695714873],
                      [-76.55899950775341, 35.123893567296676],
                      [-76.55037901786699, 35.00040654106664],
                      [-76.33486677070655, 34.900930881048],
                      [-76.5029663234917, 34.7671532692988],
                      [-76.65813514144722, 34.72256073204907],
                      [-76.89519861332371, 34.73971170791435],
                      [-77.20122600429156, 34.650526633414884],
                      [-77.53742510986186, 34.468726289242895],
                      [-77.83052176600006, 34.208031456090595],
                      [-77.91241641992103, 33.95762720845748],
                      [-78.03310327833088, 33.89245350016941],
                      [-78.25292577043453, 33.92675545189997],
                      [-78.55895316140237, 33.86844213395801],
                      [-78.93825471640476, 33.64204925253628],
                      [-79.13221573884917, 33.41908656628762],
                      [-79.20117965794051, 33.19269368486589],
                      [-79.38652019049849, 33.01775373104002],
                      [-79.5847914578861, 33.01432353586696],
                      [-79.60634268260215, 32.914847875848324],
                      [-80.00719546232058, 32.61299070061935],
                      [-80.40804824203902, 32.482643284043206],
                      [-80.44253020158469, 32.36601664815929],
                      [-80.8864854307352, 32.07101986327643],
                      [-80.83476249141671, 32.00241595981531],
                      [-81.05889522846357, 31.789743859085803],
                      [-81.19682306664626, 31.71770976045162],
                      [-81.36492261943141, 31.415852585222652],
                      [-81.2700972306808, 31.275214583127337],
                      [-81.49854021267089, 30.966497017552257],
                      [-81.49854021267089, 30.705802184399968],
                      [-81.25716649585118, 29.789940073193897],
                      [-81.17958208687341, 29.58412836281051],
                      [-80.92096739028088, 29.06959908685204],
                      [-80.61062975436982, 28.609952933662477],
                      [-80.76579857232537, 28.613383128835533],
                      [-80.7399371026661, 28.373269466721585],
                      [-80.38218677237975, 27.666649261071957],
                      [-80.34339456789088, 27.515720673457473],
                      [-80.07615938141193, 26.973749836114553],
                      [-80.03736717692304, 26.8125306629809],
                      [-80.12788232073044, 25.886377966255658],
                      [-80.30891260834521, 25.618822742757256],
                      [-80.31322285328841, 25.371848690297192],
                      [-80.42528922181185, 25.220920102682708],
                      [-80.58045803976736, 25.24150127372105],
                      [-80.70976538806364, 25.145455808875468],
                      [-80.85631371613275, 25.186618150952143],
                      [-81.08475669812282, 25.12144444266407],
                      [-81.17527184193021, 25.22778049302882],
                      [-81.14941037227095, 25.39586005650859],
                      [-81.32182016999931, 25.783472111063965],
                      [-81.66232952051283, 25.98242343110124],
                      [-81.8002573586955, 26.099050066985157],
                      [-81.85629054295723, 26.44892997463692],
                      [-82.037320830572, 26.527824463617215],
                      [-82.08042328000408, 26.6787530512317],
                      [-82.31317650693737, 26.85026280988452],
                      [-82.5631707136435, 27.27560701134352],
                      [-82.6623063473373, 27.51915086863053],
                      [-82.39938140580155, 27.7969966776481],
                      [-82.59765267318917, 27.98222721699315],
                      [-82.63644487767804, 27.70095121280252],
                      [-82.84333663495207, 27.82786843420561],
                      [-82.76575222597431, 28.10571424322318],
                      [-82.78730345069036, 28.194899317722648],
                      [-82.6623063473373, 28.448733760528825],
                      [-82.64506536756446, 28.901519523372276],
                      [-82.84764687989528, 29.182795527562906],
                      [-83.02436692256686, 29.175935137216793],
                      [-83.21401770006804, 29.40918840898463],
                      [-83.40366847756924, 29.532675435214664],
                      [-83.40797872251244, 29.666453046963863],
                      [-83.52866558092231, 29.714475779386653],
                      [-83.67952415393461, 29.92028748977004],
                      [-84.02434374939133, 30.10551802911509],
                      [-84.27002771115424, 30.091797248422864],
                      [-84.50709118303072, 29.923717684943096],
                      [-84.88639273803312, 29.731626755251938],
                      [-85.30879674246759, 29.693894608348316],
                      [-85.3562094368429, 29.889415733212534],
                      [-85.67085731769714, 30.12266900498037],
                      [-85.70964952218603, 30.246156031210404],
                      [-85.86481834014155, 30.215284274652895],
                      [-86.3648067535538, 30.379933642959603],
                      [-86.48549361196365, 30.47940930297824],
                      [-86.67945463440805, 30.42109598503628],
                      [-87.15789182310425, 30.475979107805184],
                      [-87.3303016208326, 30.318190129844588],
                      [-87.78718758481276, 30.235865445691235],
                      [-87.91649493310902, 30.424526180209337],
                      [-87.94235640276827, 30.661209647150233],
                      [-88.05442277129171, 30.65434925680412],
                      [-88.11907644543984, 30.33877130088293],
                      [-88.35613991731633, 30.403945009171],
                      [-88.47251653078297, 30.3250505201907],
                      [-88.74406196220514, 30.352492081575154],
                      [-88.92940249476312, 30.441677156074622],
                      [-89.0112971486841, 30.376503447786547],
                      [-89.33025527448154, 30.304469349152363],
                      [-89.44232164300499, 30.1912729084415],
                      [-89.70955682948394, 30.174121932576217],
                      [-89.96817152607647, 30.263307007075685],
                      [-90.05868666988387, 30.359352471921266],
                      [-90.22247597772581, 30.38679403330572],
                      [-90.40350626534058, 30.21871446982595],
                      [-90.33885259119245, 30.06435568703841],
                      [-90.03713544516782, 30.040344320827018],
                      [-89.88196662721231, 30.15354076153788],
                      [-89.83886417778021, 29.995751783577283],
                      [-89.6880056047679, 29.88255534286642],
                      [-89.42939090817535, 30.0574952966923],
                      [-89.45525237783461, 29.827672220097515],
                      [-89.66645438005185, 29.52238484969549],
                      [-89.34318600931118, 29.347444895869614],
                      [-89.20094792618528, 29.354305286215727],
                      [-89.02422788351372, 29.14849357583234],
                      [-89.18801719135566, 29.031866939948422],
                      [-89.38197821380007, 29.086750062717325],
                      [-89.48111384749387, 29.24453904067792],
                      [-89.75696952385924, 29.344014700696558],
                      [-89.90782809687155, 29.47779231244576],
                      [-90.03713544516782, 29.364595871734895],
                      [-90.08023789459992, 29.175935137216793],
                      [-90.25264769232828, 29.247969235850977],
                      [-90.56298532823931, 29.299422163446824],
                      [-90.70522341136521, 29.121052014447887],
                      [-91.22676304949348, 29.23767865033181],
                      [-91.21814255960707, 29.405758213811573],
                      [-91.32158843824409, 29.494943288311042],
                      [-91.53279044046133, 29.532675435214664],
                      [-91.68364901347366, 29.752207926290275],
                      [-91.87761003591805, 29.759068316636387],
                      [-91.98536615949827, 29.831102415270575],
                      [-92.13622473251058, 29.75563812146333],
                      [-92.10605301790812, 29.62186050971413],
                      [-92.27846281563649, 29.532675435214664],
                      [-92.68362584029812, 29.604709533848848],
                      [-93.2008552334832, 29.772789097328612],
                      [-93.73963585138432, 29.73848714559805],
                      [-93.85601246485096, 29.985461198058115],
                      [-93.93359687382872, 29.77621929250167],
                      [-94.05859397718177, 29.68017382765609],
                      [-94.65340777934462, 29.450350751061308],
                      [-94.87754051639148, 29.666453046963863],
                      [-95.02408884446058, 29.542966020733832],
                      [-94.8904712512211, 29.374886457254064],
                      [-95.15770643770006, 29.151923771005396],
                      [-95.15770643770006, 29.045587720640647],
                      [-95.60166166685059, 28.764311716450017],
                      [-95.81717391401104, 28.73343995989251],
                      [-96.20509595889985, 28.585941567451084],
                      [-96.55853604424297, 28.65454547091221],
                      [-96.58008726895902, 28.57908117710497],
                      [-96.40336722628746, 28.4350129798366],
                      [-96.65336143299356, 28.318386343952678],
                      [-97.02404249810954, 28.040540534935108],
                      [-97.18352156100828, 27.838159019724777],
                      [-97.42058503288476, 27.327059938939367],
                      [-97.51972066657856, 27.231014474093787],
                      [-97.44644650254402, 27.13153881407515],
                      [-97.54989238118104, 27.008051787845115],
                      [-97.35162111379343, 26.352884509791338],
                      [-97.30851866436133, 26.123061433196554],
                      [-97.14041911157618, 25.965272455235958],
                      [-97.42489527782797, 25.85550620969815],
                      [-97.6791997294773, 26.033876358697086],
                      [-98.22229059232163, 26.075038700773764],
                      [-98.36883892039074, 26.195095531830738],
                      [-98.6403843518129, 26.243118264253532],
                      [-98.79555316976843, 26.366605290483562],
                      [-99.08433958096342, 26.407767632560237],
                      [-99.1662342348844, 26.54154524430944],
                      [-99.24812888880537, 26.826251443673126],
                      [-99.46364113596582, 27.056074520267906],
                      [-99.43346942136336, 27.20700310788239],
                      [-99.49812309551149, 27.337350524458536],
                      [-99.5067435853979, 27.574033991399432],
                      [-99.70070460784231, 27.65978887072584],
                      [-99.86449391568425, 27.803857067994212],
                      [-99.87742465051387, 27.90333272801285],
                      [-100.07569591790148, 28.15373697564597],
                      [-100.2825876751755, 28.29780517291434],
                      [-100.39896428864216, 28.592801957797196],
                      [-100.62309702568902, 28.925530889583673],
                      [-100.67050972006432, 29.11762181927483],
                      [-100.81705804813342, 29.27198060206237],
                      [-101.16187764359015, 29.501803678657154],
                      [-101.40756160535305, 29.7659287069825],
                      [-101.97220369291342, 29.817381634578346],
                      [-102.11013153109612, 29.80366085388612],
                      [-102.30409255354051, 29.889415733212534],
                      [-102.40753843217753, 29.77621929250167],
                      [-102.6833941085429, 29.745347535944163],
                      [-102.88166537593051, 29.344014700696558],
                      [-103.14890056240947, 28.98384420752563],
                      [-103.29975913542178, 29.000995183390913],
                      [-103.67475044548097, 29.172504942043734],
                      [-103.79543730389082, 29.278840992408487],
                      [-104.05836224542657, 29.340584505523502],
                      [-104.26525400270059, 29.525815044868548],
                      [-104.53248918917954, 29.666453046963863],
                      [-104.67903751724864, 29.94086866080838],
                      [-104.68334776219186, 30.1912729084415],
                      [-105.00661613293252, 30.678360623015514],
                      [-105.36436646321887, 30.84987038166834],
                      [-105.59280944520894, 31.072833067917006],
                      [-105.76952948788052, 31.179169118281756],
                      [-106.006592959757, 31.395271414184315],
                      [-106.16607202265574, 31.44672434178016],
                      [-106.36003304510014, 31.71770976045162],
                      [-106.51520186305567, 31.772592883220522],
                      [-108.21343837068, 31.779453273566634],
                      [-108.21343837068, 31.326667510723183],
                      [-109.96770806256603, 31.326667510723183],
                      [-111.06682052308432, 31.333527901069296],
                      [-112.32541204650134, 31.728000345970788],
                      [-113.96330512492074, 32.235669231583145],
                      [-114.82104386861933, 32.49979425990849],
                      [-114.72621847986872, 32.71246636063799],
                      [-115.79515922578454, 32.63357187165769],
                      [-117.12702491323611, 32.530666016466],
                      [-117.25633226153238, 32.70217577511882],
                      [-117.25202201658918, 32.88397611929081],
                      [-117.32098593568053, 33.106938805539485],
                      [-117.51063671318171, 33.33676188213426],
                      [-118.09251978051492, 33.73123432703575],
                      [-118.38992668159634, 33.8375703774005],
                      [-118.54509549955186, 34.03995189261083],
                      [-118.93732778938387, 34.04338208778389],
                      [-119.21749371069247, 34.14628794297558],
                      [-119.26921665001096, 34.25605418851339],
                      [-119.61834649041089, 34.4207035568201],
                      [-119.87696118700343, 34.406982776127876],
                      [-120.13126563865276, 34.47215648441595],
                      [-120.47177498916626, 34.4515753133776],
                      [-120.64849503183784, 34.58535292512681],
                      [-120.60108233746253, 34.70540975618378],
                      [-120.67435650149709, 34.90779127139412],
                      [-120.64418478689463, 35.141044543161954],
                      [-120.89848923854396, 35.25081078869976],
                      [-120.8726277688847, 35.4051695714873],
                      [-121.00624536212418, 35.460052694256206],
                      [-121.26917030365992, 35.66586440463959],
                      [-121.48899279576358, 35.981442360560784],
                      [-121.89415582042523, 36.314171292347254],
                      [-121.94587875974374, 36.49254144134619],
                      [-121.79070994178821, 36.80468920209433],
                      [-121.93725826985731, 36.97962915592021],
                      [-122.15277051701776, 36.976198960747155],
                      [-122.40276472372388, 37.195731451822766],
                      [-122.39845447878066, 37.36038082012948],
                      [-122.51914133719052, 37.531890578782296],
                      [-122.3596622742918, 37.593634091897314],
                      [-122.14846027207454, 37.57991331120509],
                      [-122.48896962258806, 38.10473317268273],
                      [-122.52776182707694, 37.81659677814598],
                      [-122.91999411690895, 38.03612926922159],
                      [-122.97602730117067, 38.26595234581637],
                      [-123.64842551231126, 38.84908552523598],
                      [-123.82514555498284, 39.34646382532915],
                      [-123.76911237072112, 39.545415145366434],
                      [-123.8553172695853, 39.83355153990317],
                      [-124.11393196617783, 40.107967153747694],
                      [-124.36392617288395, 40.262325936535234],
                      [-124.41133886725925, 40.44412628070722],
                      [-124.21306759987164, 40.70139091868646],
                      [-124.10962172123463, 41.01353867943459],
                      [-124.12255245606426, 41.181618242914354],
                      [-124.06220902685932, 41.435452685720534],
                      [-124.21737784481485, 41.85050630166036],
                      [-124.21737784481485, 42.0048650844479],
                      [-124.35961592794075, 42.11463132998571],
                      [-124.4328900919753, 42.33073362588827],
                      [-124.41564911220246, 42.66346255767474],
                      [-124.54926670544194, 42.84526290184674],
                      [-124.44582082680492, 43.03049344119178],
                      [-124.37685690771357, 43.33921100676686],
                      [-124.27772127401977, 43.42153569092022],
                      [-124.15272417066672, 43.881181844109776],
                      [-124.06220902685932, 44.60838322079775],
                      [-124.06651927180253, 44.82448551670031],
                      [-123.97169388305194, 45.15378425331372],
                      [-123.97169388305194, 45.45221123336964],
                      [-123.91997094373343, 45.66145313892608],
                      [-123.98031437293835, 45.76092879894472],
                      [-123.93721192350627, 46.08336714521202],
                      [-123.86824800441492, 46.158831439019266],
                      [-123.61394355276559, 46.186273000403716],
                      [-123.69152796174336, 46.30632983146069],
                      [-123.92428118867664, 46.25144670869179],
                      [-124.06220902685932, 46.35778275905653],
                      [-123.89841971901738, 46.4401074432099],
                      [-123.911350453847, 46.72824383774663],
                      [-124.0923807414618, 46.74196461843886],
                      [-124.01479633248402, 46.98207828055281],
                      [-124.16996515043955, 47.040391598494764],
                      [-124.31651347850865, 47.355969554415964],
                      [-124.42426960208888, 47.74358160897134],
                      [-124.63978184924933, 47.90823097727805],
                      [-124.73460723799992, 48.16892581043034],
                      [-124.5751281751012, 48.37130732564067],
                      [-124.0492782920297, 48.17578620077646],
                      [-123.70014845162977, 48.165495615257285],
                      [-122.79068676861269, 48.08317093110392],
                      [-122.46741839787201, 47.757302389663565],
                      [-122.62689746077075, 47.69212868137549],
                      [-122.5062106023609, 47.520618922722676],
                      [-122.58379501133865, 47.33538838337762],
                      [-122.7993072584991, 47.20504096680148],
                      [-122.72172284952134, 47.08841433091756],
                      [-122.32518031474612, 47.37312053028124],
                      [-122.4113852136103, 47.64067575377965],
                      [-122.32087006980291, 47.94253292900862],
                      [-122.38983398889425, 48.30956381252565],
                      [-122.53207207202014, 48.374737520813724],
                      [-122.44155692821276, 48.58054923119711],
                      [-122.53207207202014, 48.76920996571522],
                      [-122.77344578883985, 48.88583660159914],
                      [-122.7518945641238, 48.992172651963884],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: '',
                  iso_a2: '',
                  name: 'South of Mexico nations',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-83.13212304614707, 14.995508291801439],
                      [-83.41228896745565, 14.827428728321673],
                      [-83.30022259893222, 14.77254560555277],
                      [-83.192466475352, 14.388363746170448],
                      [-83.21832794501125, 14.25115593924819],
                      [-83.4295299472285, 13.956159154365334],
                      [-83.49418362137664, 13.736626663289723],
                      [-83.57176803035439, 13.287271095619328],
                      [-83.50711435620624, 12.903089236237006],
                      [-83.58900901012723, 12.632103817565547],
                      [-83.76572905279879, 12.546348938239136],
                      [-83.66228317416179, 12.254782348529337],
                      [-83.71400611348028, 12.048970638145951],
                      [-83.83469297189014, 11.870600489147016],
                      [-83.70107537865066, 11.850019318108677],
                      [-83.65366268427536, 11.609905655994725],
                      [-83.76141880785559, 11.558452728398878],
                      [-83.86917493143581, 11.37322218905383],
                      [-83.83900321683333, 11.143399112459049],
                      [-83.69676513370746, 10.937587402075662],
                      [-83.66228317416179, 10.807239985499518],
                      [-83.93382860558394, 10.71805491100005],
                      [-84.02434374939133, 10.786658814461179],
                      [-84.67519073581587, 11.071365013824863],
                      [-84.9294951874652, 10.941017597248718],
                      [-85.63206511320827, 11.194852040054895],
                      [-85.70102903229962, 11.081655599344032],
                      [-85.7872339311638, 11.112527355901541],
                      [-85.92947201428969, 11.311478675938815],
                      [-86.33463503895132, 11.609905655994725],
                      [-86.49842434679327, 11.760834243609208],
                      [-86.79583124787469, 12.217050201625717],
                      [-87.07168692424005, 12.388559960278538],
                      [-87.45529872418567, 12.745300258276409],
                      [-87.64494950168685, 12.872217479679499],
                      [-87.58460607248193, 13.057448019024546],
                      [-87.4337474994696, 12.923670407275345],
                      [-87.31306064105976, 12.981983725217304],
                      [-87.62339827697082, 13.424478902541587],
                      [-87.81735929941522, 13.407327926676304],
                      [-87.80011831964237, 13.266689924580989],
                      [-87.92942566793865, 13.156923679043183],
                      [-88.20959158924722, 13.16035387421624],
                      [-88.46820628583976, 13.222097387331257],
                      [-88.78716441163724, 13.24610875354265],
                      [-89.2526708655038, 13.472501634964377],
                      [-89.80869246317775, 13.52738475773328],
                      [-89.83886417778021, 13.595988661194408],
                      [-90.09747887437274, 13.72976627294361],
                      [-90.39919602039737, 13.860113689519755],
                      [-90.70522341136521, 13.928717592980885],
                      [-90.91211516863925, 13.911566617115602],
                      [-91.3172781933009, 13.956159154365334],
                      [-91.7612334224514, 14.179121840614005],
                      [-92.24829110103403, 14.546152724131044],
                      [-92.16208620216983, 14.70394170209164],
                      [-92.15346571228342, 14.995508291801439],
                      [-92.07588130330566, 15.074402780781737],
                      [-92.20518865160193, 15.290505076684294],
                      [-91.75261293256499, 16.045148014756712],
                      [-91.72244121796253, 16.069159380968106],
                      [-90.48540091926156, 16.069159380968106],
                      [-90.39919602039737, 16.34700518998568],
                      [-90.6491902271035, 16.52880553415767],
                      [-90.73539512596767, 16.744907830060228],
                      [-91.06728398659476, 16.919847783886105],
                      [-91.29141672364163, 17.18740300738451],
                      [-90.9940098225602, 17.252576715672582],
                      [-90.989699577617, 17.801407943361614],
                      [-90.26126818221468, 17.81512872405384],
                      [-89.16215572169641, 17.81512872405384],
                      [-89.05008935317298, 18.000359263398884],
                      [-88.88198980038783, 17.887162822688023],
                      [-88.73544147231871, 18.051812190994735],
                      [-88.4897575105558, 18.484016782799845],
                      [-88.30441697799782, 18.48058658762679],
                      [-88.09321497578058, 18.116985899282806],
                      [-88.20959158924722, 17.88030243234191],
                      [-88.28286575328178, 17.581875452286],
                      [-88.23114281396327, 17.49612057295959],
                      [-88.3001067330546, 17.17711242186534],
                      [-88.21390183419044, 16.967870516308896],
                      [-88.28286575328178, 16.892406222501656],
                      [-88.30441697799782, 16.652292560387703],
                      [-88.5371702049311, 16.274971091351492],
                      [-88.73975171726192, 16.230378554101762],
                      [-88.74406196220514, 16.154914260294518],
                      [-88.92940249476312, 15.983404501641695],
                      [-88.91216151499029, 15.894219427142229],
                      [-88.6276853487385, 15.753581425046914],
                      [-88.44665506112372, 15.859917475411663],
                      [-88.22252232407686, 15.726139863662462],
                      [-88.11907644543984, 15.695268107104955],
                      [-87.9078744432226, 15.866777865757776],
                      [-87.72253391066462, 15.921660988526678],
                      [-87.51133190844737, 15.798173962296648],
                      [-87.34323235566222, 15.849626889892495],
                      [-86.87772590179566, 15.763872010566082],
                      [-86.47256287713401, 15.80503435264276],
                      [-86.33894528389453, 15.781022986431365],
                      [-86.20532769065505, 15.87363825610389],
                      [-85.99412568843782, 15.901079817488341],
                      [-85.90361054463042, 15.983404501641695],
                      [-85.70533927724281, 15.976544111295583],
                      [-85.48982703008238, 15.870208060930832],
                      [-85.25276355820588, 15.883928841623058],
                      [-84.99845910655655, 15.986834696814752],
                      [-84.67519073581587, 15.877068451276946],
                      [-84.65794975604305, 15.774162596085253],
                      [-84.29588918081349, 15.811894742988873],
                      [-84.02434374939133, 15.534048933971302],
                      [-84.08037693365304, 15.359108980145422],
                      [-83.90365689098148, 15.383120346356819],
                      [-83.7743495426852, 15.287074881511238],
                      [-83.40797872251244, 15.266493710472897],
                      [-83.25280990455693, 15.04353102422423],
                      [-83.13212304614707, 14.995508291801439],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SON',
                  iso_a2: 'MX',
                  name: 'Sonora',
                },
                geometry: {
                  type: 'MultiPolygon',
                  coordinates: [
                    [
                      [
                        [-114.82104386861933, 32.49979425990849],
                        [-113.96330512492074, 32.235669231583145],
                        [-112.32110180155813, 31.728000345970788],
                        [-111.06682052308432, 31.333527901069296],
                        [-109.96770806256603, 31.326667510723183],
                        [-109.04531564471932, 31.326667510723183],
                        [-108.96773123574155, 31.326667510723183],
                        [-109.04100539977611, 30.829289210629998],
                        [-108.58411943579597, 30.506850864362693],
                        [-108.53670674142066, 30.03691412565396],
                        [-108.60998090545522, 29.40918840898463],
                        [-108.70911653914902, 29.39889782346546],
                        [-108.62722188522805, 28.77117210679613],
                        [-108.6487731099441, 28.60652273848942],
                        [-108.54101698636387, 28.318386343952678],
                        [-108.65739359983051, 28.242922050145438],
                        [-109.07117711437857, 28.277224001876004],
                        [-109.14445127841313, 28.177748341857367],
                        [-109.01945417506006, 27.906762923185905],
                        [-108.90738780653663, 27.83472882455172],
                        [-108.77808045824037, 27.622056723822222],
                        [-108.67032433466014, 27.53630184449581],
                        [-108.64015262005768, 27.313339158247143],
                        [-108.67894482454656, 27.182991741670996],
                        [-108.46774282232931, 26.980610226460666],
                        [-108.5065350268182, 26.80224007746173],
                        [-109.14014103346992, 26.332303338752997],
                        [-109.25220740199336, 26.496952707059705],
                        [-109.54961430307478, 26.72677578365449],
                        [-109.69185238620067, 26.675322856058642],
                        [-109.8556416940426, 26.798809882288673],
                        [-109.91598512324754, 27.059504715440966],
                        [-110.2866661883635, 27.14868978994043],
                        [-110.55390137484245, 27.38194306170827],
                        [-110.62717553887701, 27.608335943129994],
                        [-110.58407308944491, 27.838159019724777],
                        [-110.80820582649179, 27.927344094224246],
                        [-111.06251027814112, 27.937634679743415],
                        [-111.2478508106991, 28.054261315627333],
                        [-111.47629379268918, 28.380129857067697],
                        [-111.70904701962246, 28.459024346047993],
                        [-111.89438755218045, 28.7814626923153],
                        [-112.15300224877298, 28.96326303648729],
                        [-112.26506861729641, 29.330293920004333],
                        [-112.50644233411612, 29.618430314541072],
                        [-112.68747262173089, 29.90999690425087],
                        [-112.75212629587902, 30.187842713268445],
                        [-112.87281315428888, 30.427956375382394],
                        [-113.0797049115629, 30.668070037496346],
                        [-113.12711760593821, 30.812138234764717],
                        [-113.04953319696044, 31.155157752070362],
                        [-113.11849711605178, 31.220331460358434],
                        [-113.54952161037268, 31.295795754165677],
                        [-113.65727773395291, 31.498177269376008],
                        [-113.87278998111336, 31.597652929394645],
                        [-114.02795879906887, 31.491316879029895],
                        [-114.16157639230835, 31.49474707420295],
                        [-114.93311023714276, 31.906370494969725],
                        [-114.9546614618588, 32.14305396191062],
                        [-115.04086636072299, 32.27683157365982],
                        [-114.90724876748351, 32.49293386956238],
                        [-114.82104386861933, 32.49979425990849],
                      ],
                    ],
                    [
                      [
                        [-112.27368910718283, 28.767741911623073],
                        [-112.58402674309387, 28.877508157160882],
                        [-112.48489110940007, 28.970123426833403],
                        [-112.43747841502477, 29.203376698601243],
                        [-112.28230959706924, 29.22395786963958],
                        [-112.19610469820506, 29.02157635442925],
                        [-112.27368910718283, 28.767741911623073],
                      ],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-BCN',
                  iso_a2: 'MX',
                  name: 'Baja California',
                },
                geometry: {
                  type: 'MultiPolygon',
                  coordinates: [
                    [
                      [
                        [-114.82104386861933, 32.49979425990849],
                        [-114.90724876748351, 32.49293386956238],
                        [-115.04086636072299, 32.27683157365982],
                        [-114.9546614618588, 32.14305396191062],
                        [-114.93311023714276, 31.906370494969725],
                        [-114.78225166413044, 31.655966247336604],
                        [-114.85121558322179, 31.529049025933514],
                        [-114.89000778771067, 31.162018142416475],
                        [-114.83397460344895, 31.007659359628935],
                        [-114.71759798998231, 30.942485651340863],
                        [-114.69604676526626, 30.63719828093884],
                        [-114.63139309111813, 30.424526180209337],
                        [-114.66156480572059, 30.18441251809539],
                        [-114.39432961924163, 29.783079682847784],
                        [-114.26933251588858, 29.772789097328612],
                        [-113.76934410247634, 29.40918840898463],
                        [-113.48055769128133, 28.94611206062201],
                        [-113.26073519917767, 28.83977601025726],
                        [-113.10125613627895, 28.503616883297727],
                        [-112.90298486889134, 28.476175321913278],
                        [-112.76074678576545, 27.99937819285843],
                        [-114.06244075861454, 28.002808388031486],
                        [-114.12709443276268, 28.256642830837663],
                        [-114.04088953389851, 28.459024346047993],
                        [-114.16588663725156, 28.6476850805661],
                        [-114.26933251588858, 28.657975666085267],
                        [-114.40295010912806, 28.860357181295598],
                        [-114.52794721248111, 28.925530889583673],
                        [-114.97190244163164, 29.378316652427124],
                        [-115.18310444384888, 29.42976958002297],
                        [-115.2865503224859, 29.532675435214664],
                        [-115.49775232470313, 29.61156992419496],
                        [-115.70033383703395, 29.75563812146333],
                        [-115.83395143027343, 30.34563169122904],
                        [-116.04946367743388, 30.47940930297824],
                        [-116.06670465720671, 30.812138234764717],
                        [-116.24773494482149, 30.95620643203309],
                        [-116.31238861896962, 31.14829736172425],
                        [-116.53221111107328, 31.439863951434045],
                        [-116.67444919419917, 31.55306039214491],
                        [-116.61841600993746, 31.854917567373878],
                        [-116.84254874698432, 31.98526498395002],
                        [-116.94599462562134, 32.24939001227537],
                        [-117.02788927954231, 32.27683157365982],
                        [-117.1227146682929, 32.530666016466],
                        [-115.79515922578454, 32.630141676484634],
                        [-114.72190823492552, 32.71246636063799],
                        [-114.82104386861933, 32.49979425990849],
                      ],
                    ],
                    [
                      [
                        [-113.13573809582462, 29.066168891678984],
                        [-113.23056348457521, 29.059308501332872],
                        [-113.58831381486156, 29.40918840898463],
                        [-113.47624744633814, 29.532675435214664],
                        [-113.35125034298507, 29.385177042773236],
                        [-113.18315079019992, 29.29256177310071],
                        [-113.13573809582462, 29.066168891678984],
                      ],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CHH',
                  iso_a2: 'MX',
                  name: 'Chihuahua',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-108.96773123574155, 31.326667510723183],
                      [-108.21774861562321, 31.326667510723183],
                      [-108.21774861562321, 31.776023078393578],
                      [-106.50658137316924, 31.769162688047466],
                      [-106.35572280015694, 31.71770976045162],
                      [-106.16176177771253, 31.44672434178016],
                      [-106.006592959757, 31.395271414184315],
                      [-105.76952948788052, 31.179169118281756],
                      [-105.59280944520894, 31.072833067917006],
                      [-105.36436646321887, 30.84987038166834],
                      [-105.00661613293252, 30.678360623015514],
                      [-104.68334776219186, 30.1912729084415],
                      [-104.68334776219186, 29.944298855981437],
                      [-104.53248918917954, 29.66988324213692],
                      [-104.2695642476438, 29.525815044868548],
                      [-104.05836224542657, 29.340584505523502],
                      [-103.79543730389082, 29.27541079723543],
                      [-103.3083796253082, 29.02500654960231],
                      [-103.96353685667596, 27.917053508705077],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.94198563195991, 26.761077735385054],
                      [-104.23508228809813, 26.723345588481433],
                      [-104.51955845434992, 26.37003548565662],
                      [-104.59714286332768, 26.349454314618278],
                      [-104.83420633520417, 26.486662121540537],
                      [-105.11868250145596, 26.55183582982861],
                      [-105.3298845036732, 26.459220560156083],
                      [-105.55832748566328, 26.57241700086695],
                      [-105.67901434407312, 26.69933422227004],
                      [-105.80832169236939, 26.692473831923923],
                      [-106.02814418447305, 26.83997222436535],
                      [-106.22641545186066, 26.558696220174724],
                      [-106.23072569680387, 26.428348803598578],
                      [-106.39882524958902, 26.383756266348843],
                      [-106.37727402487297, 26.129921823542666],
                      [-106.52382235294209, 25.99271401662041],
                      [-106.54537357765813, 25.78004191589091],
                      [-106.7220936203297, 25.63254352344948],
                      [-106.93760586749013, 25.64283410896865],
                      [-107.25656399328761, 25.869226990390377],
                      [-107.41604305618634, 26.129921823542666],
                      [-107.78672412130231, 26.215676702869075],
                      [-107.83413681567761, 26.5998585622514],
                      [-108.04533881789484, 26.932587494037875],
                      [-108.37291743357872, 27.076655691306247],
                      [-108.46774282232931, 26.980610226460666],
                      [-108.67894482454656, 27.182991741670996],
                      [-108.64015262005768, 27.313339158247143],
                      [-108.67032433466014, 27.53630184449581],
                      [-108.77808045824037, 27.622056723822222],
                      [-108.90738780653663, 27.83472882455172],
                      [-109.01945417506006, 27.906762923185905],
                      [-109.14445127841313, 28.177748341857367],
                      [-109.07117711437857, 28.277224001876004],
                      [-108.65739359983051, 28.242922050145438],
                      [-108.54101698636387, 28.318386343952678],
                      [-108.6487731099441, 28.60652273848942],
                      [-108.62722188522805, 28.77117210679613],
                      [-108.70911653914902, 29.39889782346546],
                      [-108.60998090545522, 29.40918840898463],
                      [-108.53670674142066, 30.03691412565396],
                      [-108.58411943579597, 30.506850864362693],
                      [-109.04100539977611, 30.829289210629998],
                      [-108.96773123574155, 31.326667510723183],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-COA',
                  iso_a2: 'MX',
                  name: 'Coahuila',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-103.3083796253082, 29.02500654960231],
                      [-103.14890056240947, 28.98384420752563],
                      [-102.88166537593051, 29.344014700696558],
                      [-102.6833941085429, 29.741917340771106],
                      [-102.40322818723432, 29.77621929250167],
                      [-102.30409255354051, 29.889415733212534],
                      [-102.11013153109612, 29.80366085388612],
                      [-101.97220369291342, 29.817381634578346],
                      [-101.41187185029627, 29.7659287069825],
                      [-101.16618788853336, 29.501803678657154],
                      [-100.81705804813342, 29.27198060206237],
                      [-100.66619947512112, 29.11762181927483],
                      [-100.62309702568902, 28.925530889583673],
                      [-100.39896428864216, 28.592801957797196],
                      [-100.28689792011872, 28.294374977741285],
                      [-100.07569591790148, 28.157167170819026],
                      [-99.80415048647932, 27.772985311436706],
                      [-99.96793979432127, 27.639207699687503],
                      [-100.1834520414817, 27.793566482475043],
                      [-100.33431061449403, 27.70095121280252],
                      [-100.43344624818783, 27.38194306170827],
                      [-100.62740727063223, 27.330490134112424],
                      [-100.8041273133038, 27.210433303055446],
                      [-100.55413310659767, 27.032063154056512],
                      [-100.58861506614335, 26.76450793055811],
                      [-100.75240437398529, 26.730205978827545],
                      [-101.21791082785185, 26.373465680829675],
                      [-100.84722976273588, 25.95498186971679],
                      [-100.84722976273588, 25.783472111063965],
                      [-100.57137408637051, 25.41301103237387],
                      [-100.30413889989156, 25.344407128912742],
                      [-100.25672620551626, 25.21062951716354],
                      [-100.53258188188164, 25.231210688201877],
                      [-100.76964535375812, 25.145455808875468],
                      [-100.83429902790625, 25.042549953683775],
                      [-100.77395559870133, 24.750983363973972],
                      [-100.82998878296306, 24.565752824628927],
                      [-101.09722396944201, 24.641217118436167],
                      [-101.19635960313582, 24.799006096396766],
                      [-101.46359478961477, 24.750983363973972],
                      [-101.58859189296783, 24.884760975723175],
                      [-101.7653119356394, 24.93964409849208],
                      [-101.86013732439, 25.076851905414337],
                      [-102.17478520524425, 25.16260678474075],
                      [-102.5842584748491, 25.124874637837127],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.81701170178238, 24.905342146761512],
                      [-102.84287317144164, 24.730402192935635],
                      [-103.25234644104648, 24.922493122626797],
                      [-103.27389766576253, 25.07342171024128],
                      [-103.50665089269582, 25.299814591663008],
                      [-103.42475623877485, 25.426731813066095],
                      [-103.48940991292298, 25.539928253776957],
                      [-103.31700011519462, 25.697717231737556],
                      [-103.34286158485386, 26.12649162836961],
                      [-103.28251815564894, 26.26369943529187],
                      [-103.32562060508104, 26.407767632560237],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.96353685667596, 27.917053508705077],
                      [-103.3083796253082, 29.02500654960231],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TAM',
                  iso_a2: 'MX',
                  name: 'Tamaulipas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.70932509772872, 27.670079456245013],
                      [-99.5067435853979, 27.574033991399432],
                      [-99.49812309551149, 27.337350524458536],
                      [-99.43346942136336, 27.210433303055446],
                      [-99.46364113596582, 27.056074520267906],
                      [-99.24812888880537, 26.826251443673126],
                      [-99.08433958096342, 26.407767632560237],
                      [-98.79555316976843, 26.366605290483562],
                      [-98.6403843518129, 26.243118264253532],
                      [-98.36883892039074, 26.195095531830738],
                      [-98.22229059232163, 26.075038700773764],
                      [-97.6791997294773, 26.033876358697086],
                      [-97.42489527782797, 25.85550620969815],
                      [-97.14041911157618, 25.965272455235958],
                      [-97.16197033629223, 25.725158793122006],
                      [-97.32144939919095, 25.388999666162476],
                      [-97.45937723737364, 25.17975776060603],
                      [-97.65333825981804, 24.51429989703308],
                      [-97.71799193396618, 24.010061206593782],
                      [-97.7697148732847, 23.25884846369442],
                      [-97.74385340362544, 22.974142264330737],
                      [-97.89040173169454, 22.624262356678976],
                      [-97.78264560811432, 22.270952253854162],
                      [-98.09298324402536, 22.373858109045855],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.93779125289431, 22.373858109045855],
                      [-99.24812888880537, 22.459612988372267],
                      [-99.37743623710163, 22.686005869793995],
                      [-99.5541562797732, 22.620832161505923],
                      [-99.98518077409409, 22.775190944293463],
                      [-99.91621685500274, 22.956991288465453],
                      [-100.05414469318544, 23.241697487829136],
                      [-100.04121395835581, 23.416637441655016],
                      [-99.83863244602499, 23.739075787922324],
                      [-99.5972587292053, 23.766517349306774],
                      [-99.46364113596582, 23.958608278997936],
                      [-99.61449970897813, 24.136978427996873],
                      [-99.57570750448924, 24.346220333553312],
                      [-99.653291913467, 24.637786923263114],
                      [-99.19640594948686, 24.877900585377063],
                      [-99.03261664164492, 25.118014247491015],
                      [-98.86882733380298, 25.097433076452674],
                      [-98.4464233293685, 25.42330161789304],
                      [-98.56279994283514, 25.502196106873335],
                      [-98.55848969789193, 25.97213284558207],
                      [-98.81279414954126, 26.057887724908483],
                      [-99.14899325511155, 26.085329286292932],
                      [-99.1705444798276, 26.28085041115715],
                      [-99.42053868653372, 26.400907242214124],
                      [-99.4162284415905, 26.623869928462796],
                      [-99.6058792190917, 26.730205978827545],
                      [-99.70070460784231, 26.89828554230731],
                      [-99.67915338312626, 27.134969009248206],
                      [-99.77828901682007, 27.481418721726907],
                      [-99.91190661005955, 27.570603796226376],
                      [-99.70932509772872, 27.670079456245013],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-NLE',
                  iso_a2: 'MX',
                  name: 'Nuevo León',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.80415048647932, 27.772985311436706],
                      [-99.70932509772872, 27.670079456245013],
                      [-99.91190661005955, 27.570603796226376],
                      [-99.77828901682007, 27.481418721726907],
                      [-99.67915338312626, 27.134969009248206],
                      [-99.70070460784231, 26.89828554230731],
                      [-99.6058792190917, 26.730205978827545],
                      [-99.4162284415905, 26.623869928462796],
                      [-99.42053868653372, 26.400907242214124],
                      [-99.1705444798276, 26.28085041115715],
                      [-99.14899325511155, 26.085329286292932],
                      [-98.81279414954126, 26.057887724908483],
                      [-98.55848969789193, 25.97213284558207],
                      [-98.56279994283514, 25.502196106873335],
                      [-98.4464233293685, 25.42330161789304],
                      [-98.86882733380298, 25.097433076452674],
                      [-99.03261664164492, 25.118014247491015],
                      [-99.19640594948686, 24.877900585377063],
                      [-99.653291913467, 24.637786923263114],
                      [-99.57570750448924, 24.346220333553312],
                      [-99.61449970897813, 24.136978427996873],
                      [-99.46364113596582, 23.958608278997936],
                      [-99.5972587292053, 23.766517349306774],
                      [-99.83863244602499, 23.739075787922324],
                      [-100.04121395835581, 23.416637441655016],
                      [-100.05414469318544, 23.241697487829136],
                      [-100.43775649313103, 23.22797670713691],
                      [-100.48516918750633, 23.821400472075677],
                      [-100.57999457625692, 23.931166717613486],
                      [-100.6101662908594, 24.2844768204383],
                      [-100.82998878296306, 24.565752824628927],
                      [-100.77395559870133, 24.750983363973972],
                      [-100.83429902790625, 25.042549953683775],
                      [-100.76964535375812, 25.145455808875468],
                      [-100.53258188188164, 25.231210688201877],
                      [-100.25672620551626, 25.21062951716354],
                      [-100.30413889989156, 25.344407128912742],
                      [-100.57137408637051, 25.41301103237387],
                      [-100.84722976273588, 25.783472111063965],
                      [-100.84722976273588, 25.95498186971679],
                      [-101.21791082785185, 26.373465680829675],
                      [-100.75240437398529, 26.730205978827545],
                      [-100.58861506614335, 26.76450793055811],
                      [-100.55413310659767, 27.032063154056512],
                      [-100.8041273133038, 27.210433303055446],
                      [-100.62740727063223, 27.330490134112424],
                      [-100.43344624818783, 27.38194306170827],
                      [-100.33431061449403, 27.70095121280252],
                      [-100.1834520414817, 27.793566482475043],
                      [-99.96793979432127, 27.639207699687503],
                      [-99.80415048647932, 27.772985311436706],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-ROO',
                  iso_a2: 'MX',
                  name: 'Quintana Roo',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-89.14922498686678, 17.952336530976098],
                      [-89.03284837340013, 18.20274077860922],
                      [-89.04146886328655, 18.490877173145957],
                      [-89.1104327823779, 18.693258688356288],
                      [-89.08026106777544, 18.960813911854693],
                      [-89.0112971486841, 19.218078549833926],
                      [-89.13629425203715, 19.403309089178975],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.36904747897043, 19.82179290029186],
                      [-89.20094792618528, 19.842374071330198],
                      [-88.91216151499029, 19.94871012169495],
                      [-88.70958000265946, 20.08248773344415],
                      [-88.44665506112372, 20.185393588635844],
                      [-88.22252232407686, 20.432367641095908],
                      [-88.01563056680283, 20.432367641095908],
                      [-87.67512121628931, 20.648469936998463],
                      [-87.53288313316341, 20.957187502573547],
                      [-87.58460607248193, 21.111546285361086],
                      [-87.524262643277, 21.30020701987919],
                      [-87.53719337810662, 21.499158339916463],
                      [-87.2397864770252, 21.44427521714756],
                      [-86.99841276020551, 21.567762243377594],
                      [-86.82600296247715, 21.43398463162839],
                      [-86.81307222764752, 21.204161555033608],
                      [-86.74410830855618, 21.162999212956933],
                      [-86.87341565685244, 20.854281647381853],
                      [-87.06737667929684, 20.62102837561401],
                      [-87.235476232082, 20.494111154210923],
                      [-87.44236798935603, 20.1888237838089],
                      [-87.47253970395849, 19.883536413406876],
                      [-87.62770852191402, 19.708596459580995],
                      [-87.66650072640289, 19.554237676793456],
                      [-87.42512700958319, 19.557667871966515],
                      [-87.72253391066462, 18.679537907664063],
                      [-87.7699466050399, 18.40512229381955],
                      [-88.08028424095096, 18.497737563492073],
                      [-88.00269983197319, 18.68982849318323],
                      [-88.101835465667, 18.803024933894093],
                      [-88.30441697799782, 18.48058658762679],
                      [-88.4897575105558, 18.4874469779729],
                      [-88.61475461390887, 18.247333315858953],
                      [-88.88198980038783, 17.887162822688023],
                      [-89.05008935317298, 18.000359263398884],
                      [-89.14922498686678, 17.952336530976098],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CAM',
                  iso_a2: 'MX',
                  name: 'Campeche',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-89.14922498686678, 17.952336530976098],
                      [-89.16215572169641, 17.81512872405384],
                      [-90.26126818221468, 17.81512872405384],
                      [-90.989699577617, 17.801407943361614],
                      [-90.989699577617, 17.96948750684138],
                      [-91.57158264495021, 18.10326511859058],
                      [-91.63192607415513, 17.952336530976098],
                      [-91.89054077074768, 17.966057311668322],
                      [-92.15346571228342, 18.168438826878653],
                      [-92.14915546734022, 18.463435611761508],
                      [-92.35604722461424, 18.456575221415395],
                      [-92.48535457291051, 18.648666151106553],
                      [-92.05864032353281, 18.7001190787024],
                      [-91.99398664938468, 18.538899905568748],
                      [-91.83019734154274, 18.477156392453733],
                      [-91.54572117529096, 18.44971483106928],
                      [-91.33451917307372, 18.573201857299313],
                      [-91.26555525398237, 18.734421030432966],
                      [-91.42934456182431, 18.881919422874393],
                      [-90.9379766382985, 19.16319542706502],
                      [-90.73108488102446, 19.375867527794522],
                      [-90.70953365630842, 19.68801528854266],
                      [-90.47678042937514, 19.921268560310498],
                      [-90.48971116420476, 20.5352734962876],
                      [-90.37764479568133, 20.826840085997397],
                      [-90.39057553051096, 20.548994276979826],
                      [-90.23971695749864, 20.511262130076204],
                      [-89.86903589238267, 20.267718272789196],
                      [-89.81300270812096, 20.137370856213053],
                      [-89.63197242050617, 20.017314025156075],
                      [-89.45525237783461, 19.777200363042127],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.13629425203715, 19.403309089178975],
                      [-89.0112971486841, 19.218078549833926],
                      [-89.08026106777544, 18.960813911854693],
                      [-89.1104327823779, 18.693258688356288],
                      [-89.04146886328655, 18.490877173145957],
                      [-89.03284837340013, 18.20274077860922],
                      [-89.14922498686678, 17.952336530976098],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TAB',
                  iso_a2: 'MX',
                  name: 'Tabasco',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-90.989699577617, 17.801407943361614],
                      [-90.989699577617, 17.252576715672582],
                      [-91.43365480676752, 17.252576715672582],
                      [-91.42934456182431, 17.389784522594837],
                      [-91.62761582921192, 17.51327154882487],
                      [-91.78709489211066, 17.846000480611345],
                      [-91.9982968943279, 17.904313798553307],
                      [-92.36466771450065, 17.695071892996864],
                      [-92.69655657512774, 17.386354327421785],
                      [-92.84310490319686, 17.41722608397929],
                      [-92.98965323126596, 17.561294281247662],
                      [-92.99396347620916, 17.907743993726363],
                      [-93.31292160200663, 17.962627116495266],
                      [-93.41205723570044, 17.636758575054905],
                      [-93.588777278372, 17.376063741902612],
                      [-93.61463874803125, 17.547573500555437],
                      [-93.73532560644111, 17.671060526785467],
                      [-93.93790711877193, 17.760245601284936],
                      [-94.07583495695462, 17.883732627514966],
                      [-94.04997348729536, 17.993498873052772],
                      [-94.13617838615954, 18.20960116895533],
                      [-93.4422289503029, 18.442854440723167],
                      [-92.93793029194745, 18.446284635896227],
                      [-92.68362584029812, 18.62465478489516],
                      [-92.48535457291051, 18.648666151106553],
                      [-92.35604722461424, 18.456575221415395],
                      [-92.14915546734022, 18.463435611761508],
                      [-92.15346571228342, 18.168438826878653],
                      [-91.89054077074768, 17.966057311668322],
                      [-91.63192607415513, 17.952336530976098],
                      [-91.57158264495021, 18.10326511859058],
                      [-90.989699577617, 17.96948750684138],
                      [-90.989699577617, 17.801407943361614],
                    ],
                  ],
                },
              },
              value: 6008527.58,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CHP',
                  iso_a2: 'MX',
                  name: 'Chiapas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-91.43365480676752, 17.252576715672582],
                      [-91.29141672364163, 17.190833202557563],
                      [-91.06297374165155, 16.919847783886105],
                      [-90.73539512596767, 16.748338025233284],
                      [-90.6491902271035, 16.52880553415767],
                      [-90.39488577545416, 16.34700518998568],
                      [-90.45091895971589, 16.079449966487275],
                      [-90.9940098225602, 16.069159380968106],
                      [-91.72244121796253, 16.069159380968106],
                      [-92.10605301790812, 15.455154444991003],
                      [-92.20518865160193, 15.235621953915391],
                      [-92.07157105836245, 15.074402780781737],
                      [-92.15346571228342, 14.995508291801439],
                      [-92.15777595722663, 14.700511506918584],
                      [-92.24829110103403, 14.546152724131044],
                      [-92.70086682007096, 14.998938486974495],
                      [-92.82586392342401, 15.173878440800374],
                      [-92.98103274137954, 15.266493710472897],
                      [-93.22671670314244, 15.503177177413793],
                      [-93.65343095252014, 15.839336304373326],
                      [-93.94652760865834, 16.010846063026147],
                      [-94.08445544684103, 16.148053869948406],
                      [-94.03704275246574, 16.271540896178436],
                      [-94.12324765132992, 16.508224363119332],
                      [-94.03704275246574, 16.662583145906872],
                      [-94.02842226257931, 16.813511733521356],
                      [-93.90773540416947, 16.882115636982483],
                      [-93.8732534446238, 17.14967086048089],
                      [-93.588777278372, 17.376063741902612],
                      [-93.41205723570044, 17.636758575054905],
                      [-93.31292160200663, 17.962627116495266],
                      [-92.99396347620916, 17.907743993726363],
                      [-92.98965323126596, 17.561294281247662],
                      [-92.84310490319686, 17.41722608397929],
                      [-92.69655657512774, 17.386354327421785],
                      [-92.36466771450065, 17.695071892996864],
                      [-91.9982968943279, 17.904313798553307],
                      [-91.78709489211066, 17.846000480611345],
                      [-91.62761582921192, 17.51327154882487],
                      [-91.42934456182431, 17.389784522594837],
                      [-91.43365480676752, 17.252576715672582],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-COL',
                  iso_a2: 'MX',
                  name: 'Colima',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-103.7394041196291, 18.693258688356288],
                      [-103.97646759150558, 18.87505903252828],
                      [-104.32990767684872, 19.02255742496971],
                      [-104.35576914650798, 19.111742499469173],
                      [-104.59283261838448, 19.149474646372795],
                      [-104.53679943412276, 19.248950306391436],
                      [-104.21353106338208, 19.32098440502562],
                      [-104.1230159195747, 19.471912992640103],
                      [-103.83422950837969, 19.399878894005916],
                      [-103.63595824099208, 19.485633773332328],
                      [-103.49372015786619, 19.314124014679507],
                      [-103.52389187246865, 19.091161328430836],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.7394041196291, 18.693258688356288],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-NAY',
                  iso_a2: 'MX',
                  name: 'Nayarit',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.29109229918433, 20.686202083902085],
                      [-105.51091479128797, 20.771956963228497],
                      [-105.30833327895715, 21.032651796380787],
                      [-105.2350591149226, 21.06009335776524],
                      [-105.24367960480902, 21.341369361955866],
                      [-105.18764642054731, 21.44427521714756],
                      [-105.41608940253738, 21.602064195108156],
                      [-105.63160164969783, 21.95537429793297],
                      [-105.65315287441388, 22.25380127798888],
                      [-105.72211679350522, 22.511065915968114],
                      [-105.46350209691268, 22.49734513527589],
                      [-105.48505332162873, 22.686005869793995],
                      [-105.57125822049291, 22.788911724985688],
                      [-105.39022793287813, 23.032455582272696],
                      [-105.13161323628559, 23.015304606407412],
                      [-104.9462727037276, 22.915828946388775],
                      [-104.88592927452268, 22.788911724985688],
                      [-104.9936853981029, 22.675715284274823],
                      [-104.97213417338686, 22.541937672525624],
                      [-104.77386290599924, 22.675715284274823],
                      [-104.66610678241902, 22.624262356678976],
                      [-104.58852237344126, 22.459612988372267],
                      [-104.33421792179193, 22.47676396423755],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.32990767684872, 22.26409186350805],
                      [-104.39887159594007, 22.085721714509113],
                      [-104.09715444991544, 21.783864539280145],
                      [-104.20922081843887, 21.5197395109548],
                      [-103.94198563195991, 21.375671313686432],
                      [-103.9807778364488, 21.27276545849474],
                      [-104.2221515532685, 21.169859603303046],
                      [-104.20922081843887, 20.97090828326577],
                      [-104.28680522741664, 20.706783254940426],
                      [-104.73076045656715, 21.008640430169393],
                      [-105.09282103179672, 20.916025160496865],
                      [-105.29109229918433, 20.686202083902085],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-BCS',
                  iso_a2: 'MX',
                  name: 'Baja California Sur',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-114.06244075861454, 28.002808388031486],
                      [-112.76074678576545, 27.99937819285843],
                      [-112.76936727565186, 27.86560058110923],
                      [-112.60126772286671, 27.656358675552784],
                      [-112.37282474087664, 27.563743405880263],
                      [-112.15731249371619, 27.16241057063266],
                      [-112.01076416564709, 27.117818033382925],
                      [-112.01507441059029, 26.97718003128761],
                      [-111.81680314320268, 26.89828554230731],
                      [-111.56249869155336, 26.69590402709698],
                      [-111.57111918143977, 26.575847196040005],
                      [-111.32112497473365, 26.075038700773764],
                      [-111.35991717922253, 25.965272455235958],
                      [-111.30819423990403, 25.78004191589091],
                      [-111.02371807365223, 25.4576035696236],
                      [-110.90303121524238, 25.145455808875468],
                      [-110.75648288717328, 25.011678197126265],
                      [-110.65734725347947, 24.80586648674288],
                      [-110.73924190740044, 24.555462239109758],
                      [-110.68320872313873, 24.35994111424554],
                      [-110.56252186472888, 24.212442721804113],
                      [-110.40304280183014, 24.17471057490049],
                      [-110.17459981984007, 24.25017486870773],
                      [-110.01943100188454, 24.16785018455438],
                      [-109.98925928728208, 24.044363158324344],
                      [-109.69616263114388, 23.80081930103734],
                      [-109.67892165137104, 23.649890713422856],
                      [-109.47634013904022, 23.560705638923388],
                      [-109.42461719972171, 23.296580610598042],
                      [-109.53237332330194, 23.107919876079936],
                      [-109.7090933659735, 23.029025387099637],
                      [-109.89443389853149, 22.874666604312097],
                      [-110.09701541086231, 23.015304606407412],
                      [-110.17028957489686, 23.32059197680944],
                      [-110.30821741307955, 23.543554663058103],
                      [-110.5754525995585, 23.684192665153418],
                      [-111.04095905342507, 24.102676476266307],
                      [-111.4418118331435, 24.32220896734192],
                      [-111.67887530502, 24.586333995667268],
                      [-111.84697485780515, 24.654937899128395],
                      [-111.96766171621499, 24.778424925358426],
                      [-112.08834857462485, 24.771564535012313],
                      [-112.14438175888657, 25.08714249093351],
                      [-112.07541783979522, 25.258652249586326],
                      [-112.07541783979522, 25.714868207602837],
                      [-112.20041494314827, 25.996144211793464],
                      [-112.34265302627418, 26.177944555965457],
                      [-112.72626482621978, 26.37003548565662],
                      [-113.06246393179006, 26.5998585622514],
                      [-113.14435858571105, 26.757647540211998],
                      [-113.5064191609406, 26.795379687115616],
                      [-113.63572650923686, 26.72677578365449],
                      [-113.81675679685164, 26.949738469903156],
                      [-114.00640757435283, 26.97718003128761],
                      [-114.11416369793305, 27.107527447863752],
                      [-114.48484476304903, 27.2378748644399],
                      [-114.50639598776507, 27.405954427919664],
                      [-114.73052872481193, 27.51915086863053],
                      [-114.88569754276746, 27.694090822456406],
                      [-114.92448974725633, 27.83472882455172],
                      [-114.49777549787865, 27.776415506609762],
                      [-114.3253657001503, 27.8758911666284],
                      [-114.2822632507182, 27.735253164533084],
                      [-114.10554320804664, 27.70781160314863],
                      [-114.20898908668366, 28.002808388031486],
                      [-114.14864565747872, 28.002808388031486],
                      [-114.09692271816022, 28.002808388031486],
                      [-114.07106124850097, 28.002808388031486],
                      [-114.06244075861454, 28.002808388031486],
                    ],
                  ],
                },
              },
              value: 635999.48,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SIN',
                  iso_a2: 'MX',
                  name: 'Sinaloa',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.72211679350522, 22.511065915968114],
                      [-105.79970120248298, 22.6379831373712],
                      [-106.03245442941626, 22.830074067062363],
                      [-106.22210520691746, 23.053036753311034],
                      [-106.4333072091347, 23.23140690230997],
                      [-106.52382235294209, 23.406346856135848],
                      [-106.79105753942103, 23.63273973755757],
                      [-106.90312390794446, 23.84541183828707],
                      [-107.03674150118394, 23.979189450036273],
                      [-107.37725085169745, 24.205582331458],
                      [-107.62293481346036, 24.45598657909112],
                      [-107.82120608084799, 24.59319438601338],
                      [-107.99792612351955, 24.64807750878228],
                      [-108.03671832800842, 24.78528531570454],
                      [-108.18757690102075, 24.98766683091487],
                      [-108.10568224709976, 25.118014247491015],
                      [-108.33412522908984, 25.16260678474075],
                      [-108.45050184255649, 25.2689428351055],
                      [-108.8901468267638, 25.48847532618111],
                      [-109.11858980875388, 25.536498058603904],
                      [-109.17031274807238, 25.64626430414171],
                      [-109.43754793455133, 25.793762696583137],
                      [-109.43323768960813, 26.023585773177917],
                      [-109.29530985142544, 26.236257873907416],
                      [-109.28668936153902, 26.239688069080472],
                      [-109.23065617727731, 26.26369943529187],
                      [-109.15738201324275, 26.308291972541603],
                      [-109.14014103346992, 26.332303338752997],
                      [-108.5065350268182, 26.80224007746173],
                      [-108.46774282232931, 26.980610226460666],
                      [-108.37291743357872, 27.076655691306247],
                      [-108.04533881789484, 26.932587494037875],
                      [-107.83413681567761, 26.5998585622514],
                      [-107.78672412130231, 26.215676702869075],
                      [-107.41604305618634, 26.129921823542666],
                      [-107.25656399328761, 25.869226990390377],
                      [-106.93760586749013, 25.64283410896865],
                      [-107.09708493038887, 25.419871422719982],
                      [-107.12725664499133, 25.190048346125202],
                      [-107.03674150118394, 24.922493122626797],
                      [-106.75657557987537, 24.702960631551186],
                      [-106.59278627203342, 24.37023169976471],
                      [-106.40313549453224, 24.287907015611353],
                      [-106.19193349231499, 24.387382675629993],
                      [-106.05400565413231, 24.2844768204383],
                      [-105.94624953055208, 24.075234914881854],
                      [-105.89883683617678, 23.715064421710927],
                      [-105.7134963036188, 23.464660174077807],
                      [-105.68763483395955, 23.296580610598042],
                      [-105.39022793287813, 23.032455582272696],
                      [-105.57125822049291, 22.788911724985688],
                      [-105.48505332162873, 22.686005869793995],
                      [-105.46350209691268, 22.49734513527589],
                      [-105.72211679350522, 22.511065915968114],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-YUC',
                  iso_a2: 'MX',
                  name: 'Yucatán',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-90.37764479568133, 20.826840085997397],
                      [-90.33023210130602, 21.032651796380787],
                      [-90.09747887437274, 21.162999212956933],
                      [-89.7871412384617, 21.286486239186964],
                      [-89.12336351720752, 21.361950532994207],
                      [-88.70526975771625, 21.457995997839788],
                      [-88.45096530606693, 21.574622633723706],
                      [-88.28286575328178, 21.55747165785842],
                      [-88.12769693532626, 21.61578497580038],
                      [-87.53719337810662, 21.499158339916463],
                      [-87.524262643277, 21.30020701987919],
                      [-87.58460607248193, 21.111546285361086],
                      [-87.53288313316341, 20.957187502573547],
                      [-87.67512121628931, 20.648469936998463],
                      [-88.01563056680283, 20.432367641095908],
                      [-88.22252232407686, 20.432367641095908],
                      [-88.44665506112372, 20.185393588635844],
                      [-88.70958000265946, 20.08248773344415],
                      [-88.91216151499029, 19.94871012169495],
                      [-89.20094792618528, 19.842374071330198],
                      [-89.36904747897043, 19.82179290029186],
                      [-89.41646017334574, 19.650283141639036],
                      [-89.45525237783461, 19.777200363042127],
                      [-89.63197242050617, 20.017314025156075],
                      [-89.81300270812096, 20.137370856213053],
                      [-89.86903589238267, 20.267718272789196],
                      [-90.23971695749864, 20.511262130076204],
                      [-90.39057553051096, 20.548994276979826],
                      [-90.37764479568133, 20.826840085997397],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-VER',
                  iso_a2: 'MX',
                  name: 'Veracruz',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-97.78264560811432, 22.270952253854162],
                      [-97.76109438339827, 22.096012300028285],
                      [-97.61023581038596, 21.835317466875996],
                      [-97.65764850476126, 21.63636614683872],
                      [-97.49816944186253, 21.399682679897825],
                      [-97.1964522958379, 20.80968911013212],
                      [-97.1490396014626, 20.648469936998463],
                      [-96.67491265770961, 20.15795202725139],
                      [-96.45509016560595, 19.869815632714648],
                      [-96.27837012293439, 19.314124014679507],
                      [-95.97665297690976, 19.056859376700274],
                      [-95.85165587355671, 18.717270054567685],
                      [-95.73096901514685, 18.75843239664436],
                      [-95.49821578821357, 18.706979469048516],
                      [-95.20511913207537, 18.710409664221572],
                      [-95.00253761974454, 18.556050881434032],
                      [-94.80857659730015, 18.521748929703467],
                      [-94.58444386025327, 18.18901999791699],
                      [-94.46806724678663, 18.14442746066726],
                      [-94.13617838615954, 18.20960116895533],
                      [-94.04997348729536, 17.993498873052772],
                      [-94.07583495695462, 17.883732627514966],
                      [-93.93790711877193, 17.760245601284936],
                      [-93.73532560644111, 17.671060526785467],
                      [-93.61463874803125, 17.547573500555437],
                      [-93.588777278372, 17.376063741902612],
                      [-93.8732534446238, 17.14967086048089],
                      [-94.93788394559641, 17.21484456876896],
                      [-95.30856501071239, 17.674490721958524],
                      [-95.610282156737, 17.516701743997928],
                      [-95.79562268929499, 17.537282915036265],
                      [-95.91199930276163, 17.780826772323273],
                      [-95.77407146457895, 17.996929068225832],
                      [-95.83872513872709, 18.120416094455862],
                      [-96.10596032520604, 18.14442746066726],
                      [-96.22664718361588, 18.19931058343616],
                      [-96.41198771617387, 18.538899905568748],
                      [-96.59732824873186, 18.610934004202935],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.79990976106268, 18.552620686260973],
                      [-96.98525029362067, 18.514888539357354],
                      [-97.12748837674656, 18.638375565587385],
                      [-97.30851866436133, 18.68296810283712],
                      [-97.33006988907738, 18.809885324240206],
                      [-97.22662401044036, 18.9127911794319],
                      [-97.26541621492925, 19.159765231891967],
                      [-97.11024739697372, 19.176916207757248],
                      [-96.98094004867745, 19.286682453295054],
                      [-97.22662401044036, 19.3381353808909],
                      [-97.3904133182823, 19.574818847831796],
                      [-97.30851866436133, 19.89039680375299],
                      [-97.1533498464058, 20.144231246559166],
                      [-97.40334405311194, 20.25742768727003],
                      [-97.54127189129461, 20.137370856213053],
                      [-97.7740251182279, 20.274578663135312],
                      [-97.7697148732847, 20.43922803144202],
                      [-97.55851287106745, 20.504401739730092],
                      [-97.77833536317111, 20.81311930530517],
                      [-97.89902222158096, 20.80625891495906],
                      [-97.99815785527477, 20.483820568691755],
                      [-98.0197090799908, 20.658760522517632],
                      [-98.11453446874141, 20.68963227907514],
                      [-98.33866720578827, 20.432367641095908],
                      [-98.49814626868701, 20.363763737634777],
                      [-98.57142043272155, 20.473529983172583],
                      [-98.43780283948207, 20.675911498382916],
                      [-98.39470039004999, 20.878293013593247],
                      [-98.23091108220805, 20.936606331535206],
                      [-98.13177544851425, 21.070383943284405],
                      [-98.21367010243522, 21.15270862743776],
                      [-98.41194136982283, 21.176719993649158],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.6403843518129, 21.608924585454268],
                      [-98.48952577880058, 21.75299278272264],
                      [-98.37314916533394, 22.26409186350805],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.09298324402536, 22.373858109045855],
                      [-97.78264560811432, 22.270952253854162],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-JAL',
                  iso_a2: 'MX',
                  name: 'Jalisco',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-104.59283261838448, 19.149474646372795],
                      [-104.80834486554491, 19.228369135353095],
                      [-105.01523662281895, 19.36900713744841],
                      [-105.08420054191029, 19.561098067139568],
                      [-105.24798984975223, 19.66743411750432],
                      [-105.52384552611761, 20.03446500102136],
                      [-105.55401724072007, 20.202544564501125],
                      [-105.69625532384596, 20.40835627488451],
                      [-105.5755684654361, 20.48725076386481],
                      [-105.3298845036732, 20.514692325249264],
                      [-105.29109229918433, 20.686202083902085],
                      [-105.09282103179672, 20.916025160496865],
                      [-104.73076045656715, 21.008640430169393],
                      [-104.28680522741664, 20.706783254940426],
                      [-104.20922081843887, 20.97090828326577],
                      [-104.2221515532685, 21.169859603303046],
                      [-103.9807778364488, 21.27276545849474],
                      [-103.94198563195991, 21.375671313686432],
                      [-104.20922081843887, 21.5197395109548],
                      [-104.09715444991544, 21.783864539280145],
                      [-104.39887159594007, 22.085721714509113],
                      [-104.32990767684872, 22.26409186350805],
                      [-103.94629587690312, 22.377288304218915],
                      [-103.9807778364488, 22.771760749120403],
                      [-103.77819632411797, 22.73745879738984],
                      [-103.85147048815253, 22.565949038737017],
                      [-103.61009677133282, 22.524786696660342],
                      [-103.68337093536738, 22.32240518145001],
                      [-103.67906069042417, 22.137174642104963],
                      [-103.48940991292298, 22.133744446931907],
                      [-103.36010256462671, 22.349846742834462],
                      [-103.37303329945634, 22.51449611114117],
                      [-103.04545468377245, 22.25380127798888],
                      [-103.15752105229589, 21.996536640009648],
                      [-103.28682840059216, 21.98624605449048],
                      [-103.52389187246865, 21.818166491010714],
                      [-103.51958162752544, 21.602064195108156],
                      [-103.66612995559454, 21.488867754397294],
                      [-103.7437143645723, 21.296776824706132],
                      [-103.59285579156, 21.19387096951444],
                      [-103.23079521633043, 21.080674528803577],
                      [-103.04545468377245, 21.073814138457465],
                      [-103.05407517365887, 21.265905068148626],
                      [-102.91183709053297, 21.283056044013907],
                      [-102.6833941085429, 21.399682679897825],
                      [-102.64029165911082, 21.567762243377594],
                      [-102.77821949729349, 21.608924585454268],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.23081838950597, 21.6775284889154],
                      [-101.84720658956036, 22.01711781104799],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.53686895364932, 21.63636614683872],
                      [-101.64031483228634, 21.516309315781747],
                      [-101.57135091319499, 21.34822975230198],
                      [-101.85582707944678, 21.149278432264705],
                      [-102.04547785694797, 20.87143262324713],
                      [-102.08427006143685, 20.727364425978763],
                      [-101.98082418279984, 20.55585466732594],
                      [-102.10151104120969, 20.387775103846174],
                      [-102.49805357598491, 20.31231081003893],
                      [-102.67477361865649, 20.21969554036641],
                      [-103.04976492871566, 20.12021988034777],
                      [-103.03683419388604, 19.96929129273329],
                      [-102.7739092523503, 19.955570512041064],
                      [-102.80839121189597, 19.82179290029186],
                      [-102.73942729280462, 19.58167923817791],
                      [-102.54977651530342, 19.38615811331369],
                      [-102.65753263888365, 19.23179933052615],
                      [-102.88166537593051, 19.2043577691417],
                      [-102.98942149951074, 19.056859376700274],
                      [-103.118728847807, 19.005406449104427],
                      [-103.29544889047858, 19.0465687911811],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.52389187246865, 19.091161328430836],
                      [-103.49372015786619, 19.314124014679507],
                      [-103.63595824099208, 19.485633773332328],
                      [-103.83422950837969, 19.399878894005916],
                      [-104.1230159195747, 19.471912992640103],
                      [-104.21353106338208, 19.32098440502562],
                      [-104.53679943412276, 19.248950306391436],
                      [-104.59283261838448, 19.149474646372795],
                    ],
                  ],
                },
              },
              value: 6735074.87,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MIC',
                  iso_a2: 'MX',
                  name: 'Michoacán',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-102.17047496030104, 17.921464774418588],
                      [-102.74373753774782, 18.068963166860016],
                      [-103.02390345905641, 18.185589802743934],
                      [-103.36441280956991, 18.264484291724234],
                      [-103.49803040280939, 18.33308819518536],
                      [-103.7394041196291, 18.693258688356288],
                      [-103.47647917809334, 18.967674302200805],
                      [-103.29544889047858, 19.0465687911811],
                      [-103.118728847807, 19.005406449104427],
                      [-102.98942149951074, 19.056859376700274],
                      [-102.88166537593051, 19.2043577691417],
                      [-102.65753263888365, 19.23179933052615],
                      [-102.54977651530342, 19.38615811331369],
                      [-102.73942729280462, 19.58167923817791],
                      [-102.80839121189597, 19.82179290029186],
                      [-102.7739092523503, 19.955570512041064],
                      [-103.03683419388604, 19.96929129273329],
                      [-103.04976492871566, 20.12021988034777],
                      [-102.67477361865649, 20.21969554036641],
                      [-102.49805357598491, 20.31231081003893],
                      [-102.10151104120969, 20.387775103846174],
                      [-101.95065246819738, 20.363763737634777],
                      [-101.90755001876529, 20.202544564501125],
                      [-101.69203777160484, 20.202544564501125],
                      [-101.61014311768388, 20.319171200385043],
                      [-101.386010380637, 20.288299443827537],
                      [-101.42049234018268, 20.051615976886644],
                      [-101.19635960313582, 20.03446500102136],
                      [-101.01963956046424, 19.94871012169495],
                      [-100.73085314926925, 19.934989341002723],
                      [-100.39465404369895, 19.96586109756023],
                      [-100.39896428864216, 20.07219714792498],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.12310861227678, 19.93841953617578],
                      [-100.21362375608417, 19.564528262312628],
                      [-100.15759057182245, 19.420460065044256],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.79119657847417, 18.782443762855756],
                      [-100.73516339421245, 18.508028149011242],
                      [-101.25670303234074, 18.538899905568748],
                      [-101.49376650421723, 18.477156392453733],
                      [-101.64462507722955, 18.580062247645426],
                      [-101.83858609967395, 18.57663205247237],
                      [-101.87737830416283, 18.319367414493136],
                      [-101.94203197831096, 18.206170973782275],
                      [-102.15754422547141, 18.16157843653254],
                      [-102.17047496030104, 17.921464774418588],
                    ],
                  ],
                },
              },
              value: 7592901.56,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-GRO',
                  iso_a2: 'MX',
                  name: 'Guerrero',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.55417945294872, 16.319563628601227],
                      [-98.77831218999559, 16.556247095542123],
                      [-98.85589659897335, 16.525375338984613],
                      [-99.37312599215842, 16.66601334107993],
                      [-99.73949681233118, 16.731187049368003],
                      [-99.9894910190373, 16.909557198366937],
                      [-101.01101907057783, 17.252576715672582],
                      [-101.18342886830618, 17.413795888806234],
                      [-101.45497429972835, 17.52356213434404],
                      [-101.64462507722955, 17.66763033161241],
                      [-101.80841438507149, 17.89059301786108],
                      [-102.03254712211834, 17.99006867787972],
                      [-102.17047496030104, 17.921464774418588],
                      [-102.15754422547141, 18.16157843653254],
                      [-101.94203197831096, 18.206170973782275],
                      [-101.87737830416283, 18.319367414493136],
                      [-101.83858609967395, 18.57663205247237],
                      [-101.64462507722955, 18.580062247645426],
                      [-101.49376650421723, 18.477156392453733],
                      [-101.25670303234074, 18.538899905568748],
                      [-100.73516339421245, 18.508028149011242],
                      [-100.79119657847417, 18.782443762855756],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.45499747290387, 18.844187275970775],
                      [-100.43344624818783, 18.6452359559335],
                      [-100.2739671852891, 18.39140151312732],
                      [-100.07138567295827, 18.60750380902988],
                      [-99.7481173022176, 18.693258688356288],
                      [-99.66191240335343, 18.76186259181742],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.33002354272634, 18.45314502624234],
                      [-99.14037276522514, 18.497737563492073],
                      [-99.04985762141774, 18.350239171050646],
                      [-99.03261664164492, 18.250763511032005],
                      [-98.79124292482521, 18.03466121512945],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.39039014510678, 17.640188770227958],
                      [-98.33435696084507, 17.334901399825938],
                      [-98.14901642828708, 17.21484456876896],
                      [-98.00246810021798, 17.026183834250855],
                      [-98.07143201930933, 16.77920978179079],
                      [-98.23953157209446, 16.700315292810494],
                      [-98.33435696084507, 16.56653768106129],
                      [-98.32573647095865, 16.4396204596582],
                      [-98.55417945294872, 16.319563628601227],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-OAX',
                  iso_a2: 'MX',
                  name: 'Oaxaca',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.55417945294872, 16.319563628601227],
                      [-98.32573647095865, 16.4396204596582],
                      [-98.33435696084507, 16.56653768106129],
                      [-98.23953157209446, 16.700315292810494],
                      [-98.07143201930933, 16.77920978179079],
                      [-98.00246810021798, 17.026183834250855],
                      [-98.14901642828708, 17.21484456876896],
                      [-98.33435696084507, 17.334901399825938],
                      [-98.39039014510678, 17.640188770227958],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.17487789794633, 18.01751023926417],
                      [-97.92488369124021, 18.038091410302506],
                      [-97.7266124238526, 18.302216438627852],
                      [-97.63609728004522, 18.17186902205171],
                      [-97.42489527782797, 17.99006867787972],
                      [-97.31282890930454, 18.14442746066726],
                      [-97.02835274305275, 18.12384628962892],
                      [-96.79128927117625, 18.281635267589515],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.59732824873186, 18.610934004202935],
                      [-96.41198771617387, 18.538899905568748],
                      [-96.22664718361588, 18.19931058343616],
                      [-96.10596032520604, 18.14442746066726],
                      [-95.83872513872709, 18.120416094455862],
                      [-95.77407146457895, 17.996929068225832],
                      [-95.91199930276163, 17.780826772323273],
                      [-95.79562268929499, 17.537282915036265],
                      [-95.610282156737, 17.516701743997928],
                      [-95.30856501071239, 17.674490721958524],
                      [-94.93788394559641, 17.21484456876896],
                      [-93.8732534446238, 17.14967086048089],
                      [-93.90773540416947, 16.882115636982483],
                      [-94.02842226257931, 16.813511733521356],
                      [-94.03704275246574, 16.662583145906872],
                      [-94.12324765132992, 16.508224363119332],
                      [-94.03704275246574, 16.271540896178436],
                      [-94.08445544684103, 16.148053869948406],
                      [-94.09307593672744, 16.09660094235256],
                      [-94.1146271614435, 16.058868795448937],
                      [-94.44220577712738, 16.185786016852028],
                      [-94.65340777934462, 16.36415616585096],
                      [-94.76116390292484, 16.292122067216777],
                      [-94.85167904673223, 16.429329874139036],
                      [-95.23098060173461, 16.158344455467574],
                      [-95.43356211406544, 15.976544111295583],
                      [-95.95941199713693, 15.829045718854156],
                      [-96.2352676735023, 15.681547326412728],
                      [-96.55853604424297, 15.660966155374389],
                      [-96.84732245543798, 15.733000254008575],
                      [-97.26541621492925, 15.935381769218905],
                      [-97.7740251182279, 15.97997430646864],
                      [-98.12315495862782, 16.20979738306342],
                      [-98.55417945294872, 16.319563628601227],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MEX',
                  iso_a2: 'MX',
                  name: 'Estado de México',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.6403843518129, 19.461622407120934],
                      [-98.64469459675611, 19.02255742496971],
                      [-98.81710439448446, 18.974534692546918],
                      [-98.96796296749679, 19.08773113325778],
                      [-98.95503223266715, 19.26267108708366],
                      [-99.1231317854523, 19.57138865265874],
                      [-99.33002354272634, 19.296973038814222],
                      [-99.28692109329424, 19.142614256026683],
                      [-99.30847231801029, 18.93337235047024],
                      [-99.47226162585223, 18.79959473872104],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.66191240335343, 18.76186259181742],
                      [-99.7481173022176, 18.693258688356288],
                      [-100.07138567295827, 18.60750380902988],
                      [-100.2739671852891, 18.39140151312732],
                      [-100.43344624818783, 18.6452359559335],
                      [-100.45499747290387, 18.844187275970775],
                      [-100.62309702568902, 18.871628837355225],
                      [-100.15759057182245, 19.420460065044256],
                      [-100.21362375608417, 19.564528262312628],
                      [-100.12310861227678, 19.93841953617578],
                      [-99.84725293591141, 20.308880614865878],
                      [-99.71794558761513, 20.185393588635844],
                      [-99.54984603482998, 20.154521832078338],
                      [-99.38605672698804, 19.75661919200379],
                      [-99.20502643937327, 19.979581878252457],
                      [-99.01968590681528, 20.041325391367472],
                      [-98.60590239226723, 19.74289841131156],
                      [-98.65762533158573, 19.585109433350965],
                      [-98.6403843518129, 19.461622407120934],
                    ],
                  ],
                },
              },
              value: 14635740.88,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-PUE',
                  iso_a2: 'MX',
                  name: 'Puebla',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.64469459675611, 19.02255742496971],
                      [-98.6403843518129, 19.461622407120934],
                      [-98.46366430914134, 19.437611040909538],
                      [-98.35159794061789, 19.242089916045323],
                      [-98.19211887771917, 19.10488210912306],
                      [-98.04988079459328, 19.207787964314754],
                      [-97.92919393618342, 19.156335036718907],
                      [-97.8257480575464, 19.314124014679507],
                      [-97.94212467101305, 19.578249043004853],
                      [-98.14470618334387, 19.674294507850433],
                      [-98.24384181703768, 19.869815632714648],
                      [-98.10160373391179, 20.085917928617206],
                      [-98.16194716311671, 20.329461785904215],
                      [-97.99815785527477, 20.483820568691755],
                      [-97.89902222158096, 20.80625891495906],
                      [-97.77833536317111, 20.81311930530517],
                      [-97.55851287106745, 20.504401739730092],
                      [-97.7697148732847, 20.43922803144202],
                      [-97.7740251182279, 20.274578663135312],
                      [-97.54127189129461, 20.137370856213053],
                      [-97.40334405311194, 20.25742768727003],
                      [-97.1533498464058, 20.144231246559166],
                      [-97.30851866436133, 19.89039680375299],
                      [-97.3904133182823, 19.574818847831796],
                      [-97.22662401044036, 19.3381353808909],
                      [-96.98094004867745, 19.286682453295054],
                      [-97.11024739697372, 19.176916207757248],
                      [-97.26541621492925, 19.159765231891967],
                      [-97.22662401044036, 18.9127911794319],
                      [-97.33006988907738, 18.809885324240206],
                      [-97.30851866436133, 18.68296810283712],
                      [-97.12748837674656, 18.638375565587385],
                      [-96.98525029362067, 18.514888539357354],
                      [-96.79990976106268, 18.552620686260973],
                      [-96.72663559702812, 18.41198268416566],
                      [-96.79128927117625, 18.281635267589515],
                      [-97.02835274305275, 18.12384628962892],
                      [-97.31282890930454, 18.14442746066726],
                      [-97.42489527782797, 17.99006867787972],
                      [-97.63609728004522, 18.17186902205171],
                      [-97.7266124238526, 18.302216438627852],
                      [-97.92488369124021, 18.038091410302506],
                      [-98.17487789794633, 18.01751023926417],
                      [-98.3472876956747, 17.89059301786108],
                      [-98.79124292482521, 18.03466121512945],
                      [-99.03261664164492, 18.250763511032005],
                      [-99.04985762141774, 18.350239171050646],
                      [-98.80848390459805, 18.494307368319014],
                      [-98.65762533158573, 18.892210008393562],
                      [-98.64469459675611, 19.02255742496971],
                    ],
                  ],
                },
              },
              value: 18482941.52,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-MOR',
                  iso_a2: 'MX',
                  name: 'Morelos',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.64469459675611, 19.02255742496971],
                      [-98.65762533158573, 18.892210008393562],
                      [-98.80848390459805, 18.494307368319014],
                      [-99.04985762141774, 18.350239171050646],
                      [-99.14037276522514, 18.497737563492073],
                      [-99.33002354272634, 18.45314502624234],
                      [-99.49381285056828, 18.676107712491007],
                      [-99.47226162585223, 18.79959473872104],
                      [-99.30847231801029, 18.93337235047024],
                      [-99.28692109329424, 19.142614256026683],
                      [-99.04554737647454, 19.056859376700274],
                      [-98.96796296749679, 19.08773113325778],
                      [-98.81710439448446, 18.974534692546918],
                      [-98.64469459675611, 19.02255742496971],
                    ],
                  ],
                },
              },
              value: 923534.75,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-QUE',
                  iso_a2: 'MX',
                  name: 'Querétaro',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.04554737647454, 21.26933526332168],
                      [-99.04123713153133, 21.176719993649158],
                      [-99.36450550227201, 21.111546285361086],
                      [-99.48950260562506, 20.66219071769069],
                      [-99.81708122130894, 20.514692325249264],
                      [-99.84725293591141, 20.308880614865878],
                      [-100.12310861227678, 19.93841953617578],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.48085894256312, 20.435797836268964],
                      [-100.56706384142731, 20.741085206670988],
                      [-100.4722384526767, 20.95032711222743],
                      [-100.1834520414817, 20.878293013593247],
                      [-100.10586763250394, 20.916025160496865],
                      [-100.04983444824222, 21.15613882261082],
                      [-99.82570171119536, 21.15613882261082],
                      [-99.79121975164969, 21.420263850936166],
                      [-99.72225583255835, 21.516309315781747],
                      [-99.56708701460283, 21.392822289551713],
                      [-99.37743623710163, 21.43055443645533],
                      [-99.20071619443007, 21.622645366146493],
                      [-99.04554737647454, 21.26933526332168],
                    ],
                  ],
                },
              },
              value: 101330.21,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-HID',
                  iso_a2: 'MX',
                  name: 'Hidalgo',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.84725293591141, 20.308880614865878],
                      [-99.81708122130894, 20.514692325249264],
                      [-99.48950260562506, 20.66219071769069],
                      [-99.36450550227201, 21.111546285361086],
                      [-99.04123713153133, 21.176719993649158],
                      [-99.04554737647454, 21.26933526332168],
                      [-98.93779125289431, 21.28991643436002],
                      [-98.82572488437089, 21.176719993649158],
                      [-98.5929716574376, 21.21102194537972],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.41194136982283, 21.176719993649158],
                      [-98.21367010243522, 21.15270862743776],
                      [-98.13177544851425, 21.070383943284405],
                      [-98.23091108220805, 20.936606331535206],
                      [-98.39470039004999, 20.878293013593247],
                      [-98.43780283948207, 20.675911498382916],
                      [-98.57142043272155, 20.473529983172583],
                      [-98.49814626868701, 20.363763737634777],
                      [-98.33866720578827, 20.432367641095908],
                      [-98.11453446874141, 20.68963227907514],
                      [-98.0197090799908, 20.658760522517632],
                      [-97.99815785527477, 20.483820568691755],
                      [-98.16194716311671, 20.329461785904215],
                      [-98.10160373391179, 20.085917928617206],
                      [-98.24384181703768, 19.869815632714648],
                      [-98.14470618334387, 19.674294507850433],
                      [-98.33435696084507, 19.605690604389302],
                      [-98.57573067766477, 19.633132165773755],
                      [-98.65762533158573, 19.585109433350965],
                      [-98.60590239226723, 19.74289841131156],
                      [-99.01968590681528, 20.041325391367472],
                      [-99.20502643937327, 19.979581878252457],
                      [-99.38605672698804, 19.75661919200379],
                      [-99.54984603482998, 20.154521832078338],
                      [-99.71794558761513, 20.185393588635844],
                      [-99.84725293591141, 20.308880614865878],
                    ],
                  ],
                },
              },
              value: 6922845.39,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-GUA',
                  iso_a2: 'MX',
                  name: 'Guanajuato',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.79121975164969, 21.420263850936166],
                      [-99.82570171119536, 21.15613882261082],
                      [-100.04983444824222, 21.15613882261082],
                      [-100.10586763250394, 20.916025160496865],
                      [-100.1834520414817, 20.878293013593247],
                      [-100.4722384526767, 20.95032711222743],
                      [-100.56706384142731, 20.741085206670988],
                      [-100.48085894256312, 20.435797836268964],
                      [-100.28689792011872, 20.212835150020297],
                      [-100.39896428864216, 20.07219714792498],
                      [-100.39465404369895, 19.96586109756023],
                      [-100.73085314926925, 19.934989341002723],
                      [-101.01963956046424, 19.94871012169495],
                      [-101.19635960313582, 20.03446500102136],
                      [-101.42049234018268, 20.051615976886644],
                      [-101.386010380637, 20.288299443827537],
                      [-101.61014311768388, 20.319171200385043],
                      [-101.69203777160484, 20.202544564501125],
                      [-101.90755001876529, 20.202544564501125],
                      [-101.95065246819738, 20.363763737634777],
                      [-102.10151104120969, 20.387775103846174],
                      [-101.98082418279984, 20.55585466732594],
                      [-102.08427006143685, 20.727364425978763],
                      [-102.04547785694797, 20.87143262324713],
                      [-101.85582707944678, 21.149278432264705],
                      [-101.57135091319499, 21.34822975230198],
                      [-101.64031483228634, 21.516309315781747],
                      [-101.53686895364932, 21.63636614683872],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.32566695143208, 21.873049613779614],
                      [-101.26101327728395, 21.77357395376098],
                      [-100.96360637620253, 21.749562587549583],
                      [-100.62740727063223, 21.49229794957035],
                      [-100.49809992233597, 21.516309315781747],
                      [-100.40327453358536, 21.6775284889154],
                      [-99.79121975164969, 21.420263850936166],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-SLP',
                  iso_a2: 'MX',
                  name: 'San Luis Potosí',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-100.82998878296306, 24.565752824628927],
                      [-100.6101662908594, 24.2844768204383],
                      [-100.57999457625692, 23.931166717613486],
                      [-100.48516918750633, 23.821400472075677],
                      [-100.43775649313103, 23.22797670713691],
                      [-100.05414469318544, 23.241697487829136],
                      [-99.91621685500274, 22.956991288465453],
                      [-99.98518077409409, 22.775190944293463],
                      [-99.5541562797732, 22.620832161505923],
                      [-99.37743623710163, 22.686005869793995],
                      [-99.24812888880537, 22.459612988372267],
                      [-98.93779125289431, 22.373858109045855],
                      [-98.61452288215365, 22.41845064629559],
                      [-98.37314916533394, 22.26409186350805],
                      [-98.48952577880058, 21.75299278272264],
                      [-98.6403843518129, 21.608924585454268],
                      [-98.51107700351663, 21.399682679897825],
                      [-98.5929716574376, 21.21102194537972],
                      [-98.82572488437089, 21.176719993649158],
                      [-98.93779125289431, 21.28991643436002],
                      [-99.04554737647454, 21.26933526332168],
                      [-99.20071619443007, 21.622645366146493],
                      [-99.37743623710163, 21.43055443645533],
                      [-99.56708701460283, 21.392822289551713],
                      [-99.72225583255835, 21.516309315781747],
                      [-99.79121975164969, 21.420263850936166],
                      [-100.40327453358536, 21.6775284889154],
                      [-100.49809992233597, 21.516309315781747],
                      [-100.62740727063223, 21.49229794957035],
                      [-100.96360637620253, 21.749562587549583],
                      [-101.26101327728395, 21.77357395376098],
                      [-101.32566695143208, 21.873049613779614],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.32135670648887, 22.09944249520134],
                      [-101.38170013569379, 22.36013732835363],
                      [-101.29980548177282, 22.48019415941061],
                      [-101.35152842109133, 22.589960404948414],
                      [-101.51100748399007, 22.61054157598675],
                      [-101.63169434239992, 22.49734513527589],
                      [-101.83427585473073, 22.48019415941061],
                      [-101.95065246819738, 22.648273722890373],
                      [-102.11875202098253, 22.754609773255122],
                      [-102.24805936927879, 22.984432849849902],
                      [-102.252369614222, 23.186814365060236],
                      [-102.18771594007387, 23.406346856135848],
                      [-102.07564957155044, 23.35489392854],
                      [-101.82996560978754, 23.581286809961725],
                      [-101.24808254245431, 23.992910230728498],
                      [-100.993778090805, 24.37023169976471],
                      [-100.82998878296306, 24.565752824628927],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-ZAC',
                  iso_a2: 'MX',
                  name: 'Zacatecas',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-100.82998878296306, 24.565752824628927],
                      [-100.993778090805, 24.37023169976471],
                      [-101.24808254245431, 23.992910230728498],
                      [-101.82996560978754, 23.581286809961725],
                      [-102.07564957155044, 23.35489392854],
                      [-102.18771594007387, 23.406346856135848],
                      [-102.252369614222, 23.186814365060236],
                      [-102.24805936927879, 22.984432849849902],
                      [-102.11875202098253, 22.754609773255122],
                      [-101.95065246819738, 22.648273722890373],
                      [-101.83427585473073, 22.48019415941061],
                      [-101.63169434239992, 22.49734513527589],
                      [-101.51100748399007, 22.61054157598675],
                      [-101.35152842109133, 22.589960404948414],
                      [-101.29980548177282, 22.48019415941061],
                      [-101.38170013569379, 22.36013732835363],
                      [-101.32135670648887, 22.09944249520134],
                      [-101.51962797387648, 21.842177857222108],
                      [-101.84720658956036, 22.01711781104799],
                      [-101.98082418279984, 22.123453861412735],
                      [-101.98513442774305, 22.250371082815825],
                      [-102.3471950029726, 22.394439280084196],
                      [-102.64460190405401, 22.212638935912203],
                      [-102.84287317144164, 21.931362931721573],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.77821949729349, 21.608924585454268],
                      [-102.64029165911082, 21.567762243377594],
                      [-102.6833941085429, 21.399682679897825],
                      [-102.91183709053297, 21.283056044013907],
                      [-103.05407517365887, 21.265905068148626],
                      [-103.04545468377245, 21.073814138457465],
                      [-103.23079521633043, 21.080674528803577],
                      [-103.59285579156, 21.19387096951444],
                      [-103.7437143645723, 21.296776824706132],
                      [-103.66612995559454, 21.488867754397294],
                      [-103.51958162752544, 21.602064195108156],
                      [-103.52389187246865, 21.818166491010714],
                      [-103.28682840059216, 21.98624605449048],
                      [-103.15752105229589, 21.996536640009648],
                      [-103.04545468377245, 22.25380127798888],
                      [-103.37303329945634, 22.51449611114117],
                      [-103.36010256462671, 22.349846742834462],
                      [-103.48940991292298, 22.133744446931907],
                      [-103.67906069042417, 22.137174642104963],
                      [-103.68337093536738, 22.32240518145001],
                      [-103.61009677133282, 22.524786696660342],
                      [-103.85147048815253, 22.565949038737017],
                      [-103.77819632411797, 22.73745879738984],
                      [-103.9807778364488, 22.771760749120403],
                      [-103.94629587690312, 22.377288304218915],
                      [-104.32990767684872, 22.26409186350805],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.20922081843887, 22.644843527717317],
                      [-104.18766959372283, 23.118210461599105],
                      [-104.11008518474506, 23.437218612693357],
                      [-103.94198563195991, 23.5675660292695],
                      [-103.85147048815253, 23.852272228633186],
                      [-103.8385397533229, 24.085525500401026],
                      [-103.67044020053775, 24.164419989381322],
                      [-103.51527138258223, 24.3393599432072],
                      [-103.24803619610327, 24.490288530821687],
                      [-102.79977072200954, 24.40796384666833],
                      [-102.49374333104171, 24.473137554956402],
                      [-102.49374333104171, 24.82301746260816],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.5842584748491, 25.124874637837127],
                      [-102.17478520524425, 25.16260678474075],
                      [-101.86013732439, 25.076851905414337],
                      [-101.7653119356394, 24.93964409849208],
                      [-101.58859189296783, 24.884760975723175],
                      [-101.46359478961477, 24.750983363973972],
                      [-101.19635960313582, 24.799006096396766],
                      [-101.09722396944201, 24.641217118436167],
                      [-100.82998878296306, 24.565752824628927],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-AGU',
                  iso_a2: 'MX',
                  name: 'Aguascalientes',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-101.84720658956036, 22.01711781104799],
                      [-102.23081838950597, 21.6775284889154],
                      [-102.76097851752067, 21.749562587549583],
                      [-102.84287317144164, 21.931362931721573],
                      [-102.64460190405401, 22.212638935912203],
                      [-102.3471950029726, 22.394439280084196],
                      [-101.98513442774305, 22.250371082815825],
                      [-101.98082418279984, 22.123453861412735],
                      [-101.84720658956036, 22.01711781104799],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-DUR',
                  iso_a2: 'MX',
                  name: 'Durango',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-105.39022793287813, 23.032455582272696],
                      [-105.68763483395955, 23.296580610598042],
                      [-105.7134963036188, 23.464660174077807],
                      [-105.89883683617678, 23.715064421710927],
                      [-105.94624953055208, 24.075234914881854],
                      [-106.05400565413231, 24.2844768204383],
                      [-106.19193349231499, 24.387382675629993],
                      [-106.40313549453224, 24.287907015611353],
                      [-106.59278627203342, 24.37023169976471],
                      [-106.75657557987537, 24.702960631551186],
                      [-107.03674150118394, 24.922493122626797],
                      [-107.12725664499133, 25.190048346125202],
                      [-107.09708493038887, 25.419871422719982],
                      [-106.93760586749013, 25.64283410896865],
                      [-106.7220936203297, 25.63254352344948],
                      [-106.54537357765813, 25.78004191589091],
                      [-106.52382235294209, 25.99271401662041],
                      [-106.37727402487297, 26.129921823542666],
                      [-106.39882524958902, 26.383756266348843],
                      [-106.23072569680387, 26.428348803598578],
                      [-106.22641545186066, 26.558696220174724],
                      [-106.02814418447305, 26.83997222436535],
                      [-105.80832169236939, 26.692473831923923],
                      [-105.67901434407312, 26.69933422227004],
                      [-105.55832748566328, 26.57241700086695],
                      [-105.3298845036732, 26.459220560156083],
                      [-105.11868250145596, 26.55183582982861],
                      [-104.83420633520417, 26.486662121540537],
                      [-104.59714286332768, 26.349454314618278],
                      [-104.51955845434992, 26.37003548565662],
                      [-104.23508228809813, 26.723345588481433],
                      [-103.94198563195991, 26.761077735385054],
                      [-103.62733775110567, 26.641020904328077],
                      [-103.32562060508104, 26.407767632560237],
                      [-103.28251815564894, 26.26369943529187],
                      [-103.34286158485386, 26.12649162836961],
                      [-103.31700011519462, 25.697717231737556],
                      [-103.48940991292298, 25.539928253776957],
                      [-103.42475623877485, 25.426731813066095],
                      [-103.50665089269582, 25.299814591663008],
                      [-103.27389766576253, 25.07342171024128],
                      [-103.25234644104648, 24.922493122626797],
                      [-102.84287317144164, 24.730402192935635],
                      [-102.81701170178238, 24.905342146761512],
                      [-102.66615312877006, 25.076851905414337],
                      [-102.49374333104171, 24.82301746260816],
                      [-102.49374333104171, 24.473137554956402],
                      [-102.79977072200954, 24.40796384666833],
                      [-103.24803619610327, 24.490288530821687],
                      [-103.51527138258223, 24.3393599432072],
                      [-103.67044020053775, 24.164419989381322],
                      [-103.8385397533229, 24.085525500401026],
                      [-103.85147048815253, 23.852272228633186],
                      [-103.94198563195991, 23.5675660292695],
                      [-104.11008518474506, 23.437218612693357],
                      [-104.18766959372283, 23.118210461599105],
                      [-104.20922081843887, 22.644843527717317],
                      [-104.31266669707588, 22.318974986276956],
                      [-104.33421792179193, 22.47676396423755],
                      [-104.58852237344126, 22.459612988372267],
                      [-104.66610678241902, 22.624262356678976],
                      [-104.77386290599924, 22.675715284274823],
                      [-104.97213417338686, 22.541937672525624],
                      [-104.9936853981029, 22.675715284274823],
                      [-104.88592927452268, 22.788911724985688],
                      [-104.9462727037276, 22.915828946388775],
                      [-105.13161323628559, 23.015304606407412],
                      [-105.39022793287813, 23.032455582272696],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-TLA',
                  iso_a2: 'MX',
                  name: 'Tlaxcala',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-98.65762533158573, 19.585109433350965],
                      [-98.57573067766477, 19.633132165773755],
                      [-98.33435696084507, 19.605690604389302],
                      [-98.14470618334387, 19.674294507850433],
                      [-97.94212467101305, 19.578249043004853],
                      [-97.8257480575464, 19.314124014679507],
                      [-97.92919393618342, 19.156335036718907],
                      [-98.04988079459328, 19.207787964314754],
                      [-98.19211887771917, 19.10488210912306],
                      [-98.35159794061789, 19.242089916045323],
                      [-98.46366430914134, 19.437611040909538],
                      [-98.6403843518129, 19.461622407120934],
                      [-98.65762533158573, 19.585109433350965],
                    ],
                  ],
                },
              },
              value: 0,
            },
            {
              feature: {
                type: 'Feature',
                properties: {
                  iso_3166_2: 'MX-CMX',
                  iso_a2: 'MX',
                  name: 'Ciudad de México',
                },
                geometry: {
                  type: 'Polygon',
                  coordinates: [
                    [
                      [-99.28692109329424, 19.142614256026683],
                      [-99.33002354272634, 19.296973038814222],
                      [-99.1231317854523, 19.57138865265874],
                      [-98.95503223266715, 19.26267108708366],
                      [-98.96796296749679, 19.08773113325778],
                      [-99.04554737647454, 19.056859376700274],
                      [-99.28692109329424, 19.142614256026683],
                    ],
                  ],
                },
              },
              value: 37879092.81,
            },
          ],
          xAxisID: 'projection',
          yAxisID: 'projection',
          vAxisID: 'color',
          rAxisID: 'color',
          iAxisID: 'projection',
        },
      ],
      legends: [
        {
          color: 'hsl(320, 100%, 17%)',
          label: 'Ciudad de México',
        },
        {
          color: 'hsl(321, 100%, 57%)',
          label: 'Puebla',
        },
        {
          color: 'hsl(321, 100%, 66%)',
          label: 'Estado de México',
        },
        {
          color: 'hsl(321, 100%, 80%)',
          label: 'Michoacán',
        },
        {
          color: 'hsl(321, 100%, 82%)',
          label: 'Hidalgo',
        },
        {
          color: 'hsl(321, 100%, 82%)',
          label: 'Jalisco',
        },
        {
          color: 'hsl(321, 100%, 83%)',
          label: 'Tabasco',
        },
        {
          color: 'hsl(321, 100%, 94%)',
          label: 'Morelos',
        },
        {
          color: 'hsl(321, 100%, 95%)',
          label: 'Baja California Sur',
        },
        {
          color: 'hsl(321, 100%, 96%)',
          label: 'Querétaro',
        },
      ],
    },
    options: {
      scales: {
        y: {
          axis: 'y',
          title: {
            text: 'Net loan Value',
            display: false,
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          display: false,
          offset: false,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          id: 'y',
          position: 'left',
        },
        projection: {
          axis: 'x',
          projection: 'mercator',
          projectionScale: 2.1,
          projectionOffset: [900, 150],
          type: 'projection',
          position: 'chartArea',
          display: false,
          padding: 0,
          offset: false,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          id: 'projection',
        },
        color: {
          axis: 'x',
          display: false,
          type: 'color',
          ticks: {
            z: 1,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          position: 'chartArea',
          property: 'value',
          grid: {
            z: 1,
            drawOnChartArea: false,
            display: true,
            lineWidth: 1,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          legend: {
            align: 'right',
            position: 'bottom-right',
            length: 100,
            width: 50,
            margin: 8,
            indicatorWidth: 10,
          },
          missing: 'transparent',
          quantize: 0,
          offset: false,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          id: 'color',
        },
      },
      indexAxis: null,
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legendCustom: {
          containerID: 'legendCustom-5',
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          padding: 0,
          hideZeros: false,
        },
      },
    },
  },
  {
    title: 'CONCENTRATION PER INDUSTRY',
    subtitle: 'The concentration of the top 10 clients is presented below.',
    type: 'bar',
    size: 'large',
    icon: null,
    data: {
      labels: [
        'Comercio al por mayor',
        'Servicios de apoyo a los negocios y manejo de residuos, y servicios de remediación',
        'Industrias manufactureras',
        'Transportes, correos y almacenamiento',
        'Construcción',
        'Otros servicios excepto actividades gubernamentales',
        'Servicios profesionales, científicos y técnicos',
        'Agricultura, cría y explotación de animales, aprovechamiento forestal, pesca y caza',
        'Comercio al por menor',
        'Servicios inmobiliarios y de alquiler de bienes muebles e intangibles',
      ],
      datasets: [
        {
          label: 'Comercio al por mayor',
          data: [29887210.55, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['29.91%'],
          },
          grouped: false,
          backgroundColor: '#330022',
          borderRadius: 8,
        },
        {
          label:
            'Servicios de apoyo a los negocios y manejo de residuos, y servicios de remediación',
          data: [0, 14559623.84, 0, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['14.57%'],
          },
          grouped: false,
          backgroundColor: '#5B003D',
          borderRadius: 8,
        },
        {
          label: 'Industrias manufactureras',
          data: [0, 0, 12814498.9, 0, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['12.83%'],
          },
          grouped: false,
          backgroundColor: '#830258',
          borderRadius: 8,
        },
        {
          label: 'Transportes, correos y almacenamiento',
          data: [0, 0, 0, 12610120.54, 0, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['12.62%'],
          },
          grouped: false,
          backgroundColor: '#AA0372',
          borderRadius: 8,
        },
        {
          label: 'Construcción',
          data: [0, 0, 0, 0, 11147329.32, 0, 0, 0, 0, 0],
          tooltip: {
            muted: ['11.16%'],
          },
          grouped: false,
          backgroundColor: '#D1058D',
          borderRadius: 8,
        },
        {
          label: 'Otros servicios excepto actividades gubernamentales',
          data: [0, 0, 0, 0, 0, 6255836.92, 0, 0, 0, 0],
          tooltip: {
            muted: ['6.26%'],
          },
          grouped: false,
          backgroundColor: '#F609A7',
          borderRadius: 8,
        },
        {
          label: 'Servicios profesionales, científicos y técnicos',
          data: [0, 0, 0, 0, 0, 0, 6142265.39, 0, 0, 0],
          tooltip: {
            muted: ['6.15%'],
          },
          grouped: false,
          backgroundColor: '#F736B7',
          borderRadius: 8,
        },
        {
          label:
            'Agricultura, cría y explotación de animales, aprovechamiento forestal, pesca y caza',
          data: [0, 0, 0, 0, 0, 0, 0, 2669706.04, 0, 0],
          tooltip: {
            muted: ['2.67%'],
          },
          grouped: false,
          backgroundColor: '#F75EC4',
          borderRadius: 8,
        },
        {
          label: 'Comercio al por menor',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 1790251.29, 0],
          tooltip: {
            muted: ['1.79%'],
          },
          grouped: false,
          backgroundColor: '#F986D2',
          borderRadius: 8,
        },
        {
          label:
            'Servicios inmobiliarios y de alquiler de bienes muebles e intangibles',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 1205819.02],
          tooltip: {
            muted: ['1.21%'],
          },
          grouped: false,
          backgroundColor: '#FAAEE0',
          borderRadius: 8,
        },
      ],
    },
    options: {
      scales: {
        y: {
          axis: 'y',
          title: {
            text: 'Net loan Value',
            display: true,
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          display: true,
          stacked: false,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            color: ['#3f3f46'],
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
          },
          type: 'linear',
          beginAtZero: true,
          offset: false,
          reverse: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'y',
          position: 'left',
        },
        x: {
          axis: 'x',
          display: true,
          stacked: false,
          grid: {
            display: true,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            maxRotation: 0,
            minRotation: 0,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          type: 'category',
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'x',
          position: 'bottom',
        },
        percentage: {
          axis: 'x',
          display: false,
          type: 'linear',
          position: 'top',
          max: 100,
          ticks: {
            maxTicksLimit: 3,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          grid: {
            display: false,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          id: 'percentage',
        },
      },
      indexAxis: 'x',
      responsive: true,
      elements: {
        point: {
          backgroundColor: 'white',
        },
      },
      plugins: {
        legendCustom: {
          containerID: 'legendCustom-6',
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          padding: 0,
          hideZeros: false,
        },
      },
      maintainAspectRatio: false,
    },
  },
  {
    title: 'CONCENTRATION PER TYPE OF ASSET',
    subtitle: '',
    type: 'bar',
    size: 'medium',
    icon: null,
    data: {
      labels: ['Arrendamiento Puro', 'Crédito Simple'],
      datasets: [
        {
          label: 'Arrendamiento Puro',
          data: [81839873.21, 0],
          tooltip: {
            muted: ['81.91%'],
          },
          grouped: false,
          backgroundColor: '#330022',
          borderRadius: 8,
        },
        {
          label: 'Crédito Simple',
          data: [0, 18078115.84],
          tooltip: {
            muted: ['18.09%'],
          },
          grouped: false,
          backgroundColor: '#F609A7',
          borderRadius: 8,
        },
      ],
    },
    options: {
      scales: {
        y: {
          axis: 'y',
          title: {
            text: 'Net loan Value',
            display: true,
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          display: true,
          stacked: false,
          grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            offset: false,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            color: ['#3f3f46'],
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
          },
          type: 'linear',
          beginAtZero: true,
          offset: false,
          reverse: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'y',
          position: 'left',
        },
        x: {
          axis: 'x',
          display: true,
          stacked: false,
          grid: {
            display: true,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          ticks: {
            display: true,
            maxRotation: 0,
            minRotation: 0,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          type: 'category',
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          id: 'x',
          position: 'bottom',
        },
        percentage: {
          axis: 'x',
          display: false,
          type: 'linear',
          position: 'top',
          max: 100,
          ticks: {
            maxTicksLimit: 3,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2,
            color: '#666',
          },
          grid: {
            display: false,
            offset: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            color: 'rgba(0,0,0,0.1)',
          },
          offset: true,
          reverse: false,
          beginAtZero: false,
          bounds: 'ticks',
          clip: true,
          grace: 0,
          border: {
            display: true,
            dash: [],
            dashOffset: 0,
            width: 1,
            color: 'rgba(0,0,0,0.1)',
          },
          title: {
            display: false,
            text: '',
            padding: {
              top: 4,
              bottom: 4,
            },
            color: '#666',
          },
          id: 'percentage',
        },
      },
      indexAxis: 'x',
      responsive: true,
      elements: {
        point: {
          backgroundColor: 'white',
        },
      },
      plugins: {
        legendCustom: {
          containerID: 'legendCustom-7',
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          padding: 0,
          hideZeros: false,
        },
      },
      maintainAspectRatio: false,
    },
  },
];
